var tokens_module = {
  "ACCESSORY_BACKGROUND_LIGHT_MODE_COLOR": "#000000",
  "ACCESSORY_BACKGROUND_DARK_MODE_COLOR": "#ffffff",
  "ACCESSORY_BACKGROUND_RADIUS": 6,
  "ACCESSORY_BACKGROUND_COLOR": "#000000",
  "ACCESSORY_MEDIUM_SIZE_HEIGHT": 40,
  "ACCESSORY_MEDIUM_SIZE_WIDTH": 40,
  "ACCESSORY_LARGE_SIZE_HEIGHT": 64,
  "ACCESSORY_LARGE_SIZE_WIDTH": 64,
  "ACCESSORY_ICON_VARIANT_LIGHT_MODE_COLOR": "#000000",
  "ACCESSORY_ICON_VARIANT_DARK_MODE_COLOR": "#ffffff",
  "ACCESSORY_ICON_VARIANT_SIZE": 24,
  "ACCESSORY_ICON_VARIANT_BORDER_RADIUS": 3,
  "ACCESSORY_ICON_VARIANT_MEDIUM_SIZE_HEIGHT": 24,
  "ACCESSORY_ICON_VARIANT_MEDIUM_SIZE_WIDTH": 24,
  "ACCESSORY_ICON_VARIANT_LARGE_SIZE_HEIGHT": 40,
  "ACCESSORY_ICON_VARIANT_LARGE_SIZE_WIDTH": 40,
  "ACCESSORY_ICON_VARIANT_COLOR": "#000000",
  "ACCESSORY_IMAGE_VARIANT_SIZE": 40,
  "ACCESSORY_IMAGE_VARIANT_BORDER_RADIUS": 5,
  "ACCESSORY_INITIALS_VARIANT_LIGHT_MODE_COLOR": "#000000",
  "ACCESSORY_INITIALS_VARIANT_DARK_MODE_COLOR": "#ffffff",
  "ACCESSORY_INITIALS_VARIANT_MEDIUM_SIZE_TEXT_SIZE": 16,
  "ACCESSORY_INITIALS_VARIANT_MEDIUM_SIZE_TEXT_LEADING": 24,
  "ACCESSORY_INITIALS_VARIANT_MEDIUM_SIZE_TEXT_TRACKING": 0,
  "ACCESSORY_INITIALS_VARIANT_MEDIUM_SIZE_TEXT_WEIGHT": 600,
  "ACCESSORY_INITIALS_VARIANT_MEDIUM_SIZE_TEXT_CASE": "regular",
  "ACCESSORY_INITIALS_VARIANT_MEDIUM_SIZE_TEXT_NUMBER_SPACING": "default",
  "ACCESSORY_INITIALS_VARIANT_MEDIUM_SIZE_TEXT_SCALE": "paragraph-30",
  "ACCESSORY_INITIALS_VARIANT_MEDIUM_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
  "ACCESSORY_INITIALS_VARIANT_LARGE_SIZE_TEXT_SIZE": 32,
  "ACCESSORY_INITIALS_VARIANT_LARGE_SIZE_TEXT_LEADING": 40,
  "ACCESSORY_INITIALS_VARIANT_LARGE_SIZE_TEXT_TRACKING": 0,
  "ACCESSORY_INITIALS_VARIANT_LARGE_SIZE_TEXT_WEIGHT": 700,
  "ACCESSORY_INITIALS_VARIANT_LARGE_SIZE_TEXT_CASE": "regular",
  "ACCESSORY_INITIALS_VARIANT_LARGE_SIZE_TEXT_NUMBER_SPACING": "default",
  "ACCESSORY_INITIALS_VARIANT_LARGE_SIZE_TEXT_SCALE": "heading-30",
  "ACCESSORY_INITIALS_VARIANT_LARGE_SIZE_TEXT_FONT_FAMILY": "Square Sans Display",
  "ACCESSORY_INITIALS_VARIANT_COLOR": "#000000",
  "ACCORDION_DISABLED_STATE_CONTENT_LIGHT_MODE_COLOR": "#000000",
  "ACCORDION_DISABLED_STATE_CONTENT_DARK_MODE_COLOR": "#ffffff",
  "ACCORDION_DISABLED_STATE_CONTENT_COLOR": "#000000",
  "ACCORDION_DISABLED_STATE_ACCESSORY_OPACITY": 0.5,
  "ACCORDION_DISABLED_STATE_SIDE_TEXT_LIGHT_MODE_COLOR": "#000000",
  "ACCORDION_DISABLED_STATE_SIDE_TEXT_DARK_MODE_COLOR": "#ffffff",
  "ACCORDION_DISABLED_STATE_SIDE_TEXT_COLOR": "#000000",
  "ACCORDION_FOCUS_STATE_CONTENT_LIGHT_MODE_COLOR": "#005ad9",
  "ACCORDION_FOCUS_STATE_CONTENT_DARK_MODE_COLOR": "#4a95ff",
  "ACCORDION_FOCUS_STATE_CONTENT_COLOR": "#005ad9",
  "ACCORDION_FOCUS_STATE_ACCESSORY_OPACITY": 1,
  "ACCORDION_FOCUS_STATE_SIDE_TEXT_LIGHT_MODE_COLOR": "#000000",
  "ACCORDION_FOCUS_STATE_SIDE_TEXT_DARK_MODE_COLOR": "#ffffff",
  "ACCORDION_FOCUS_STATE_SIDE_TEXT_COLOR": "#000000",
  "ACCORDION_HOVER_STATE_CONTENT_LIGHT_MODE_COLOR": "#005ad9",
  "ACCORDION_HOVER_STATE_CONTENT_DARK_MODE_COLOR": "#4a95ff",
  "ACCORDION_HOVER_STATE_CONTENT_COLOR": "#005ad9",
  "ACCORDION_HOVER_STATE_ACCESSORY_OPACITY": 1,
  "ACCORDION_HOVER_STATE_SIDE_TEXT_LIGHT_MODE_COLOR": "#000000",
  "ACCORDION_HOVER_STATE_SIDE_TEXT_DARK_MODE_COLOR": "#ffffff",
  "ACCORDION_HOVER_STATE_SIDE_TEXT_COLOR": "#000000",
  "ACCORDION_NORMAL_STATE_CONTENT_LIGHT_MODE_COLOR": "#000000",
  "ACCORDION_NORMAL_STATE_CONTENT_DARK_MODE_COLOR": "#ffffff",
  "ACCORDION_NORMAL_STATE_CONTENT_COLOR": "#000000",
  "ACCORDION_NORMAL_STATE_ACCESSORY_OPACITY": 1,
  "ACCORDION_NORMAL_STATE_SIDE_TEXT_LIGHT_MODE_COLOR": "#000000",
  "ACCORDION_NORMAL_STATE_SIDE_TEXT_DARK_MODE_COLOR": "#ffffff",
  "ACCORDION_NORMAL_STATE_SIDE_TEXT_COLOR": "#000000",
  "ACCORDION_PRESSED_STATE_CONTENT_LIGHT_MODE_COLOR": "#005ad9",
  "ACCORDION_PRESSED_STATE_CONTENT_DARK_MODE_COLOR": "#4a95ff",
  "ACCORDION_PRESSED_STATE_CONTENT_COLOR": "#005ad9",
  "ACCORDION_PRESSED_STATE_ACCESSORY_OPACITY": 1,
  "ACCORDION_PRESSED_STATE_SIDE_TEXT_LIGHT_MODE_COLOR": "#000000",
  "ACCORDION_PRESSED_STATE_SIDE_TEXT_DARK_MODE_COLOR": "#ffffff",
  "ACCORDION_PRESSED_STATE_SIDE_TEXT_COLOR": "#000000",
  "ACCORDION_HEADING_10_VARIANT_CONTENT_SPACING": 16,
  "ACCORDION_HEADING_10_VARIANT_SEPARATOR_LIGHT_MODE_COLOR": "#000000",
  "ACCORDION_HEADING_10_VARIANT_SEPARATOR_DARK_MODE_COLOR": "#ffffff",
  "ACCORDION_HEADING_10_VARIANT_SEPARATOR_SIZE": 1,
  "ACCORDION_HEADING_10_VARIANT_SEPARATOR_COLOR": "#000000",
  "ACCORDION_HEADING_10_VARIANT_HORIZONTAL_PADDING": 0,
  "ACCORDION_HEADING_10_VARIANT_TEXT_SIZE": 14,
  "ACCORDION_HEADING_10_VARIANT_TEXT_LEADING": 22,
  "ACCORDION_HEADING_10_VARIANT_TEXT_TRACKING": 0,
  "ACCORDION_HEADING_10_VARIANT_TEXT_WEIGHT": 700,
  "ACCORDION_HEADING_10_VARIANT_TEXT_CASE": "regular",
  "ACCORDION_HEADING_10_VARIANT_TEXT_NUMBER_SPACING": "default",
  "ACCORDION_HEADING_10_VARIANT_TEXT_SCALE": "heading-10",
  "ACCORDION_HEADING_10_VARIANT_TEXT_FONT_FAMILY": "Square Sans Text",
  "ACCORDION_HEADING_10_VARIANT_TEXT_IS_HEADER": true,
  "ACCORDION_HEADING_10_VARIANT_SIDE_TEXT_SIZE": 16,
  "ACCORDION_HEADING_10_VARIANT_SIDE_TEXT_LEADING": 24,
  "ACCORDION_HEADING_10_VARIANT_SIDE_TEXT_TRACKING": 0,
  "ACCORDION_HEADING_10_VARIANT_SIDE_TEXT_WEIGHT": 400,
  "ACCORDION_HEADING_10_VARIANT_SIDE_TEXT_CASE": "regular",
  "ACCORDION_HEADING_10_VARIANT_SIDE_TEXT_NUMBER_SPACING": "default",
  "ACCORDION_HEADING_10_VARIANT_SIDE_TEXT_SCALE": "paragraph-30",
  "ACCORDION_HEADING_10_VARIANT_SIDE_TEXT_FONT_FAMILY": "Square Sans Text",
  "ACCORDION_HEADING_10_VARIANT_VERTICAL_PADDING": 13,
  "ACCORDION_HEADING_10_VARIANT_EXPANDED_PHASE_ICON_ASSET": "chevron-down",
  "ACCORDION_HEADING_10_VARIANT_EXPANDED_PHASE_ICON_WIDTH": 16,
  "ACCORDION_HEADING_10_VARIANT_EXPANDED_PHASE_ICON_HEIGHT": 16,
  "ACCORDION_HEADING_10_VARIANT_EXPANDED_PHASE_ICON_TINTABLE": true,
  "ACCORDION_HEADING_10_VARIANT_COLLAPSED_PHASE_ICON_ASSET": "chevron-up",
  "ACCORDION_HEADING_10_VARIANT_COLLAPSED_PHASE_ICON_WIDTH": 16,
  "ACCORDION_HEADING_10_VARIANT_COLLAPSED_PHASE_ICON_HEIGHT": 16,
  "ACCORDION_HEADING_10_VARIANT_COLLAPSED_PHASE_ICON_TINTABLE": true,
  "ACCORDION_HEADING_20_VARIANT_CONTENT_SPACING": 16,
  "ACCORDION_HEADING_20_VARIANT_SEPARATOR_LIGHT_MODE_COLOR": "#000000",
  "ACCORDION_HEADING_20_VARIANT_SEPARATOR_DARK_MODE_COLOR": "#ffffff",
  "ACCORDION_HEADING_20_VARIANT_SEPARATOR_SIZE": 1,
  "ACCORDION_HEADING_20_VARIANT_SEPARATOR_COLOR": "#000000",
  "ACCORDION_HEADING_20_VARIANT_HORIZONTAL_PADDING": 0,
  "ACCORDION_HEADING_20_VARIANT_TEXT_SIZE": 19,
  "ACCORDION_HEADING_20_VARIANT_TEXT_LEADING": 26,
  "ACCORDION_HEADING_20_VARIANT_TEXT_TRACKING": 0,
  "ACCORDION_HEADING_20_VARIANT_TEXT_WEIGHT": 700,
  "ACCORDION_HEADING_20_VARIANT_TEXT_CASE": "regular",
  "ACCORDION_HEADING_20_VARIANT_TEXT_NUMBER_SPACING": "default",
  "ACCORDION_HEADING_20_VARIANT_TEXT_SCALE": "heading-20",
  "ACCORDION_HEADING_20_VARIANT_TEXT_FONT_FAMILY": "Square Sans Display",
  "ACCORDION_HEADING_20_VARIANT_TEXT_IS_HEADER": true,
  "ACCORDION_HEADING_20_VARIANT_SIDE_TEXT_SIZE": 14,
  "ACCORDION_HEADING_20_VARIANT_SIDE_TEXT_LEADING": 22,
  "ACCORDION_HEADING_20_VARIANT_SIDE_TEXT_TRACKING": 0,
  "ACCORDION_HEADING_20_VARIANT_SIDE_TEXT_WEIGHT": 400,
  "ACCORDION_HEADING_20_VARIANT_SIDE_TEXT_CASE": "regular",
  "ACCORDION_HEADING_20_VARIANT_SIDE_TEXT_NUMBER_SPACING": "default",
  "ACCORDION_HEADING_20_VARIANT_SIDE_TEXT_SCALE": "paragraph-20",
  "ACCORDION_HEADING_20_VARIANT_SIDE_TEXT_FONT_FAMILY": "Square Sans Text",
  "ACCORDION_HEADING_20_VARIANT_VERTICAL_PADDING": 19,
  "ACCORDION_HEADING_20_VARIANT_EXPANDED_PHASE_ICON_ASSET": "chevron-down",
  "ACCORDION_HEADING_20_VARIANT_EXPANDED_PHASE_ICON_WIDTH": 16,
  "ACCORDION_HEADING_20_VARIANT_EXPANDED_PHASE_ICON_HEIGHT": 16,
  "ACCORDION_HEADING_20_VARIANT_EXPANDED_PHASE_ICON_TINTABLE": true,
  "ACCORDION_HEADING_20_VARIANT_COLLAPSED_PHASE_ICON_ASSET": "chevron-up",
  "ACCORDION_HEADING_20_VARIANT_COLLAPSED_PHASE_ICON_WIDTH": 16,
  "ACCORDION_HEADING_20_VARIANT_COLLAPSED_PHASE_ICON_HEIGHT": 16,
  "ACCORDION_HEADING_20_VARIANT_COLLAPSED_PHASE_ICON_TINTABLE": true,
  "ACCORDION_HEADING_30_VARIANT_CONTENT_SPACING": 16,
  "ACCORDION_HEADING_30_VARIANT_HORIZONTAL_PADDING": 0,
  "ACCORDION_HEADING_30_VARIANT_SEPARATOR_LIGHT_MODE_COLOR": "#000000",
  "ACCORDION_HEADING_30_VARIANT_SEPARATOR_DARK_MODE_COLOR": "#ffffff",
  "ACCORDION_HEADING_30_VARIANT_SEPARATOR_SIZE": 1,
  "ACCORDION_HEADING_30_VARIANT_SEPARATOR_COLOR": "#000000",
  "ACCORDION_HEADING_30_VARIANT_TEXT_SIZE": 25,
  "ACCORDION_HEADING_30_VARIANT_TEXT_LEADING": 32,
  "ACCORDION_HEADING_30_VARIANT_TEXT_TRACKING": 0,
  "ACCORDION_HEADING_30_VARIANT_TEXT_WEIGHT": 700,
  "ACCORDION_HEADING_30_VARIANT_TEXT_CASE": "regular",
  "ACCORDION_HEADING_30_VARIANT_TEXT_NUMBER_SPACING": "default",
  "ACCORDION_HEADING_30_VARIANT_TEXT_SCALE": "heading-30",
  "ACCORDION_HEADING_30_VARIANT_TEXT_FONT_FAMILY": "Square Sans Display",
  "ACCORDION_HEADING_30_VARIANT_TEXT_IS_HEADER": true,
  "ACCORDION_HEADING_30_VARIANT_SIDE_TEXT_SIZE": 12,
  "ACCORDION_HEADING_30_VARIANT_SIDE_TEXT_LEADING": 18,
  "ACCORDION_HEADING_30_VARIANT_SIDE_TEXT_TRACKING": 0,
  "ACCORDION_HEADING_30_VARIANT_SIDE_TEXT_WEIGHT": 400,
  "ACCORDION_HEADING_30_VARIANT_SIDE_TEXT_CASE": "regular",
  "ACCORDION_HEADING_30_VARIANT_SIDE_TEXT_NUMBER_SPACING": "default",
  "ACCORDION_HEADING_30_VARIANT_SIDE_TEXT_SCALE": "paragraph-10",
  "ACCORDION_HEADING_30_VARIANT_SIDE_TEXT_FONT_FAMILY": "Square Sans Text",
  "ACCORDION_HEADING_30_VARIANT_VERTICAL_PADDING": 24,
  "ACCORDION_HEADING_30_VARIANT_EXPANDED_PHASE_ICON_16_FIDELITY_ASSET": "chevron-down",
  "ACCORDION_HEADING_30_VARIANT_EXPANDED_PHASE_ICON_16_FIDELITY_WIDTH": 16,
  "ACCORDION_HEADING_30_VARIANT_EXPANDED_PHASE_ICON_16_FIDELITY_HEIGHT": 16,
  "ACCORDION_HEADING_30_VARIANT_EXPANDED_PHASE_ICON_16_FIDELITY_TINTABLE": true,
  "ACCORDION_HEADING_30_VARIANT_EXPANDED_PHASE_ICON_ASSET": "chevron-down",
  "ACCORDION_HEADING_30_VARIANT_EXPANDED_PHASE_ICON_WIDTH": 16,
  "ACCORDION_HEADING_30_VARIANT_EXPANDED_PHASE_ICON_HEIGHT": 16,
  "ACCORDION_HEADING_30_VARIANT_EXPANDED_PHASE_ICON_TINTABLE": true,
  "ACCORDION_HEADING_30_VARIANT_COLLAPSED_PHASE_ICON_16_FIDELITY_ASSET": "chevron-up",
  "ACCORDION_HEADING_30_VARIANT_COLLAPSED_PHASE_ICON_16_FIDELITY_WIDTH": 16,
  "ACCORDION_HEADING_30_VARIANT_COLLAPSED_PHASE_ICON_16_FIDELITY_HEIGHT": 16,
  "ACCORDION_HEADING_30_VARIANT_COLLAPSED_PHASE_ICON_16_FIDELITY_TINTABLE": true,
  "ACCORDION_HEADING_30_VARIANT_COLLAPSED_PHASE_ICON_ASSET": "chevron-up",
  "ACCORDION_HEADING_30_VARIANT_COLLAPSED_PHASE_ICON_WIDTH": 16,
  "ACCORDION_HEADING_30_VARIANT_COLLAPSED_PHASE_ICON_HEIGHT": 16,
  "ACCORDION_HEADING_30_VARIANT_COLLAPSED_PHASE_ICON_TINTABLE": true,
  "ACTION_CARD_BORDER_RADIUS": 6,
  "ACTION_CARD_BORDER_HOVER_STATE_LIGHT_MODE_COLOR": "#000000",
  "ACTION_CARD_BORDER_HOVER_STATE_DARK_MODE_COLOR": "#ffffff",
  "ACTION_CARD_BORDER_HOVER_STATE_WIDTH": 1,
  "ACTION_CARD_BORDER_HOVER_STATE_COLOR": "#000000",
  "ACTION_CARD_BORDER_SELECTED_STATE_LIGHT_MODE_COLOR": "#006aff",
  "ACTION_CARD_BORDER_SELECTED_STATE_DARK_MODE_COLOR": "#006aff",
  "ACTION_CARD_BORDER_SELECTED_STATE_WIDTH": 2,
  "ACTION_CARD_BORDER_SELECTED_STATE_COLOR": "#006aff",
  "ACTION_CARD_BORDER_DISABLED_STATE_LIGHT_MODE_COLOR": "#000000",
  "ACTION_CARD_BORDER_DISABLED_STATE_DARK_MODE_COLOR": "#ffffff",
  "ACTION_CARD_BORDER_DISABLED_STATE_WIDTH": 1,
  "ACTION_CARD_BORDER_DISABLED_STATE_COLOR": "#000000",
  "ACTION_CARD_NORMAL_STATE_CONTENT_OPACITY": 1,
  "ACTION_CARD_NORMAL_STATE_UNSELECTED_VALUE_BORDER_LIGHT_MODE_COLOR": "#000000",
  "ACTION_CARD_NORMAL_STATE_UNSELECTED_VALUE_BORDER_DARK_MODE_COLOR": "#ffffff",
  "ACTION_CARD_NORMAL_STATE_UNSELECTED_VALUE_BORDER_WIDTH": 1,
  "ACTION_CARD_NORMAL_STATE_UNSELECTED_VALUE_BORDER_COLOR": "#000000",
  "ACTION_CARD_NORMAL_STATE_SELECTED_VALUE_BORDER_LIGHT_MODE_COLOR": "#006aff",
  "ACTION_CARD_NORMAL_STATE_SELECTED_VALUE_BORDER_DARK_MODE_COLOR": "#006aff",
  "ACTION_CARD_NORMAL_STATE_SELECTED_VALUE_BORDER_WIDTH": 2,
  "ACTION_CARD_NORMAL_STATE_SELECTED_VALUE_BORDER_COLOR": "#006aff",
  "ACTION_CARD_HOVER_STATE_CONTENT_OPACITY": 1,
  "ACTION_CARD_HOVER_STATE_UNSELECTED_VALUE_BORDER_LIGHT_MODE_COLOR": "#000000",
  "ACTION_CARD_HOVER_STATE_UNSELECTED_VALUE_BORDER_DARK_MODE_COLOR": "#ffffff",
  "ACTION_CARD_HOVER_STATE_UNSELECTED_VALUE_BORDER_WIDTH": 1,
  "ACTION_CARD_HOVER_STATE_UNSELECTED_VALUE_BORDER_COLOR": "#000000",
  "ACTION_CARD_HOVER_STATE_SELECTED_VALUE_BORDER_LIGHT_MODE_COLOR": "#006aff",
  "ACTION_CARD_HOVER_STATE_SELECTED_VALUE_BORDER_DARK_MODE_COLOR": "#006aff",
  "ACTION_CARD_HOVER_STATE_SELECTED_VALUE_BORDER_WIDTH": 2,
  "ACTION_CARD_HOVER_STATE_SELECTED_VALUE_BORDER_COLOR": "#006aff",
  "ACTION_CARD_ACTIVE_STATE_CONTENT_OPACITY": 1,
  "ACTION_CARD_ACTIVE_STATE_UNSELECTED_VALUE_BORDER_LIGHT_MODE_COLOR": "#006aff",
  "ACTION_CARD_ACTIVE_STATE_UNSELECTED_VALUE_BORDER_DARK_MODE_COLOR": "#006aff",
  "ACTION_CARD_ACTIVE_STATE_UNSELECTED_VALUE_BORDER_WIDTH": 1,
  "ACTION_CARD_ACTIVE_STATE_UNSELECTED_VALUE_BORDER_COLOR": "#006aff",
  "ACTION_CARD_ACTIVE_STATE_SELECTED_VALUE_BORDER_LIGHT_MODE_COLOR": "#000000",
  "ACTION_CARD_ACTIVE_STATE_SELECTED_VALUE_BORDER_DARK_MODE_COLOR": "#ffffff",
  "ACTION_CARD_ACTIVE_STATE_SELECTED_VALUE_BORDER_WIDTH": 2,
  "ACTION_CARD_ACTIVE_STATE_SELECTED_VALUE_BORDER_COLOR": "#000000",
  "ACTION_CARD_DISABLED_STATE_CONTENT_OPACITY": 0.4,
  "ACTION_CARD_DISABLED_STATE_UNSELECTED_VALUE_BORDER_LIGHT_MODE_COLOR": "#000000",
  "ACTION_CARD_DISABLED_STATE_UNSELECTED_VALUE_BORDER_DARK_MODE_COLOR": "#ffffff",
  "ACTION_CARD_DISABLED_STATE_UNSELECTED_VALUE_BORDER_WIDTH": 1,
  "ACTION_CARD_DISABLED_STATE_UNSELECTED_VALUE_BORDER_COLOR": "#000000",
  "ACTION_CARD_DISABLED_STATE_SELECTED_VALUE_BORDER_LIGHT_MODE_COLOR": "#006aff",
  "ACTION_CARD_DISABLED_STATE_SELECTED_VALUE_BORDER_DARK_MODE_COLOR": "#006aff",
  "ACTION_CARD_DISABLED_STATE_SELECTED_VALUE_BORDER_WIDTH": 2,
  "ACTION_CARD_DISABLED_STATE_SELECTED_VALUE_BORDER_COLOR": "#006aff",
  "ACTION_CARD_BACKGROUND_LIGHT_MODE_COLOR": "#ffffff",
  "ACTION_CARD_BACKGROUND_DARK_MODE_COLOR": "#141414",
  "ACTION_CARD_BACKGROUND_COLOR": "#ffffff",
  "ACTION_CARD_PADDING_HORIZONTAL_SIZE": 16,
  "ACTION_CARD_PADDING_VERTICAL_SIZE": 16,
  "ACTION_CARD_SPACING": 16,
  "ACTION_CARD_FOCUS_RING_BUFFER_SIZE": 2,
  "ACTION_CARD_FOCUS_RING_BORDER_SIZE": 2,
  "ACTION_CARD_FOCUS_RING_LIGHT_MODE_COLOR": "#006aff",
  "ACTION_CARD_FOCUS_RING_DARK_MODE_COLOR": "#006aff",
  "ACTION_CARD_FOCUS_RING_COLOR": "#006aff",
  "BANNER_BORDER_RADIUS": 6,
  "BANNER_BORDER_WIDTH": 1,
  "BANNER_DISMISS_BUTTON_NORMAL_STATE_LIGHT_MODE_COLOR": "#000000",
  "BANNER_DISMISS_BUTTON_NORMAL_STATE_DARK_MODE_COLOR": "#ffffff",
  "BANNER_DISMISS_BUTTON_NORMAL_STATE_COLOR": "#000000",
  "BANNER_DISMISS_BUTTON_PRESSED_STATE_LIGHT_MODE_COLOR": "#000000",
  "BANNER_DISMISS_BUTTON_PRESSED_STATE_DARK_MODE_COLOR": "#ffffff",
  "BANNER_DISMISS_BUTTON_PRESSED_STATE_COLOR": "#000000",
  "BANNER_DISMISS_BUTTON_ICON_ASSET": "x",
  "BANNER_DISMISS_BUTTON_ICON_WIDTH": 24,
  "BANNER_DISMISS_BUTTON_ICON_HEIGHT": 24,
  "BANNER_DISMISS_BUTTON_ICON_TINTABLE": true,
  "BANNER_BUTTON_SEPARATOR_LIGHT_MODE_COLOR": "#000000",
  "BANNER_BUTTON_SEPARATOR_DARK_MODE_COLOR": "#ffffff",
  "BANNER_BUTTON_SEPARATOR_HEIGHT": 8,
  "BANNER_BUTTON_SEPARATOR_OPACITY": 0.3,
  "BANNER_BUTTON_SEPARATOR_WIDTH": 1,
  "BANNER_BUTTON_SEPARATOR_COLOR": "#000000",
  "BANNER_BUTTON_SPACING": 12,
  "BANNER_BUTTON_TEXT_SIZE": 16,
  "BANNER_BUTTON_TEXT_LEADING": 24,
  "BANNER_BUTTON_TEXT_TRACKING": 0,
  "BANNER_BUTTON_TEXT_WEIGHT": 600,
  "BANNER_BUTTON_TEXT_CASE": "regular",
  "BANNER_BUTTON_TEXT_NUMBER_SPACING": "default",
  "BANNER_BUTTON_TEXT_SCALE": "paragraph-30",
  "BANNER_BUTTON_TEXT_FONT_FAMILY": "Square Sans Text",
  "BANNER_CONTENT_SPACING": 12,
  "BANNER_HORIZONTAL_PADDING": 16,
  "BANNER_ICON_SPACING": 12,
  "BANNER_MULTILINE_SPACING": 12,
  "BANNER_VERTICAL_PADDING": 16,
  "BANNER_TITLE_SIZE": 16,
  "BANNER_TITLE_LEADING": 24,
  "BANNER_TITLE_TRACKING": 0,
  "BANNER_TITLE_WEIGHT": 600,
  "BANNER_TITLE_CASE": "regular",
  "BANNER_TITLE_NUMBER_SPACING": "default",
  "BANNER_TITLE_SCALE": "paragraph-30",
  "BANNER_TITLE_FONT_FAMILY": "Square Sans Text",
  "BANNER_TEXT_SIZE": 16,
  "BANNER_TEXT_LEADING": 24,
  "BANNER_TEXT_TRACKING": 0,
  "BANNER_TEXT_WEIGHT": 400,
  "BANNER_TEXT_CASE": "regular",
  "BANNER_TEXT_NUMBER_SPACING": "default",
  "BANNER_TEXT_SCALE": "paragraph-30",
  "BANNER_TEXT_FONT_FAMILY": "Square Sans Text",
  "BANNER_INFO_VARIANT_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "BANNER_INFO_VARIANT_LIGHT_MODE_BORDER_COLOR": "#cce1ff",
  "BANNER_INFO_VARIANT_LIGHT_MODE_ICON_COLOR": "#006aff",
  "BANNER_INFO_VARIANT_LIGHT_MODE_TEXT_COLOR": "#000000",
  "BANNER_INFO_VARIANT_LIGHT_MODE_BUTTON_TEXT_COLOR": "#005ad9",
  "BANNER_INFO_VARIANT_LIGHT_MODE_TEXT_LINK_TEXT_COLOR": "#005ad9",
  "BANNER_INFO_VARIANT_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "BANNER_INFO_VARIANT_DARK_MODE_BORDER_COLOR": "#002559",
  "BANNER_INFO_VARIANT_DARK_MODE_ICON_COLOR": "#006aff",
  "BANNER_INFO_VARIANT_DARK_MODE_TEXT_COLOR": "#ffffff",
  "BANNER_INFO_VARIANT_DARK_MODE_BUTTON_TEXT_COLOR": "#4a95ff",
  "BANNER_INFO_VARIANT_DARK_MODE_TEXT_LINK_TEXT_COLOR": "#4a95ff",
  "BANNER_INFO_VARIANT_BACKGROUND_COLOR": "#e6f0ff",
  "BANNER_INFO_VARIANT_BORDER_COLOR": "#cce1ff",
  "BANNER_INFO_VARIANT_ICON_COLOR": "#006aff",
  "BANNER_INFO_VARIANT_TEXT_COLOR": "#000000",
  "BANNER_INFO_VARIANT_BUTTON_TEXT_COLOR": "#005ad9",
  "BANNER_INFO_VARIANT_TEXT_LINK_TEXT_COLOR": "#005ad9",
  "BANNER_SUCCESS_VARIANT_LIGHT_MODE_BACKGROUND_COLOR": "#e5ffee",
  "BANNER_SUCCESS_VARIANT_LIGHT_MODE_BORDER_COLOR": "#ccffdd",
  "BANNER_SUCCESS_VARIANT_LIGHT_MODE_ICON_COLOR": "#00b23b",
  "BANNER_SUCCESS_VARIANT_LIGHT_MODE_TEXT_COLOR": "#000000",
  "BANNER_SUCCESS_VARIANT_LIGHT_MODE_BUTTON_TEXT_COLOR": "#007d2a",
  "BANNER_SUCCESS_VARIANT_LIGHT_MODE_TEXT_LINK_TEXT_COLOR": "#007d2a",
  "BANNER_SUCCESS_VARIANT_DARK_MODE_BACKGROUND_COLOR": "#003311",
  "BANNER_SUCCESS_VARIANT_DARK_MODE_BORDER_COLOR": "#00591e",
  "BANNER_SUCCESS_VARIANT_DARK_MODE_ICON_COLOR": "#00b33b",
  "BANNER_SUCCESS_VARIANT_DARK_MODE_TEXT_COLOR": "#ffffff",
  "BANNER_SUCCESS_VARIANT_DARK_MODE_BUTTON_TEXT_COLOR": "#16d956",
  "BANNER_SUCCESS_VARIANT_DARK_MODE_TEXT_LINK_TEXT_COLOR": "#16d956",
  "BANNER_SUCCESS_VARIANT_BACKGROUND_COLOR": "#e5ffee",
  "BANNER_SUCCESS_VARIANT_BORDER_COLOR": "#ccffdd",
  "BANNER_SUCCESS_VARIANT_ICON_COLOR": "#00b23b",
  "BANNER_SUCCESS_VARIANT_TEXT_COLOR": "#000000",
  "BANNER_SUCCESS_VARIANT_BUTTON_TEXT_COLOR": "#007d2a",
  "BANNER_SUCCESS_VARIANT_TEXT_LINK_TEXT_COLOR": "#007d2a",
  "BANNER_WARNING_VARIANT_LIGHT_MODE_BACKGROUND_COLOR": "#fff2e6",
  "BANNER_WARNING_VARIANT_LIGHT_MODE_BORDER_COLOR": "#ffe6cc",
  "BANNER_WARNING_VARIANT_LIGHT_MODE_ICON_COLOR": "#ff9f40",
  "BANNER_WARNING_VARIANT_LIGHT_MODE_TEXT_COLOR": "#000000",
  "BANNER_WARNING_VARIANT_LIGHT_MODE_BUTTON_TEXT_COLOR": "#945c25",
  "BANNER_WARNING_VARIANT_LIGHT_MODE_TEXT_LINK_TEXT_COLOR": "#945c25",
  "BANNER_WARNING_VARIANT_DARK_MODE_BACKGROUND_COLOR": "#331a00",
  "BANNER_WARNING_VARIANT_DARK_MODE_BORDER_COLOR": "#592d00",
  "BANNER_WARNING_VARIANT_DARK_MODE_ICON_COLOR": "#ff9f40",
  "BANNER_WARNING_VARIANT_DARK_MODE_TEXT_COLOR": "#ffffff",
  "BANNER_WARNING_VARIANT_DARK_MODE_BUTTON_TEXT_COLOR": "#ff9f40",
  "BANNER_WARNING_VARIANT_DARK_MODE_TEXT_LINK_TEXT_COLOR": "#ff9f40",
  "BANNER_WARNING_VARIANT_BACKGROUND_COLOR": "#fff2e6",
  "BANNER_WARNING_VARIANT_BORDER_COLOR": "#ffe6cc",
  "BANNER_WARNING_VARIANT_ICON_COLOR": "#ff9f40",
  "BANNER_WARNING_VARIANT_TEXT_COLOR": "#000000",
  "BANNER_WARNING_VARIANT_BUTTON_TEXT_COLOR": "#945c25",
  "BANNER_WARNING_VARIANT_TEXT_LINK_TEXT_COLOR": "#945c25",
  "BANNER_CRITICAL_VARIANT_LIGHT_MODE_BACKGROUND_COLOR": "#ffe5ea",
  "BANNER_CRITICAL_VARIANT_LIGHT_MODE_BORDER_COLOR": "#ffccd5",
  "BANNER_CRITICAL_VARIANT_LIGHT_MODE_ICON_COLOR": "#cc0023",
  "BANNER_CRITICAL_VARIANT_LIGHT_MODE_TEXT_COLOR": "#000000",
  "BANNER_CRITICAL_VARIANT_LIGHT_MODE_BUTTON_TEXT_COLOR": "#bf0020",
  "BANNER_CRITICAL_VARIANT_LIGHT_MODE_TEXT_LINK_TEXT_COLOR": "#bf0020",
  "BANNER_CRITICAL_VARIANT_DARK_MODE_BACKGROUND_COLOR": "#330009",
  "BANNER_CRITICAL_VARIANT_DARK_MODE_BORDER_COLOR": "#59000f",
  "BANNER_CRITICAL_VARIANT_DARK_MODE_ICON_COLOR": "#cc0023",
  "BANNER_CRITICAL_VARIANT_DARK_MODE_TEXT_COLOR": "#ffffff",
  "BANNER_CRITICAL_VARIANT_DARK_MODE_BUTTON_TEXT_COLOR": "#ff5a76",
  "BANNER_CRITICAL_VARIANT_DARK_MODE_TEXT_LINK_TEXT_COLOR": "#ff5a76",
  "BANNER_CRITICAL_VARIANT_BACKGROUND_COLOR": "#ffe5ea",
  "BANNER_CRITICAL_VARIANT_BORDER_COLOR": "#ffccd5",
  "BANNER_CRITICAL_VARIANT_ICON_COLOR": "#cc0023",
  "BANNER_CRITICAL_VARIANT_TEXT_COLOR": "#000000",
  "BANNER_CRITICAL_VARIANT_BUTTON_TEXT_COLOR": "#bf0020",
  "BANNER_CRITICAL_VARIANT_TEXT_LINK_TEXT_COLOR": "#bf0020",
  "BANNER_INSIGHT_VARIANT_LIGHT_MODE_BACKGROUND_COLOR": "#f4e6ff",
  "BANNER_INSIGHT_VARIANT_LIGHT_MODE_BORDER_COLOR": "#eaccff",
  "BANNER_INSIGHT_VARIANT_LIGHT_MODE_ICON_COLOR": "#8716d9",
  "BANNER_INSIGHT_VARIANT_LIGHT_MODE_TEXT_COLOR": "#000000",
  "BANNER_INSIGHT_VARIANT_LIGHT_MODE_BUTTON_TEXT_COLOR": "#8716d9",
  "BANNER_INSIGHT_VARIANT_LIGHT_MODE_TEXT_LINK_TEXT_COLOR": "#8716d9",
  "BANNER_INSIGHT_VARIANT_DARK_MODE_BACKGROUND_COLOR": "#1e0033",
  "BANNER_INSIGHT_VARIANT_DARK_MODE_BORDER_COLOR": "#340059",
  "BANNER_INSIGHT_VARIANT_DARK_MODE_ICON_COLOR": "#8716d9",
  "BANNER_INSIGHT_VARIANT_DARK_MODE_TEXT_COLOR": "#ffffff",
  "BANNER_INSIGHT_VARIANT_DARK_MODE_BUTTON_TEXT_COLOR": "#c26eff",
  "BANNER_INSIGHT_VARIANT_DARK_MODE_TEXT_LINK_TEXT_COLOR": "#c26eff",
  "BANNER_INSIGHT_VARIANT_BACKGROUND_COLOR": "#f4e6ff",
  "BANNER_INSIGHT_VARIANT_BORDER_COLOR": "#eaccff",
  "BANNER_INSIGHT_VARIANT_ICON_COLOR": "#8716d9",
  "BANNER_INSIGHT_VARIANT_TEXT_COLOR": "#000000",
  "BANNER_INSIGHT_VARIANT_BUTTON_TEXT_COLOR": "#8716d9",
  "BANNER_INSIGHT_VARIANT_TEXT_LINK_TEXT_COLOR": "#8716d9",
  "BUTTON_GROUP_SPACING": 16,
  "BUTTON_GROUP_OVERFLOW_BUTTON_ICON_ASSET": "ellipsis",
  "BUTTON_GROUP_OVERFLOW_BUTTON_ICON_WIDTH": 24,
  "BUTTON_GROUP_OVERFLOW_BUTTON_ICON_HEIGHT": 24,
  "BUTTON_GROUP_OVERFLOW_BUTTON_ICON_TINTABLE": true,
  "BUTTON_GROUP_OVERFLOW_BUTTON_WIDTH": 48,
  "BUTTON_COMPACT_HORIZONTAL_SIZE_CLASS_SAMPLE_TOKEN": 100,
  "BUTTON_REGULAR_HORIZONTAL_SIZE_CLASS_SAMPLE_TOKEN": 200,
  "BUTTON_WIDE_HORIZONTAL_SIZE_CLASS_SAMPLE_TOKEN": 300,
  "BUTTON_COMPACT_VERTICAL_SIZE_CLASS_SAMPLE_TOKEN_2": 10,
  "BUTTON_REGULAR_VERTICAL_SIZE_CLASS_SAMPLE_TOKEN_2": 20,
  "BUTTON_TALL_VERTICAL_SIZE_CLASS_SAMPLE_TOKEN_2": 30,
  "BUTTON_SMALL_SIZE_MINIMUM_HEIGHT": 40,
  "BUTTON_SMALL_SIZE_MINIMUM_WIDTH_MULTIPLIER": 1.5,
  "BUTTON_SMALL_SIZE_TEXT_SIZE": 14,
  "BUTTON_SMALL_SIZE_TEXT_LEADING": 22,
  "BUTTON_SMALL_SIZE_TEXT_TRACKING": 0,
  "BUTTON_SMALL_SIZE_TEXT_WEIGHT": 600,
  "BUTTON_SMALL_SIZE_TEXT_CASE": "regular",
  "BUTTON_SMALL_SIZE_TEXT_NUMBER_SPACING": "default",
  "BUTTON_SMALL_SIZE_TEXT_SCALE": "paragraph-20",
  "BUTTON_SMALL_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
  "BUTTON_SMALL_SIZE_CONTENT_SPACING": 8,
  "BUTTON_SMALL_SIZE_PRIMARY_RANK_HORIZONTAL_PADDING": 12,
  "BUTTON_SMALL_SIZE_PRIMARY_RANK_VERTICAL_PADDING": 9,
  "BUTTON_SMALL_SIZE_SECONDARY_RANK_HORIZONTAL_PADDING": 12,
  "BUTTON_SMALL_SIZE_SECONDARY_RANK_VERTICAL_PADDING": 9,
  "BUTTON_SMALL_SIZE_TERTIARY_RANK_HORIZONTAL_PADDING": 8,
  "BUTTON_SMALL_SIZE_TERTIARY_RANK_VERTICAL_PADDING": 9,
  "BUTTON_MEDIUM_SIZE_MINIMUM_HEIGHT": 48,
  "BUTTON_MEDIUM_SIZE_MINIMUM_WIDTH_MULTIPLIER": 1.5,
  "BUTTON_MEDIUM_SIZE_TEXT_SIZE": 16,
  "BUTTON_MEDIUM_SIZE_TEXT_LEADING": 24,
  "BUTTON_MEDIUM_SIZE_TEXT_TRACKING": 0,
  "BUTTON_MEDIUM_SIZE_TEXT_WEIGHT": 600,
  "BUTTON_MEDIUM_SIZE_TEXT_CASE": "regular",
  "BUTTON_MEDIUM_SIZE_TEXT_NUMBER_SPACING": "default",
  "BUTTON_MEDIUM_SIZE_TEXT_SCALE": "paragraph-30",
  "BUTTON_MEDIUM_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
  "BUTTON_MEDIUM_SIZE_CONTENT_SPACING": 8,
  "BUTTON_MEDIUM_SIZE_PRIMARY_RANK_HORIZONTAL_PADDING": 16,
  "BUTTON_MEDIUM_SIZE_PRIMARY_RANK_VERTICAL_PADDING": 12,
  "BUTTON_MEDIUM_SIZE_SECONDARY_RANK_HORIZONTAL_PADDING": 16,
  "BUTTON_MEDIUM_SIZE_SECONDARY_RANK_VERTICAL_PADDING": 12,
  "BUTTON_MEDIUM_SIZE_TERTIARY_RANK_HORIZONTAL_PADDING": 8,
  "BUTTON_MEDIUM_SIZE_TERTIARY_RANK_VERTICAL_PADDING": 12,
  "BUTTON_LARGE_SIZE_MINIMUM_HEIGHT": 64,
  "BUTTON_LARGE_SIZE_MINIMUM_WIDTH_MULTIPLIER": 1.5,
  "BUTTON_LARGE_SIZE_TEXT_SIZE": 16,
  "BUTTON_LARGE_SIZE_TEXT_LEADING": 24,
  "BUTTON_LARGE_SIZE_TEXT_TRACKING": 0,
  "BUTTON_LARGE_SIZE_TEXT_WEIGHT": 600,
  "BUTTON_LARGE_SIZE_TEXT_CASE": "regular",
  "BUTTON_LARGE_SIZE_TEXT_NUMBER_SPACING": "default",
  "BUTTON_LARGE_SIZE_TEXT_SCALE": "paragraph-30",
  "BUTTON_LARGE_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
  "BUTTON_LARGE_SIZE_CONTENT_SPACING": 8,
  "BUTTON_LARGE_SIZE_PRIMARY_RANK_HORIZONTAL_PADDING": 20,
  "BUTTON_LARGE_SIZE_PRIMARY_RANK_VERTICAL_PADDING": 20,
  "BUTTON_LARGE_SIZE_SECONDARY_RANK_HORIZONTAL_PADDING": 20,
  "BUTTON_LARGE_SIZE_SECONDARY_RANK_VERTICAL_PADDING": 20,
  "BUTTON_LARGE_SIZE_TERTIARY_RANK_HORIZONTAL_PADDING": 8,
  "BUTTON_LARGE_SIZE_TERTIARY_RANK_VERTICAL_PADDING": 20,
  "BUTTON_BORDER_RADIUS": 6,
  "BUTTON_FOCUS_RING_BUFFER_SIZE": 2,
  "BUTTON_FOCUS_RING_BORDER_SIZE": 2,
  "BUTTON_FOCUS_RING_COLOR": "#006aff",
  "BUTTON_LIGHT_MODE_FOCUS_RING_COLOR": "#006aff",
  "BUTTON_DARK_MODE_FOCUS_RING_COLOR": "#006aff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#006aff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#006aff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "#006aff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_LABEL_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#005fe5",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#005fe5",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "#005fe5",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_LABEL_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#0055cc",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#0055cc",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "#0055cc",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_LABEL_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#006aff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#006aff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "#006aff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_LABEL_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_LABEL_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "#005ad9",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "#4a95ff",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_LABEL_COLOR": "#005ad9",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "#005ad9",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "#4a95ff",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_LABEL_COLOR": "#005ad9",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#cce1ff",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "#005ad9",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#002559",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "#4a95ff",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "#cce1ff",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_LABEL_COLOR": "#005ad9",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "#005ad9",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "#4a95ff",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_LABEL_COLOR": "#005ad9",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_LABEL_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "#005ad9",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "#4a95ff",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_LABEL_COLOR": "#005ad9",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "#005ad9",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "#4a95ff",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_LABEL_COLOR": "#005ad9",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#cce1ff",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "#005ad9",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#002559",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "#4a95ff",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "#cce1ff",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_LABEL_COLOR": "#005ad9",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "#005ad9",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "#4a95ff",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_LABEL_COLOR": "#005ad9",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_LABEL_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#cc0023",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#cc0023",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "#cc0023",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_LABEL_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#b2001e",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#b2001e",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "#b2001e",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_LABEL_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#99001a",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#99001a",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "#99001a",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_LABEL_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#b2001e",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#b2001e",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "#b2001e",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_FOCUS_STATE_LABEL_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_LABEL_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "#bf0020",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "#ff5a76",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_LABEL_COLOR": "#bf0020",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#ffe5ea",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "#bf0020",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#330009",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "#ff5a76",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "#ffe5ea",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_LABEL_COLOR": "#bf0020",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#ffccd5",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "#bf0020",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#59000f",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "#ff5a76",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "#ffccd5",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_LABEL_COLOR": "#bf0020",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#ffe5ea",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "#bf0020",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#330009",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "#ff5a76",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "#ffe5ea",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_FOCUS_STATE_LABEL_COLOR": "#bf0020",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_LABEL_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "#bf0020",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "#ff5a76",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_NORMAL_STATE_LABEL_COLOR": "#bf0020",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#ffe5ea",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "#bf0020",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#330009",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "#ff5a76",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "#ffe5ea",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_HOVER_STATE_LABEL_COLOR": "#bf0020",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#ffccd5",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "#bf0020",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#59000f",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "#ff5a76",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "#ffccd5",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_PRESSED_STATE_LABEL_COLOR": "#bf0020",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "#bf0020",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "#ff5a76",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_FOCUS_STATE_LABEL_COLOR": "#bf0020",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "BUTTON_DESTRUCTIVE_VARIANT_TERTIARY_RANK_DISABLED_STATE_LABEL_COLOR": "#000000",
  "BUTTON_LOADING_ICON_ASSET": "radial-spinner",
  "BUTTON_LOADING_ICON_WIDTH": 24,
  "BUTTON_LOADING_ICON_HEIGHT": 24,
  "BUTTON_LOADING_ICON_TINTABLE": true,
  "CHECKBOX_WIDTH": 20,
  "CHECKBOX_HEIGHT": 20,
  "CHECKBOX_BORDER_RADIUS": 4,
  "CHECKBOX_BORDER_SIZE": 2,
  "CHECKBOX_LIGHT_MODE_FOCUS_RING_COLOR": "#006aff",
  "CHECKBOX_DARK_MODE_FOCUS_RING_COLOR": "#006aff",
  "CHECKBOX_FOCUS_RING_BUFFER_SIZE": 2,
  "CHECKBOX_FOCUS_RING_BORDER_SIZE": 2,
  "CHECKBOX_FOCUS_RING_COLOR": "#006aff",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#ffffff",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#006aff",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#006aff",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_ICON_ASSET": "checkmark",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_ICON_WIDTH": 20,
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_ICON_HEIGHT": 20,
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_ICON_TINTABLE": true,
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "#006aff",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_ICON_COLOR": "#006aff",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "#ffffff",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_ICON_COLOR": "#006aff",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_ICON_ASSET": "indeterminate-mark",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_ICON_WIDTH": 20,
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_ICON_HEIGHT": 20,
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_ICON_TINTABLE": true,
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#cc0023",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#cc0023",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "#cc0023",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#cc0023",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#cc0023",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "#cc0023",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_CHECKED_VALUE_ICON_COLOR": "#ffffff",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "#cc0023",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_ICON_COLOR": "#cc0023",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "#cc0023",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_ICON_COLOR": "#cc0023",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "#cc0023",
  "CHECKBOX_NORMAL_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_ICON_COLOR": "#cc0023",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#006aff",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#006aff",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "#006aff",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#005fe5",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#005fe5",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "#005fe5",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_CHECKED_VALUE_ICON_COLOR": "#ffffff",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "#006aff",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_ICON_COLOR": "#006aff",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "#006aff",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "#006aff",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_ICON_COLOR": "#006aff",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "#006aff",
  "CHECKBOX_HOVER_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_ICON_COLOR": "#006aff",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#b2001e",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#b2001e",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "#b2001e",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#b2001e",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#b2001e",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "#b2001e",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_CHECKED_VALUE_ICON_COLOR": "#ffffff",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "#b2001e",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_ICON_COLOR": "#b2001e",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "#b2001e",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_ICON_COLOR": "#b2001e",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "#b2001e",
  "CHECKBOX_HOVER_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_ICON_COLOR": "#b2001e",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#0055cc",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#0055cc",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "#0055cc",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#0055cc",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#0055cc",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "#0055cc",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_ICON_COLOR": "#ffffff",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "#0055cc",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_ICON_COLOR": "#0055cc",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "#0055cc",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_ICON_COLOR": "#0055cc",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "#0055cc",
  "CHECKBOX_PRESSED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_ICON_COLOR": "#0055cc",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#99001a",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#99001a",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "#99001a",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#99001a",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#99001a",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "#99001a",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_CHECKED_VALUE_ICON_COLOR": "#ffffff",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "#99001a",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_ICON_COLOR": "#99001a",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "#99001a",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_ICON_COLOR": "#99001a",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "#99001a",
  "CHECKBOX_PRESSED_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_ICON_COLOR": "#99001a",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#006aff",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#006aff",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "#006aff",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#005fe5",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#005fe5",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "#005fe5",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_CHECKED_VALUE_ICON_COLOR": "#ffffff",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "#006aff",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_ICON_COLOR": "#006aff",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "#006aff",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "#006aff",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_ICON_COLOR": "#006aff",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "#006aff",
  "CHECKBOX_FOCUS_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_ICON_COLOR": "#006aff",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#b2001e",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#b2001e",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "#b2001e",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#b2001e",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#b2001e",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "#b2001e",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_CHECKED_VALUE_ICON_COLOR": "#ffffff",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "#b2001e",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "#b2001e",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_FOCUS_STATE_INVALID_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "#b2001e",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#ffffff",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_UNCHECKED_VALUE_BORDER_COLOR": "#000000",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_BORDER_COLOR": "#000000",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_CHECKED_VALUE_ICON_COLOR": "#ffffff",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_LIGHT_MODE_ICON_COLOR": "#000000",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_BORDER_COLOR": "#ffffff",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BACKGROUND_COLOR": "#000000",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_BORDER_COLOR": "#000000",
  "CHECKBOX_DISABLED_STATE_NORMAL_VALIDITY_INDETERMINATE_VALUE_ICON_COLOR": "#000000",
  "CHOICE_BUTTON_MINIMUM_WIDTH_MULTIPLER": 1.5,
  "CHOICE_BUTTON_SMALL_SIZE_TEXT_PRIMARY_SIZE": 14,
  "CHOICE_BUTTON_SMALL_SIZE_TEXT_PRIMARY_LEADING": 22,
  "CHOICE_BUTTON_SMALL_SIZE_TEXT_PRIMARY_TRACKING": 0,
  "CHOICE_BUTTON_SMALL_SIZE_TEXT_PRIMARY_WEIGHT": 600,
  "CHOICE_BUTTON_SMALL_SIZE_TEXT_PRIMARY_CASE": "regular",
  "CHOICE_BUTTON_SMALL_SIZE_TEXT_PRIMARY_NUMBER_SPACING": "default",
  "CHOICE_BUTTON_SMALL_SIZE_TEXT_PRIMARY_SCALE": "paragraph-20",
  "CHOICE_BUTTON_SMALL_SIZE_TEXT_PRIMARY_FONT_FAMILY": "Square Sans Text",
  "CHOICE_BUTTON_SMALL_SIZE_TEXT_SECONDARY_SIZE": 14,
  "CHOICE_BUTTON_SMALL_SIZE_TEXT_SECONDARY_LEADING": 22,
  "CHOICE_BUTTON_SMALL_SIZE_TEXT_SECONDARY_TRACKING": 0,
  "CHOICE_BUTTON_SMALL_SIZE_TEXT_SECONDARY_WEIGHT": 400,
  "CHOICE_BUTTON_SMALL_SIZE_TEXT_SECONDARY_CASE": "regular",
  "CHOICE_BUTTON_SMALL_SIZE_TEXT_SECONDARY_NUMBER_SPACING": "default",
  "CHOICE_BUTTON_SMALL_SIZE_TEXT_SECONDARY_SCALE": "paragraph-20",
  "CHOICE_BUTTON_SMALL_SIZE_TEXT_SECONDARY_FONT_FAMILY": "Square Sans Text",
  "CHOICE_BUTTON_SMALL_SIZE_CONTENT_SPACING": 8,
  "CHOICE_BUTTON_SMALL_SIZE_HORIZONTAL_PADDING": 12,
  "CHOICE_BUTTON_SMALL_SIZE_VERTICAL_PADDING": 9,
  "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_PRIMARY_SIZE": 16,
  "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_PRIMARY_LEADING": 24,
  "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_PRIMARY_TRACKING": 0,
  "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_PRIMARY_WEIGHT": 600,
  "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_PRIMARY_CASE": "regular",
  "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_PRIMARY_NUMBER_SPACING": "default",
  "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_PRIMARY_SCALE": "paragraph-30",
  "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_PRIMARY_FONT_FAMILY": "Square Sans Text",
  "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_SECONDARY_SIZE": 16,
  "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_SECONDARY_LEADING": 24,
  "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_SECONDARY_TRACKING": 0,
  "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_SECONDARY_WEIGHT": 400,
  "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_SECONDARY_CASE": "regular",
  "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_SECONDARY_NUMBER_SPACING": "default",
  "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_SECONDARY_SCALE": "paragraph-30",
  "CHOICE_BUTTON_MEDIUM_SIZE_TEXT_SECONDARY_FONT_FAMILY": "Square Sans Text",
  "CHOICE_BUTTON_MEDIUM_SIZE_CONTENT_SPACING": 8,
  "CHOICE_BUTTON_MEDIUM_SIZE_HORIZONTAL_PADDING": 16,
  "CHOICE_BUTTON_MEDIUM_SIZE_VERTICAL_PADDING": 12,
  "CHOICE_BUTTON_LARGE_SIZE_TEXT_PRIMARY_SIZE": 16,
  "CHOICE_BUTTON_LARGE_SIZE_TEXT_PRIMARY_LEADING": 24,
  "CHOICE_BUTTON_LARGE_SIZE_TEXT_PRIMARY_TRACKING": 0,
  "CHOICE_BUTTON_LARGE_SIZE_TEXT_PRIMARY_WEIGHT": 600,
  "CHOICE_BUTTON_LARGE_SIZE_TEXT_PRIMARY_CASE": "regular",
  "CHOICE_BUTTON_LARGE_SIZE_TEXT_PRIMARY_NUMBER_SPACING": "default",
  "CHOICE_BUTTON_LARGE_SIZE_TEXT_PRIMARY_SCALE": "paragraph-30",
  "CHOICE_BUTTON_LARGE_SIZE_TEXT_PRIMARY_FONT_FAMILY": "Square Sans Text",
  "CHOICE_BUTTON_LARGE_SIZE_TEXT_SECONDARY_SIZE": 16,
  "CHOICE_BUTTON_LARGE_SIZE_TEXT_SECONDARY_LEADING": 24,
  "CHOICE_BUTTON_LARGE_SIZE_TEXT_SECONDARY_TRACKING": 0,
  "CHOICE_BUTTON_LARGE_SIZE_TEXT_SECONDARY_WEIGHT": 400,
  "CHOICE_BUTTON_LARGE_SIZE_TEXT_SECONDARY_CASE": "regular",
  "CHOICE_BUTTON_LARGE_SIZE_TEXT_SECONDARY_NUMBER_SPACING": "default",
  "CHOICE_BUTTON_LARGE_SIZE_TEXT_SECONDARY_SCALE": "paragraph-30",
  "CHOICE_BUTTON_LARGE_SIZE_TEXT_SECONDARY_FONT_FAMILY": "Square Sans Text",
  "CHOICE_BUTTON_LARGE_SIZE_CONTENT_SPACING": 8,
  "CHOICE_BUTTON_LARGE_SIZE_HORIZONTAL_PADDING": 20,
  "CHOICE_BUTTON_LARGE_SIZE_VERTICAL_PADDING": 20,
  "CHOICE_BUTTON_BORDER_RADIUS": 6,
  "CHOICE_BUTTON_FOCUS_RING_BUFFER_SIZE": 2,
  "CHOICE_BUTTON_FOCUS_RING_BORDER_SIZE": 2,
  "CHOICE_BUTTON_FOCUS_RING_COLOR": "#006aff",
  "CHOICE_BUTTON_LIGHT_MODE_FOCUS_RING_COLOR": "#006aff",
  "CHOICE_BUTTON_DARK_MODE_FOCUS_RING_COLOR": "#006aff",
  "CHOICE_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHOICE_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "CHOICE_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "CHOICE_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "CHOICE_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "CHOICE_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_LABEL_COLOR": "#000000",
  "CHOICE_BUTTON_UNSELECTED_VALUE_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "CHOICE_BUTTON_UNSELECTED_VALUE_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "CHOICE_BUTTON_UNSELECTED_VALUE_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "CHOICE_BUTTON_UNSELECTED_VALUE_HOVER_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "CHOICE_BUTTON_UNSELECTED_VALUE_HOVER_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "CHOICE_BUTTON_UNSELECTED_VALUE_HOVER_STATE_LABEL_COLOR": "#000000",
  "CHOICE_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#cce1ff",
  "CHOICE_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "CHOICE_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#002559",
  "CHOICE_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "CHOICE_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_BACKGROUND_COLOR": "#cce1ff",
  "CHOICE_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_LABEL_COLOR": "#000000",
  "CHOICE_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHOICE_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "CHOICE_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "CHOICE_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "CHOICE_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "CHOICE_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_LABEL_COLOR": "#000000",
  "CHOICE_BUTTON_SELECTED_VALUE_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHOICE_BUTTON_SELECTED_VALUE_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "#ffffff",
  "CHOICE_BUTTON_SELECTED_VALUE_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "CHOICE_BUTTON_SELECTED_VALUE_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "#000000",
  "CHOICE_BUTTON_SELECTED_VALUE_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "CHOICE_BUTTON_SELECTED_VALUE_NORMAL_STATE_LABEL_COLOR": "#ffffff",
  "CHOICE_BUTTON_SELECTED_VALUE_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHOICE_BUTTON_SELECTED_VALUE_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "#ffffff",
  "CHOICE_BUTTON_SELECTED_VALUE_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "CHOICE_BUTTON_SELECTED_VALUE_HOVER_STATE_DARK_MODE_LABEL_COLOR": "#000000",
  "CHOICE_BUTTON_SELECTED_VALUE_HOVER_STATE_BACKGROUND_COLOR": "#000000",
  "CHOICE_BUTTON_SELECTED_VALUE_HOVER_STATE_LABEL_COLOR": "#ffffff",
  "CHOICE_BUTTON_SELECTED_VALUE_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHOICE_BUTTON_SELECTED_VALUE_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "#ffffff",
  "CHOICE_BUTTON_SELECTED_VALUE_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "CHOICE_BUTTON_SELECTED_VALUE_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "#000000",
  "CHOICE_BUTTON_SELECTED_VALUE_PRESSED_STATE_BACKGROUND_COLOR": "#000000",
  "CHOICE_BUTTON_SELECTED_VALUE_PRESSED_STATE_LABEL_COLOR": "#ffffff",
  "CHOICE_BUTTON_SELECTED_VALUE_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHOICE_BUTTON_SELECTED_VALUE_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "#ffffff",
  "CHOICE_BUTTON_SELECTED_VALUE_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "CHOICE_BUTTON_SELECTED_VALUE_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "#000000",
  "CHOICE_BUTTON_SELECTED_VALUE_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "CHOICE_BUTTON_SELECTED_VALUE_DISABLED_STATE_LABEL_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_MINIMUM_WIDTH_MULTIPLER": 1,
  "CHOICE_ICON_BUTTON_SMALL_SIZE_HORIZONTAL_PADDING": 8,
  "CHOICE_ICON_BUTTON_SMALL_SIZE_VERTICAL_PADDING": 8,
  "CHOICE_ICON_BUTTON_MEDIUM_SIZE_HORIZONTAL_PADDING": 12,
  "CHOICE_ICON_BUTTON_MEDIUM_SIZE_VERTICAL_PADDING": 12,
  "CHOICE_ICON_BUTTON_LARGE_SIZE_HORIZONTAL_PADDING": 16,
  "CHOICE_ICON_BUTTON_LARGE_SIZE_VERTICAL_PADDING": 16,
  "CHOICE_ICON_BUTTON_BORDER_RADIUS": 6,
  "CHOICE_ICON_BUTTON_FOCUS_RING_BUFFER_SIZE": 2,
  "CHOICE_ICON_BUTTON_FOCUS_RING_BORDER_SIZE": 2,
  "CHOICE_ICON_BUTTON_FOCUS_RING_COLOR": "#006aff",
  "CHOICE_ICON_BUTTON_LIGHT_MODE_FOCUS_RING_COLOR": "#006aff",
  "CHOICE_ICON_BUTTON_DARK_MODE_FOCUS_RING_COLOR": "#006aff",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_NORMAL_STATE_ICON_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_HOVER_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_HOVER_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_HOVER_STATE_ICON_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#cce1ff",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#002559",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_BACKGROUND_COLOR": "#cce1ff",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_PRESSED_STATE_ICON_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_UNSELECTED_VALUE_DISABLED_STATE_ICON_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_NORMAL_STATE_DARK_MODE_ICON_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_NORMAL_STATE_ICON_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_HOVER_STATE_DARK_MODE_ICON_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_HOVER_STATE_BACKGROUND_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_HOVER_STATE_ICON_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_PRESSED_STATE_DARK_MODE_ICON_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_PRESSED_STATE_BACKGROUND_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_PRESSED_STATE_ICON_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_DISABLED_STATE_DARK_MODE_ICON_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "CHOICE_ICON_BUTTON_SELECTED_VALUE_DISABLED_STATE_ICON_COLOR": "#ffffff",
  "COLOR_PICKER_VERTICAL_SPACING": 16,
  "COLOR_PICKER_DOTS_SIZE": 40,
  "COLOR_PICKER_DOTS_HORIZONTAL_SPACING": 14,
  "COLOR_PICKER_DOTS_VERTICAL_SPACING": 16,
  "COLOR_PICKER_DOTS_ICON_ASSET": "check",
  "COLOR_PICKER_DOTS_ICON_WIDTH": 24,
  "COLOR_PICKER_DOTS_ICON_HEIGHT": 24,
  "COLOR_PICKER_DOTS_ICON_TINTABLE": true,
  "COLOR_PICKER_ADJUSTMENTS_HUE_RADIUS": 6,
  "COLOR_PICKER_ADJUSTMENTS_HUE_MIN_HEIGHT": 40,
  "COLOR_PICKER_ADJUSTMENTS_SATURATION_BRIGHTNESS_RADIUS": 12,
  "COLOR_PICKER_ADJUSTMENTS_SATURATION_BRIGHTNESS_MIN_HEIGHT": 200,
  "COLOR_PICKER_ADJUSTMENTS_SCRUBBER_SIZE": 16,
  "COLOR_PICKER_ADJUSTMENTS_SCRUBBER_WIDTH": 2,
  "COLOR_PICKER_ADJUSTMENTS_SCRUBBER_PADDING": 4,
  "COLOR_PICKER_ADJUSTMENTS_SCRUBBER_MULTIPLIER": 1.25,
  "CONTENT_CARD_BORDER_LIGHT_MODE_COLOR": "#000000",
  "CONTENT_CARD_BORDER_DARK_MODE_COLOR": "#ffffff",
  "CONTENT_CARD_BORDER_WIDTH": 1,
  "CONTENT_CARD_BORDER_RADIUS": 6,
  "CONTENT_CARD_BORDER_COLOR": "#000000",
  "CONTENT_CARD_PADDING_HORIZONTAL_SIZE": 16,
  "CONTENT_CARD_PADDING_VERTICAL_SIZE": 16,
  "CONTENT_CARD_BACKGROUND_LIGHT_MODE_COLOR": "#ffffff",
  "CONTENT_CARD_BACKGROUND_DARK_MODE_COLOR": "#141414",
  "CONTENT_CARD_BACKGROUND_COLOR": "#ffffff",
  "DATE_PICKER_MINIMUM_WIDTH": 280,
  "DATE_PICKER_HEADER_FONT_SIZE": 25,
  "DATE_PICKER_HEADER_FONT_LEADING": 32,
  "DATE_PICKER_HEADER_FONT_TRACKING": 0,
  "DATE_PICKER_HEADER_FONT_WEIGHT": 700,
  "DATE_PICKER_HEADER_FONT_CASE": "regular",
  "DATE_PICKER_HEADER_FONT_NUMBER_SPACING": "default",
  "DATE_PICKER_HEADER_FONT_SCALE": "heading-30",
  "DATE_PICKER_HEADER_FONT_FONT_FAMILY": "Square Sans Display",
  "DATE_PICKER_HEADER_FONT_IS_HEADER": true,
  "DATE_PICKER_HEADER_COLOR_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_HEADER_COLOR_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_HEADER_COLOR_COLOR": "#000000",
  "DATE_PICKER_HEADER_MINIMUM_HEIGHT": 40,
  "DATE_PICKER_HEADER_VERTICAL_SPACING": 16,
  "DATE_PICKER_HEADER_BUTTON_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_HEADER_BUTTON_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_HEADER_BUTTON_BACKGROUND_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_HEADER_BUTTON_BACKGROUND_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_HEADER_BUTTON_BACKGROUND_COLOR": "#000000",
  "DATE_PICKER_HEADER_BUTTON_BORDER_RADIUS": 6,
  "DATE_PICKER_HEADER_BUTTON_PREVIOUS_YEAR_ICON_ASSET": "arrow-left",
  "DATE_PICKER_HEADER_BUTTON_PREVIOUS_YEAR_ICON_WIDTH": 24,
  "DATE_PICKER_HEADER_BUTTON_PREVIOUS_YEAR_ICON_HEIGHT": 24,
  "DATE_PICKER_HEADER_BUTTON_PREVIOUS_YEAR_ICON_TINTABLE": true,
  "DATE_PICKER_HEADER_BUTTON_NEXT_YEAR_ICON_ASSET": "arrow-right",
  "DATE_PICKER_HEADER_BUTTON_NEXT_YEAR_ICON_WIDTH": 24,
  "DATE_PICKER_HEADER_BUTTON_NEXT_YEAR_ICON_HEIGHT": 24,
  "DATE_PICKER_HEADER_BUTTON_NEXT_YEAR_ICON_TINTABLE": true,
  "DATE_PICKER_HEADER_BUTTON_PADDING": 8,
  "DATE_PICKER_HEADER_BUTTON_HORIZONTAL_SPACING": 16,
  "DATE_PICKER_HEADER_BUTTON_COLOR": "#000000",
  "DATE_PICKER_GRID_ITEM_WIDTH": 40,
  "DATE_PICKER_GRID_ITEM_HEIGHT": 40,
  "DATE_PICKER_GRID_ITEM_VERTICAL_PADDING": 8,
  "DATE_PICKER_GRID_ITEM_HORIZONTAL_PADDING": 0,
  "DATE_PICKER_WEEKDAYS_FONT_SIZE": 16,
  "DATE_PICKER_WEEKDAYS_FONT_LEADING": 24,
  "DATE_PICKER_WEEKDAYS_FONT_TRACKING": 0,
  "DATE_PICKER_WEEKDAYS_FONT_WEIGHT": 400,
  "DATE_PICKER_WEEKDAYS_FONT_CASE": "regular",
  "DATE_PICKER_WEEKDAYS_FONT_NUMBER_SPACING": "default",
  "DATE_PICKER_WEEKDAYS_FONT_SCALE": "paragraph-30",
  "DATE_PICKER_WEEKDAYS_FONT_FONT_FAMILY": "Square Sans Text",
  "DATE_PICKER_WEEKDAYS_COLOR_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_WEEKDAYS_COLOR_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_WEEKDAYS_COLOR_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "#080808",
  "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_NORMAL_STATE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "#080808",
  "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_DISABLED_STATE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "#e6f0ff",
  "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "#001533",
  "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_HOVER_STATE_COLOR": "#e6f0ff",
  "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "#cce1ff",
  "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "#002559",
  "DATE_PICKER_DATE_BACKGROUND_UNSELECTED_SELECTION_PRESSED_STATE_COLOR": "#cce1ff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_NORMAL_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_DISABLED_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "#e6f0ff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "#001533",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_HOVER_STATE_COLOR": "#e6f0ff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "#cce1ff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "#002559",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_FIRST_SELECTION_PRESSED_STATE_COLOR": "#cce1ff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_NORMAL_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_DISABLED_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "#e6f0ff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "#001533",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_HOVER_STATE_COLOR": "#e6f0ff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "#cce1ff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "#002559",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_MIDDLE_SELECTION_PRESSED_STATE_COLOR": "#cce1ff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_NORMAL_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_DISABLED_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "#e6f0ff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "#001533",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_HOVER_STATE_COLOR": "#e6f0ff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "#cce1ff",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "#002559",
  "DATE_PICKER_DATE_BACKGROUND_RANGE_LAST_SELECTION_PRESSED_STATE_COLOR": "#cce1ff",
  "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_NORMAL_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_DISABLED_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "#e6f0ff",
  "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "#001533",
  "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_HOVER_STATE_COLOR": "#e6f0ff",
  "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "#cce1ff",
  "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "#002559",
  "DATE_PICKER_DATE_BACKGROUND_SINGLE_SELECTION_PRESSED_STATE_COLOR": "#cce1ff",
  "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_NORMAL_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_DISABLED_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_HOVER_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_UNSELECTED_SELECTION_PRESSED_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_NORMAL_STATE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_DISABLED_STATE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_HOVER_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_RANGE_FIRST_SELECTION_PRESSED_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_NORMAL_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_DISABLED_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_HOVER_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_RANGE_MIDDLE_SELECTION_PRESSED_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_NORMAL_STATE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_DISABLED_STATE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_HOVER_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_RANGE_LAST_SELECTION_PRESSED_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_NORMAL_STATE_LIGHT_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_NORMAL_STATE_DARK_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_NORMAL_STATE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_DISABLED_STATE_LIGHT_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_DISABLED_STATE_DARK_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_DISABLED_STATE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_HOVER_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_HOVER_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_HOVER_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_PRESSED_STATE_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_PRESSED_STATE_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_TEXT_SINGLE_SELECTION_PRESSED_STATE_COLOR": "#000000",
  "DATE_PICKER_DATE_BORDER_RADIUS": 6,
  "DATE_PICKER_DATE_BORDER_NORMAL_STATE_BORDER": 2,
  "DATE_PICKER_DATE_BORDER_NORMAL_STATE_COLOR_LIGHT_MODE_COLOR": "#006aff",
  "DATE_PICKER_DATE_BORDER_NORMAL_STATE_COLOR_DARK_MODE_COLOR": "#006aff",
  "DATE_PICKER_DATE_BORDER_NORMAL_STATE_COLOR_COLOR": "#006aff",
  "DATE_PICKER_DATE_BORDER_NORMAL_STATE_OPACITY": 0,
  "DATE_PICKER_DATE_BORDER_FOCUSED_STATE_BORDER": 2,
  "DATE_PICKER_DATE_BORDER_FOCUSED_STATE_COLOR_LIGHT_MODE_COLOR": "#006aff",
  "DATE_PICKER_DATE_BORDER_FOCUSED_STATE_COLOR_DARK_MODE_COLOR": "#006aff",
  "DATE_PICKER_DATE_BORDER_FOCUSED_STATE_COLOR_COLOR": "#006aff",
  "DATE_PICKER_DATE_BORDER_FOCUSED_STATE_OPACITY": 1,
  "DATE_PICKER_DATE_BORDER_DISABLED_STATE_COLOR_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_DATE_BORDER_DISABLED_STATE_COLOR_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_DATE_BORDER_DISABLED_STATE_COLOR_COLOR": "#000000",
  "DATE_PICKER_TODAY_BORDER_WIDTH": 1,
  "DATE_PICKER_TODAY_BORDER_COLOR_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_TODAY_BORDER_COLOR_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_TODAY_BORDER_COLOR_COLOR": "#000000",
  "DATE_PICKER_TODAY_FONT_SIZE": 16,
  "DATE_PICKER_TODAY_FONT_LEADING": 24,
  "DATE_PICKER_TODAY_FONT_TRACKING": 0,
  "DATE_PICKER_TODAY_FONT_WEIGHT": 600,
  "DATE_PICKER_TODAY_FONT_CASE": "regular",
  "DATE_PICKER_TODAY_FONT_NUMBER_SPACING": "default",
  "DATE_PICKER_TODAY_FONT_SCALE": "paragraph-30",
  "DATE_PICKER_TODAY_FONT_FONT_FAMILY": "Square Sans Text",
  "DATE_PICKER_TODAY_LABEL_DISABLED_STATE_COLOR_LIGHT_MODE_COLOR": "#000000",
  "DATE_PICKER_TODAY_LABEL_DISABLED_STATE_COLOR_DARK_MODE_COLOR": "#ffffff",
  "DATE_PICKER_TODAY_LABEL_DISABLED_STATE_COLOR_COLOR": "#000000",
  "DATE_PICKER_MENU_TEXT_SIZE": 16,
  "DATE_PICKER_MENU_TEXT_LEADING": 24,
  "DATE_PICKER_MENU_TEXT_TRACKING": 0,
  "DATE_PICKER_MENU_TEXT_WEIGHT": 600,
  "DATE_PICKER_MENU_TEXT_CASE": "regular",
  "DATE_PICKER_MENU_TEXT_NUMBER_SPACING": "default",
  "DATE_PICKER_MENU_TEXT_SCALE": "paragraph-30",
  "DATE_PICKER_MENU_TEXT_FONT_FAMILY": "Square Sans Text",
  "DATE_PICKER_MENU_ROW_LABEL_SELECTED_STATE_TEXT_LIGHT_MODE_COLOR": "#005ad9",
  "DATE_PICKER_MENU_ROW_LABEL_SELECTED_STATE_TEXT_DARK_MODE_COLOR": "#4a95ff",
  "DATE_PICKER_MENU_ROW_LABEL_SELECTED_STATE_TEXT_COLOR": "#005ad9",
  "DATE_PICKER_MENU_ROW_HEIGHT": 48,
  "DATE_PICKER_MENU_ROW_WIDTH": 111,
  "DATE_PICKER_MENU_HORIZONTAL_SPACING": 32,
  "DATE_PICKER_MENU_VERTICAL_SPACING": 24,
  "DIVIDER_FILL_LIGHT_MODE_COLOR": "#000000",
  "DIVIDER_FILL_DARK_MODE_COLOR": "#ffffff",
  "DIVIDER_FILL_COLOR": "#000000",
  "DIVIDER_HEIGHT": 8,
  "DIVIDER_RADIUS": 2,
  "DIVIDER_EXTRA_SMALL_VARIANT_VERTICAL_PADDING": 0,
  "DIVIDER_SMALL_VARIANT_VERTICAL_PADDING": 8,
  "DIVIDER_MEDIUM_VARIANT_VERTICAL_PADDING": 16,
  "DIVIDER_LARGE_VARIANT_VERTICAL_PADDING": 32,
  "DROPDOWN_BUTTON_SMALL_SIZE_MINIMUM_HEIGHT": 40,
  "DROPDOWN_BUTTON_SMALL_SIZE_MINIMUM_WIDTH_MULTIPLIER": 1.5,
  "DROPDOWN_BUTTON_SMALL_SIZE_TEXT_SIZE": 14,
  "DROPDOWN_BUTTON_SMALL_SIZE_TEXT_LEADING": 22,
  "DROPDOWN_BUTTON_SMALL_SIZE_TEXT_TRACKING": 0,
  "DROPDOWN_BUTTON_SMALL_SIZE_TEXT_WEIGHT": 600,
  "DROPDOWN_BUTTON_SMALL_SIZE_TEXT_CASE": "regular",
  "DROPDOWN_BUTTON_SMALL_SIZE_TEXT_NUMBER_SPACING": "default",
  "DROPDOWN_BUTTON_SMALL_SIZE_TEXT_SCALE": "paragraph-20",
  "DROPDOWN_BUTTON_SMALL_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
  "DROPDOWN_BUTTON_SMALL_SIZE_CONTENT_SPACING": 8,
  "DROPDOWN_BUTTON_SMALL_SIZE_PRIMARY_RANK_HORIZONTAL_PADDING": 12,
  "DROPDOWN_BUTTON_SMALL_SIZE_PRIMARY_RANK_VERTICAL_PADDING": 9,
  "DROPDOWN_BUTTON_SMALL_SIZE_SECONDARY_RANK_HORIZONTAL_PADDING": 12,
  "DROPDOWN_BUTTON_SMALL_SIZE_SECONDARY_RANK_VERTICAL_PADDING": 9,
  "DROPDOWN_BUTTON_SMALL_SIZE_TERTIARY_RANK_HORIZONTAL_PADDING": 8,
  "DROPDOWN_BUTTON_SMALL_SIZE_TERTIARY_RANK_VERTICAL_PADDING": 9,
  "DROPDOWN_BUTTON_SMALL_SIZE_CARET_ICON_ASSET": "chevron-down",
  "DROPDOWN_BUTTON_SMALL_SIZE_CARET_ICON_WIDTH": 16,
  "DROPDOWN_BUTTON_SMALL_SIZE_CARET_ICON_HEIGHT": 16,
  "DROPDOWN_BUTTON_SMALL_SIZE_CARET_ICON_TINTABLE": true,
  "DROPDOWN_BUTTON_MEDIUM_SIZE_MINIMUM_HEIGHT": 48,
  "DROPDOWN_BUTTON_MEDIUM_SIZE_MINIMUM_WIDTH_MULTIPLIER": 1.5,
  "DROPDOWN_BUTTON_MEDIUM_SIZE_TEXT_SIZE": 16,
  "DROPDOWN_BUTTON_MEDIUM_SIZE_TEXT_LEADING": 24,
  "DROPDOWN_BUTTON_MEDIUM_SIZE_TEXT_TRACKING": 0,
  "DROPDOWN_BUTTON_MEDIUM_SIZE_TEXT_WEIGHT": 600,
  "DROPDOWN_BUTTON_MEDIUM_SIZE_TEXT_CASE": "regular",
  "DROPDOWN_BUTTON_MEDIUM_SIZE_TEXT_NUMBER_SPACING": "default",
  "DROPDOWN_BUTTON_MEDIUM_SIZE_TEXT_SCALE": "paragraph-30",
  "DROPDOWN_BUTTON_MEDIUM_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
  "DROPDOWN_BUTTON_MEDIUM_SIZE_CONTENT_SPACING": 8,
  "DROPDOWN_BUTTON_MEDIUM_SIZE_PRIMARY_RANK_HORIZONTAL_PADDING": 16,
  "DROPDOWN_BUTTON_MEDIUM_SIZE_PRIMARY_RANK_VERTICAL_PADDING": 12,
  "DROPDOWN_BUTTON_MEDIUM_SIZE_SECONDARY_RANK_HORIZONTAL_PADDING": 16,
  "DROPDOWN_BUTTON_MEDIUM_SIZE_SECONDARY_RANK_VERTICAL_PADDING": 12,
  "DROPDOWN_BUTTON_MEDIUM_SIZE_TERTIARY_RANK_HORIZONTAL_PADDING": 8,
  "DROPDOWN_BUTTON_MEDIUM_SIZE_TERTIARY_RANK_VERTICAL_PADDING": 12,
  "DROPDOWN_BUTTON_MEDIUM_SIZE_CARET_ICON_ASSET": "chevron-down",
  "DROPDOWN_BUTTON_MEDIUM_SIZE_CARET_ICON_WIDTH": 16,
  "DROPDOWN_BUTTON_MEDIUM_SIZE_CARET_ICON_HEIGHT": 16,
  "DROPDOWN_BUTTON_MEDIUM_SIZE_CARET_ICON_TINTABLE": true,
  "DROPDOWN_BUTTON_LARGE_SIZE_MINIMUM_HEIGHT": 64,
  "DROPDOWN_BUTTON_LARGE_SIZE_MINIMUM_WIDTH_MULTIPLIER": 1.5,
  "DROPDOWN_BUTTON_LARGE_SIZE_TEXT_SIZE": 16,
  "DROPDOWN_BUTTON_LARGE_SIZE_TEXT_LEADING": 24,
  "DROPDOWN_BUTTON_LARGE_SIZE_TEXT_TRACKING": 0,
  "DROPDOWN_BUTTON_LARGE_SIZE_TEXT_WEIGHT": 600,
  "DROPDOWN_BUTTON_LARGE_SIZE_TEXT_CASE": "regular",
  "DROPDOWN_BUTTON_LARGE_SIZE_TEXT_NUMBER_SPACING": "default",
  "DROPDOWN_BUTTON_LARGE_SIZE_TEXT_SCALE": "paragraph-30",
  "DROPDOWN_BUTTON_LARGE_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
  "DROPDOWN_BUTTON_LARGE_SIZE_CONTENT_SPACING": 8,
  "DROPDOWN_BUTTON_LARGE_SIZE_PRIMARY_RANK_HORIZONTAL_PADDING": 20,
  "DROPDOWN_BUTTON_LARGE_SIZE_PRIMARY_RANK_VERTICAL_PADDING": 20,
  "DROPDOWN_BUTTON_LARGE_SIZE_SECONDARY_RANK_HORIZONTAL_PADDING": 20,
  "DROPDOWN_BUTTON_LARGE_SIZE_SECONDARY_RANK_VERTICAL_PADDING": 20,
  "DROPDOWN_BUTTON_LARGE_SIZE_TERTIARY_RANK_HORIZONTAL_PADDING": 8,
  "DROPDOWN_BUTTON_LARGE_SIZE_TERTIARY_RANK_VERTICAL_PADDING": 20,
  "DROPDOWN_BUTTON_LARGE_SIZE_CARET_ICON_ASSET": "chevron-down",
  "DROPDOWN_BUTTON_LARGE_SIZE_CARET_ICON_WIDTH": 16,
  "DROPDOWN_BUTTON_LARGE_SIZE_CARET_ICON_HEIGHT": 16,
  "DROPDOWN_BUTTON_LARGE_SIZE_CARET_ICON_TINTABLE": true,
  "DROPDOWN_BUTTON_BORDER_RADIUS": 6,
  "DROPDOWN_BUTTON_FOCUS_RING_BUFFER_SIZE": 2,
  "DROPDOWN_BUTTON_FOCUS_RING_BORDER_SIZE": 2,
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#006aff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#006aff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "#006aff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_LABEL_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#005fe5",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#005fe5",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "#005fe5",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_LABEL_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#0055cc",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#0055cc",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "#0055cc",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_LABEL_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#006aff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#006aff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "#006aff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_LABEL_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_LABEL_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "#005ad9",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "#4a95ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_LABEL_COLOR": "#005ad9",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "#005ad9",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "#4a95ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_LABEL_COLOR": "#005ad9",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#cce1ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "#005ad9",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#002559",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "#4a95ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "#cce1ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_LABEL_COLOR": "#005ad9",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "#005ad9",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "#4a95ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_FOCUS_STATE_LABEL_COLOR": "#005ad9",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_LABEL_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "#005ad9",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "#4a95ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_NORMAL_STATE_LABEL_COLOR": "#005ad9",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "#005ad9",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_DARK_MODE_LABEL_COLOR": "#4a95ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_HOVER_STATE_LABEL_COLOR": "#005ad9",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#cce1ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "#005ad9",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#002559",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "#4a95ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "#cce1ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_PRESSED_STATE_LABEL_COLOR": "#005ad9",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "#005ad9",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "#4a95ff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_FOCUS_STATE_LABEL_COLOR": "#005ad9",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_BUTTON_NORMAL_VARIANT_TERTIARY_RANK_DISABLED_STATE_LABEL_COLOR": "#000000",
  "DROPDOWN_ICON_BUTTON_SMALL_SIZE_MINIMUM_HEIGHT": 40,
  "DROPDOWN_ICON_BUTTON_SMALL_SIZE_WIDTH_MULTIPLIER": 1,
  "DROPDOWN_ICON_BUTTON_SMALL_SIZE_PADDING_SIZE": 8,
  "DROPDOWN_ICON_BUTTON_MEDIUM_SIZE_MINIMUM_HEIGHT": 48,
  "DROPDOWN_ICON_BUTTON_MEDIUM_SIZE_WIDTH_MULTIPLIER": 1,
  "DROPDOWN_ICON_BUTTON_MEDIUM_SIZE_PADDING_SIZE": 12,
  "DROPDOWN_ICON_BUTTON_LARGE_SIZE_MINIMUM_HEIGHT": 64,
  "DROPDOWN_ICON_BUTTON_LARGE_SIZE_WIDTH_MULTIPLIER": 1,
  "DROPDOWN_ICON_BUTTON_LARGE_SIZE_PADDING_SIZE": 20,
  "DROPDOWN_ICON_BUTTON_BORDER_RADIUS": 6,
  "DROPDOWN_ICON_BUTTON_FOCUS_RING_BUFFER_SIZE": 2,
  "DROPDOWN_ICON_BUTTON_FOCUS_RING_BORDER_SIZE": 2,
  "DROPDOWN_ICON_BUTTON_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_ICON_BUTTON_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "DROPDOWN_ICON_BUTTON_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "DROPDOWN_ICON_BUTTON_NORMAL_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "DROPDOWN_ICON_BUTTON_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_ICON_BUTTON_NORMAL_STATE_ICON_COLOR": "#000000",
  "DROPDOWN_ICON_BUTTON_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "DROPDOWN_ICON_BUTTON_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "DROPDOWN_ICON_BUTTON_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "DROPDOWN_ICON_BUTTON_HOVER_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "DROPDOWN_ICON_BUTTON_HOVER_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "DROPDOWN_ICON_BUTTON_HOVER_STATE_ICON_COLOR": "#000000",
  "DROPDOWN_ICON_BUTTON_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#cce1ff",
  "DROPDOWN_ICON_BUTTON_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "DROPDOWN_ICON_BUTTON_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#002559",
  "DROPDOWN_ICON_BUTTON_PRESSED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "DROPDOWN_ICON_BUTTON_PRESSED_STATE_BACKGROUND_COLOR": "#cce1ff",
  "DROPDOWN_ICON_BUTTON_PRESSED_STATE_ICON_COLOR": "#000000",
  "DROPDOWN_ICON_BUTTON_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "DROPDOWN_ICON_BUTTON_FOCUS_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "DROPDOWN_ICON_BUTTON_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "DROPDOWN_ICON_BUTTON_FOCUS_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "DROPDOWN_ICON_BUTTON_FOCUS_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "DROPDOWN_ICON_BUTTON_FOCUS_STATE_ICON_COLOR": "#000000",
  "DROPDOWN_ICON_BUTTON_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_ICON_BUTTON_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "DROPDOWN_ICON_BUTTON_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "DROPDOWN_ICON_BUTTON_DISABLED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "DROPDOWN_ICON_BUTTON_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "DROPDOWN_ICON_BUTTON_DISABLED_STATE_ICON_COLOR": "#000000",
  "EMPTY_STATE_HEADING_LIGHT_MODE_COLOR": "#000000",
  "EMPTY_STATE_HEADING_DARK_MODE_COLOR": "#ffffff",
  "EMPTY_STATE_HEADING_TEXT_SIZE": 19,
  "EMPTY_STATE_HEADING_TEXT_LEADING": 26,
  "EMPTY_STATE_HEADING_TEXT_TRACKING": 0,
  "EMPTY_STATE_HEADING_TEXT_WEIGHT": 700,
  "EMPTY_STATE_HEADING_TEXT_CASE": "regular",
  "EMPTY_STATE_HEADING_TEXT_NUMBER_SPACING": "default",
  "EMPTY_STATE_HEADING_TEXT_SCALE": "heading-20",
  "EMPTY_STATE_HEADING_TEXT_FONT_FAMILY": "Square Sans Display",
  "EMPTY_STATE_HEADING_TEXT_IS_HEADER": true,
  "EMPTY_STATE_HEADING_COLOR": "#000000",
  "EMPTY_STATE_PARAGRAPH_LIGHT_MODE_COLOR": "#000000",
  "EMPTY_STATE_PARAGRAPH_DARK_MODE_COLOR": "#ffffff",
  "EMPTY_STATE_PARAGRAPH_TEXT_SIZE": 16,
  "EMPTY_STATE_PARAGRAPH_TEXT_LEADING": 24,
  "EMPTY_STATE_PARAGRAPH_TEXT_TRACKING": 0,
  "EMPTY_STATE_PARAGRAPH_TEXT_WEIGHT": 400,
  "EMPTY_STATE_PARAGRAPH_TEXT_CASE": "regular",
  "EMPTY_STATE_PARAGRAPH_TEXT_NUMBER_SPACING": "default",
  "EMPTY_STATE_PARAGRAPH_TEXT_SCALE": "paragraph-30",
  "EMPTY_STATE_PARAGRAPH_TEXT_FONT_FAMILY": "Square Sans Text",
  "EMPTY_STATE_PARAGRAPH_VERTICAL_SPACING": 8,
  "EMPTY_STATE_PARAGRAPH_COLOR": "#000000",
  "EMPTY_STATE_BUTTON_GROUP_VERTICAL_SPACING": 32,
  "EMPTY_STATE_HORIZONTAL_PADDING": 32,
  "EMPTY_STATE_VERTICAL_PADDING": 32,
  "EMPTY_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#ffffff",
  "EMPTY_STATE_BACKGROUND_DARK_MODE_COLOR": "#141414",
  "EMPTY_STATE_BACKGROUND_COLOR": "#ffffff",
  "EMPTY_STATE_BORDER_LIGHT_MODE_COLOR": "#000000",
  "EMPTY_STATE_BORDER_DARK_MODE_COLOR": "#ffffff",
  "EMPTY_STATE_BORDER_RADIUS": 6,
  "EMPTY_STATE_BORDER_WIDTH": 1,
  "EMPTY_STATE_BORDER_COLOR": "#000000",
  "FIELD_BORDER_RADIUS": 6,
  "FIELD_BORDER_SIZE": 1,
  "FIELD_ACTION_TEXT_SIZE": 14,
  "FIELD_ACTION_TEXT_LEADING": 22,
  "FIELD_ACTION_TEXT_TRACKING": 0,
  "FIELD_ACTION_TEXT_WEIGHT": 600,
  "FIELD_ACTION_TEXT_CASE": "regular",
  "FIELD_ACTION_TEXT_NUMBER_SPACING": "default",
  "FIELD_ACTION_TEXT_SCALE": "paragraph-20",
  "FIELD_ACTION_TEXT_FONT_FAMILY": "Square Sans Text",
  "FIELD_ACTION_TEXT_COLOR": "#006aff",
  "FIELD_ACTION_VERTICAL_PADDING_SIZE": 8,
  "FIELD_ERROR_MESSAGE_ICON_ASSET": "exclamation-circle",
  "FIELD_ERROR_MESSAGE_ICON_WIDTH": 24,
  "FIELD_ERROR_MESSAGE_ICON_HEIGHT": 24,
  "FIELD_ERROR_MESSAGE_ICON_TINTABLE": true,
  "FIELD_ERROR_MESSAGE_TEXT_SIZE": 14,
  "FIELD_ERROR_MESSAGE_TEXT_LEADING": 22,
  "FIELD_ERROR_MESSAGE_TEXT_TRACKING": 0,
  "FIELD_ERROR_MESSAGE_TEXT_WEIGHT": 400,
  "FIELD_ERROR_MESSAGE_TEXT_CASE": "regular",
  "FIELD_ERROR_MESSAGE_TEXT_NUMBER_SPACING": "default",
  "FIELD_ERROR_MESSAGE_TEXT_SCALE": "paragraph-20",
  "FIELD_ERROR_MESSAGE_TEXT_FONT_FAMILY": "Square Sans Text",
  "FIELD_ERROR_MESSAGE_TEXT_VERTICAL_SPACING": 8,
  "FIELD_ERROR_MESSAGE_TEXT_COLOR": "#bf0020",
  "FIELD_HELPER_TEXT_SIZE": 14,
  "FIELD_HELPER_TEXT_LEADING": 22,
  "FIELD_HELPER_TEXT_TRACKING": 0,
  "FIELD_HELPER_TEXT_WEIGHT": 400,
  "FIELD_HELPER_TEXT_CASE": "regular",
  "FIELD_HELPER_TEXT_NUMBER_SPACING": "default",
  "FIELD_HELPER_TEXT_SCALE": "paragraph-20",
  "FIELD_HELPER_TEXT_FONT_FAMILY": "Square Sans Text",
  "FIELD_HELPER_TEXT_HORIZONTAL_SPACING": 0,
  "FIELD_HELPER_TEXT_VERTICAL_SPACING": 8,
  "FIELD_HELPER_TEXT_TEXT_COLOR": "#000000",
  "FIELD_ICON_ASSET": "i-circle",
  "FIELD_ICON_WIDTH": 24,
  "FIELD_ICON_HEIGHT": 24,
  "FIELD_ICON_TINTABLE": true,
  "FIELD_IMAGE_ACCESSORY_SPACING_LEFT_SIZE": 12,
  "FIELD_INPUT_SIZE": 16,
  "FIELD_INPUT_LEADING": 24,
  "FIELD_INPUT_TRACKING": 0,
  "FIELD_INPUT_WEIGHT": 400,
  "FIELD_INPUT_CASE": "regular",
  "FIELD_INPUT_NUMBER_SPACING": "default",
  "FIELD_INPUT_SCALE": "paragraph-30",
  "FIELD_INPUT_FONT_FAMILY": "Square Sans Text",
  "FIELD_TRAILING_ACCESSORY_BUFFER_SIZE": 16,
  "FIELD_TRAILING_ACCESSORY_HEIGHT": 48,
  "FIELD_TRAILING_ACCESSORY_WIDTH": 48,
  "FIELD_TRAILING_ACCESSORY_POSITION_BOTTOM_SIZE": 8,
  "FIELD_TRAILING_ACCESSORY_POSITION_RIGHT_SIZE": 0,
  "FIELD_LIGHT_MODE_ACTION_TEXT_COLOR": "#006aff",
  "FIELD_LIGHT_MODE_ERROR_MESSAGE_TEXT_COLOR": "#bf0020",
  "FIELD_LIGHT_MODE_HELPER_TEXT_TEXT_COLOR": "#000000",
  "FIELD_LIGHT_MODE_PLACEHOLDER_TEXT_COLOR": "#000000",
  "FIELD_DARK_MODE_ACTION_TEXT_COLOR": "#006aff",
  "FIELD_DARK_MODE_ERROR_MESSAGE_TEXT_COLOR": "#ff5a76",
  "FIELD_DARK_MODE_HELPER_TEXT_TEXT_COLOR": "#ffffff",
  "FIELD_DARK_MODE_PLACEHOLDER_TEXT_COLOR": "#ffffff",
  "FIELD_EMPTY_PHASE_LABEL_TEXT_SIZE": 16,
  "FIELD_EMPTY_PHASE_LABEL_TEXT_LEADING": 24,
  "FIELD_EMPTY_PHASE_LABEL_TEXT_TRACKING": 0,
  "FIELD_EMPTY_PHASE_LABEL_TEXT_WEIGHT": 400,
  "FIELD_EMPTY_PHASE_LABEL_TEXT_CASE": "regular",
  "FIELD_EMPTY_PHASE_LABEL_TEXT_NUMBER_SPACING": "default",
  "FIELD_EMPTY_PHASE_LABEL_TEXT_SCALE": "paragraph-30",
  "FIELD_EMPTY_PHASE_LABEL_TEXT_FONT_FAMILY": "Square Sans Text",
  "FIELD_EMPTY_PHASE_HORIZONTAL_PADDING_SIZE": 16,
  "FIELD_EMPTY_PHASE_VERTICAL_PADDING_SIZE": 20,
  "FIELD_FLOAT_PHASE_LABEL_TEXT_SIZE": 14,
  "FIELD_FLOAT_PHASE_LABEL_TEXT_LEADING": 22,
  "FIELD_FLOAT_PHASE_LABEL_TEXT_TRACKING": 0,
  "FIELD_FLOAT_PHASE_LABEL_TEXT_WEIGHT": 500,
  "FIELD_FLOAT_PHASE_LABEL_TEXT_CASE": "regular",
  "FIELD_FLOAT_PHASE_LABEL_TEXT_NUMBER_SPACING": "default",
  "FIELD_FLOAT_PHASE_LABEL_TEXT_SCALE": "paragraph-20",
  "FIELD_FLOAT_PHASE_LABEL_TEXT_FONT_FAMILY": "Square Sans Text",
  "FIELD_FLOAT_PHASE_LABEL_MARGIN_TOP_SIZE": 8,
  "FIELD_FLOAT_PHASE_LABEL_MARGIN_BOTTOM_SIZE": 2,
  "FIELD_FLOAT_PHASE_HORIZONTAL_PADDING_SIZE": 16,
  "FIELD_FLOAT_PHASE_VERTICAL_PADDING_SIZE": 8,
  "FIELD_NORMAL_STATE_EMPTY_PHASE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "FIELD_NORMAL_STATE_EMPTY_PHASE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "FIELD_NORMAL_STATE_EMPTY_PHASE_LABEL_COLOR": "#000000",
  "FIELD_NORMAL_STATE_FLOAT_PHASE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "FIELD_NORMAL_STATE_FLOAT_PHASE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "FIELD_NORMAL_STATE_FLOAT_PHASE_LABEL_COLOR": "#000000",
  "FIELD_NORMAL_STATE_NORMAL_VALIDITY_LIGHT_MODE_BORDER_COLOR": "#000000",
  "FIELD_NORMAL_STATE_NORMAL_VALIDITY_DARK_MODE_BORDER_COLOR": "#ffffff",
  "FIELD_NORMAL_STATE_NORMAL_VALIDITY_BORDER_COLOR": "#000000",
  "FIELD_NORMAL_STATE_INVALID_VALIDITY_LIGHT_MODE_BORDER_COLOR": "#cc0023",
  "FIELD_NORMAL_STATE_INVALID_VALIDITY_DARK_MODE_BORDER_COLOR": "#cc0023",
  "FIELD_NORMAL_STATE_INVALID_VALIDITY_BORDER_COLOR": "#cc0023",
  "FIELD_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#ffffff",
  "FIELD_NORMAL_STATE_LIGHT_MODE_INPUT_COLOR": "#000000",
  "FIELD_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#080808",
  "FIELD_NORMAL_STATE_DARK_MODE_INPUT_COLOR": "#ffffff",
  "FIELD_NORMAL_STATE_BACKGROUND_COLOR": "#ffffff",
  "FIELD_NORMAL_STATE_INPUT_COLOR": "#000000",
  "FIELD_HOVER_STATE_EMPTY_PHASE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "FIELD_HOVER_STATE_EMPTY_PHASE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "FIELD_HOVER_STATE_EMPTY_PHASE_LABEL_COLOR": "#000000",
  "FIELD_HOVER_STATE_FLOAT_PHASE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "FIELD_HOVER_STATE_FLOAT_PHASE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "FIELD_HOVER_STATE_FLOAT_PHASE_LABEL_COLOR": "#000000",
  "FIELD_HOVER_STATE_NORMAL_VALIDITY_LIGHT_MODE_BORDER_COLOR": "#006aff",
  "FIELD_HOVER_STATE_NORMAL_VALIDITY_DARK_MODE_BORDER_COLOR": "#006aff",
  "FIELD_HOVER_STATE_NORMAL_VALIDITY_BORDER_COLOR": "#006aff",
  "FIELD_HOVER_STATE_INVALID_VALIDITY_LIGHT_MODE_BORDER_COLOR": "#006aff",
  "FIELD_HOVER_STATE_INVALID_VALIDITY_DARK_MODE_BORDER_COLOR": "#006aff",
  "FIELD_HOVER_STATE_INVALID_VALIDITY_BORDER_COLOR": "#006aff",
  "FIELD_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#ffffff",
  "FIELD_HOVER_STATE_LIGHT_MODE_INPUT_COLOR": "#000000",
  "FIELD_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#080808",
  "FIELD_HOVER_STATE_DARK_MODE_INPUT_COLOR": "#ffffff",
  "FIELD_HOVER_STATE_BACKGROUND_COLOR": "#ffffff",
  "FIELD_HOVER_STATE_INPUT_COLOR": "#000000",
  "FIELD_FOCUS_STATE_BORDER_SIZE": 2,
  "FIELD_FOCUS_STATE_FLOAT_PHASE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "FIELD_FOCUS_STATE_FLOAT_PHASE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "FIELD_FOCUS_STATE_FLOAT_PHASE_LABEL_COLOR": "#000000",
  "FIELD_FOCUS_STATE_NORMAL_VALIDITY_LIGHT_MODE_BORDER_COLOR": "#006aff",
  "FIELD_FOCUS_STATE_NORMAL_VALIDITY_DARK_MODE_BORDER_COLOR": "#006aff",
  "FIELD_FOCUS_STATE_NORMAL_VALIDITY_BORDER_COLOR": "#006aff",
  "FIELD_FOCUS_STATE_INVALID_VALIDITY_LIGHT_MODE_BORDER_COLOR": "#006aff",
  "FIELD_FOCUS_STATE_INVALID_VALIDITY_DARK_MODE_BORDER_COLOR": "#006aff",
  "FIELD_FOCUS_STATE_INVALID_VALIDITY_BORDER_COLOR": "#006aff",
  "FIELD_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#ffffff",
  "FIELD_FOCUS_STATE_LIGHT_MODE_INPUT_COLOR": "#000000",
  "FIELD_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#080808",
  "FIELD_FOCUS_STATE_DARK_MODE_INPUT_COLOR": "#ffffff",
  "FIELD_FOCUS_STATE_BACKGROUND_COLOR": "#ffffff",
  "FIELD_FOCUS_STATE_INPUT_COLOR": "#000000",
  "FIELD_DISABLED_STATE_EMPTY_PHASE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "FIELD_DISABLED_STATE_EMPTY_PHASE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "FIELD_DISABLED_STATE_EMPTY_PHASE_LABEL_COLOR": "#000000",
  "FIELD_DISABLED_STATE_FLOAT_PHASE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "FIELD_DISABLED_STATE_FLOAT_PHASE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "FIELD_DISABLED_STATE_FLOAT_PHASE_LABEL_COLOR": "#000000",
  "FIELD_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "FIELD_DISABLED_STATE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "FIELD_DISABLED_STATE_LIGHT_MODE_INPUT_COLOR": "#000000",
  "FIELD_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "FIELD_DISABLED_STATE_DARK_MODE_BORDER_COLOR": "#ffffff",
  "FIELD_DISABLED_STATE_DARK_MODE_INPUT_COLOR": "#ffffff",
  "FIELD_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "FIELD_DISABLED_STATE_BORDER_COLOR": "#000000",
  "FIELD_DISABLED_STATE_INPUT_COLOR": "#000000",
  "FIELD_PLACEHOLDER_TEXT_COLOR": "#000000",
  "FILTER_BUTTON_BORDER_RADIUS": 6,
  "FILTER_BUTTON_BORDER_SIZE": 1,
  "FILTER_BUTTON_FEEDBACK_MAXIMUM": 99,
  "FILTER_BUTTON_LABEL_CONTENT_SPACING": 8,
  "FILTER_BUTTON_ICON_FEEDBACK_TRAILING_PADDING": 2,
  "FILTER_BUTTON_ICON_CONTENT_SPACING": 4,
  "FILTER_BUTTON_SMALL_SIZE_MINIMUM_HEIGHT": 40,
  "FILTER_BUTTON_SMALL_SIZE_MINIMUM_WIDTH_MULTIPLIER": 1,
  "FILTER_BUTTON_SMALL_SIZE_LABEL_TEXT_SIZE": 14,
  "FILTER_BUTTON_SMALL_SIZE_LABEL_TEXT_LEADING": 22,
  "FILTER_BUTTON_SMALL_SIZE_LABEL_TEXT_TRACKING": 0,
  "FILTER_BUTTON_SMALL_SIZE_LABEL_TEXT_WEIGHT": 400,
  "FILTER_BUTTON_SMALL_SIZE_LABEL_TEXT_CASE": "regular",
  "FILTER_BUTTON_SMALL_SIZE_LABEL_TEXT_NUMBER_SPACING": "default",
  "FILTER_BUTTON_SMALL_SIZE_LABEL_TEXT_SCALE": "paragraph-20",
  "FILTER_BUTTON_SMALL_SIZE_LABEL_TEXT_FONT_FAMILY": "Square Sans Text",
  "FILTER_BUTTON_SMALL_SIZE_LABEL_HORIZONTAL_PADDING": 12,
  "FILTER_BUTTON_SMALL_SIZE_LABEL_VERTICAL_PADDING": 9,
  "FILTER_BUTTON_SMALL_SIZE_FEEDBACK_TEXT_SIZE": 14,
  "FILTER_BUTTON_SMALL_SIZE_FEEDBACK_TEXT_LEADING": 22,
  "FILTER_BUTTON_SMALL_SIZE_FEEDBACK_TEXT_TRACKING": 0,
  "FILTER_BUTTON_SMALL_SIZE_FEEDBACK_TEXT_WEIGHT": 600,
  "FILTER_BUTTON_SMALL_SIZE_FEEDBACK_TEXT_CASE": "regular",
  "FILTER_BUTTON_SMALL_SIZE_FEEDBACK_TEXT_NUMBER_SPACING": "default",
  "FILTER_BUTTON_SMALL_SIZE_FEEDBACK_TEXT_SCALE": "paragraph-20",
  "FILTER_BUTTON_SMALL_SIZE_FEEDBACK_TEXT_FONT_FAMILY": "Square Sans Text",
  "FILTER_BUTTON_SMALL_SIZE_ICON_TEXT_SIZE": 16,
  "FILTER_BUTTON_SMALL_SIZE_ICON_TEXT_LEADING": 24,
  "FILTER_BUTTON_SMALL_SIZE_ICON_TEXT_TRACKING": 0,
  "FILTER_BUTTON_SMALL_SIZE_ICON_TEXT_WEIGHT": 600,
  "FILTER_BUTTON_SMALL_SIZE_ICON_TEXT_CASE": "regular",
  "FILTER_BUTTON_SMALL_SIZE_ICON_TEXT_NUMBER_SPACING": "default",
  "FILTER_BUTTON_SMALL_SIZE_ICON_TEXT_SCALE": "paragraph-30",
  "FILTER_BUTTON_SMALL_SIZE_ICON_TEXT_FONT_FAMILY": "Square Sans Text",
  "FILTER_BUTTON_SMALL_SIZE_ICON_HORIZONTAL_PADDING": 8,
  "FILTER_BUTTON_SMALL_SIZE_ICON_VERTICAL_PADDING": 8,
  "FILTER_BUTTON_MEDIUM_SIZE_MINIMUM_HEIGHT": 48,
  "FILTER_BUTTON_MEDIUM_SIZE_MINIMUM_WIDTH_MULTIPLIER": 1,
  "FILTER_BUTTON_MEDIUM_SIZE_LABEL_TEXT_SIZE": 16,
  "FILTER_BUTTON_MEDIUM_SIZE_LABEL_TEXT_LEADING": 24,
  "FILTER_BUTTON_MEDIUM_SIZE_LABEL_TEXT_TRACKING": 0,
  "FILTER_BUTTON_MEDIUM_SIZE_LABEL_TEXT_WEIGHT": 400,
  "FILTER_BUTTON_MEDIUM_SIZE_LABEL_TEXT_CASE": "regular",
  "FILTER_BUTTON_MEDIUM_SIZE_LABEL_TEXT_NUMBER_SPACING": "default",
  "FILTER_BUTTON_MEDIUM_SIZE_LABEL_TEXT_SCALE": "paragraph-30",
  "FILTER_BUTTON_MEDIUM_SIZE_LABEL_TEXT_FONT_FAMILY": "Square Sans Text",
  "FILTER_BUTTON_MEDIUM_SIZE_LABEL_HORIZONTAL_PADDING": 16,
  "FILTER_BUTTON_MEDIUM_SIZE_LABEL_VERTICAL_PADDING": 12,
  "FILTER_BUTTON_MEDIUM_SIZE_FEEDBACK_TEXT_SIZE": 16,
  "FILTER_BUTTON_MEDIUM_SIZE_FEEDBACK_TEXT_LEADING": 24,
  "FILTER_BUTTON_MEDIUM_SIZE_FEEDBACK_TEXT_TRACKING": 0,
  "FILTER_BUTTON_MEDIUM_SIZE_FEEDBACK_TEXT_WEIGHT": 600,
  "FILTER_BUTTON_MEDIUM_SIZE_FEEDBACK_TEXT_CASE": "regular",
  "FILTER_BUTTON_MEDIUM_SIZE_FEEDBACK_TEXT_NUMBER_SPACING": "default",
  "FILTER_BUTTON_MEDIUM_SIZE_FEEDBACK_TEXT_SCALE": "paragraph-30",
  "FILTER_BUTTON_MEDIUM_SIZE_FEEDBACK_TEXT_FONT_FAMILY": "Square Sans Text",
  "FILTER_BUTTON_MEDIUM_SIZE_ICON_TEXT_SIZE": 16,
  "FILTER_BUTTON_MEDIUM_SIZE_ICON_TEXT_LEADING": 24,
  "FILTER_BUTTON_MEDIUM_SIZE_ICON_TEXT_TRACKING": 0,
  "FILTER_BUTTON_MEDIUM_SIZE_ICON_TEXT_WEIGHT": 600,
  "FILTER_BUTTON_MEDIUM_SIZE_ICON_TEXT_CASE": "regular",
  "FILTER_BUTTON_MEDIUM_SIZE_ICON_TEXT_NUMBER_SPACING": "default",
  "FILTER_BUTTON_MEDIUM_SIZE_ICON_TEXT_SCALE": "paragraph-30",
  "FILTER_BUTTON_MEDIUM_SIZE_ICON_TEXT_FONT_FAMILY": "Square Sans Text",
  "FILTER_BUTTON_MEDIUM_SIZE_ICON_HORIZONTAL_PADDING": 12,
  "FILTER_BUTTON_MEDIUM_SIZE_ICON_VERTICAL_PADDING": 12,
  "FILTER_BUTTON_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#000000",
  "FILTER_BUTTON_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "#000000",
  "FILTER_BUTTON_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "FILTER_BUTTON_NORMAL_STATE_LABEL_LIGHT_MODE_COLOR": "#000000",
  "FILTER_BUTTON_NORMAL_STATE_LABEL_DARK_MODE_COLOR": "#ffffff",
  "FILTER_BUTTON_NORMAL_STATE_LABEL_COLOR": "#000000",
  "FILTER_BUTTON_NORMAL_STATE_FEEDBACK_LIGHT_MODE_COLOR": "#000000",
  "FILTER_BUTTON_NORMAL_STATE_FEEDBACK_DARK_MODE_COLOR": "#ffffff",
  "FILTER_BUTTON_NORMAL_STATE_FEEDBACK_COLOR": "#000000",
  "FILTER_BUTTON_NORMAL_STATE_BORDER_LIGHT_MODE_COLOR": "#000000",
  "FILTER_BUTTON_NORMAL_STATE_BORDER_DARK_MODE_COLOR": "#ffffff",
  "FILTER_BUTTON_NORMAL_STATE_BORDER_COLOR": "#000000",
  "FILTER_BUTTON_HOVER_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#000000",
  "FILTER_BUTTON_HOVER_STATE_BACKGROUND_DARK_MODE_COLOR": "#ffffff",
  "FILTER_BUTTON_HOVER_STATE_BACKGROUND_COLOR": "#000000",
  "FILTER_BUTTON_HOVER_STATE_LABEL_LIGHT_MODE_COLOR": "#000000",
  "FILTER_BUTTON_HOVER_STATE_LABEL_DARK_MODE_COLOR": "#ffffff",
  "FILTER_BUTTON_HOVER_STATE_LABEL_COLOR": "#000000",
  "FILTER_BUTTON_HOVER_STATE_FEEDBACK_LIGHT_MODE_COLOR": "#000000",
  "FILTER_BUTTON_HOVER_STATE_FEEDBACK_DARK_MODE_COLOR": "#ffffff",
  "FILTER_BUTTON_HOVER_STATE_FEEDBACK_COLOR": "#000000",
  "FILTER_BUTTON_HOVER_STATE_BORDER_LIGHT_MODE_COLOR": "#000000",
  "FILTER_BUTTON_HOVER_STATE_BORDER_DARK_MODE_COLOR": "#ffffff",
  "FILTER_BUTTON_HOVER_STATE_BORDER_COLOR": "#000000",
  "FILTER_BUTTON_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#000000",
  "FILTER_BUTTON_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "#000000",
  "FILTER_BUTTON_PRESSED_STATE_BACKGROUND_COLOR": "#000000",
  "FILTER_BUTTON_PRESSED_STATE_LABEL_LIGHT_MODE_COLOR": "#000000",
  "FILTER_BUTTON_PRESSED_STATE_LABEL_DARK_MODE_COLOR": "#ffffff",
  "FILTER_BUTTON_PRESSED_STATE_LABEL_COLOR": "#000000",
  "FILTER_BUTTON_PRESSED_STATE_FEEDBACK_LIGHT_MODE_COLOR": "#000000",
  "FILTER_BUTTON_PRESSED_STATE_FEEDBACK_DARK_MODE_COLOR": "#ffffff",
  "FILTER_BUTTON_PRESSED_STATE_FEEDBACK_COLOR": "#000000",
  "FILTER_BUTTON_PRESSED_STATE_BORDER_LIGHT_MODE_COLOR": "#000000",
  "FILTER_BUTTON_PRESSED_STATE_BORDER_DARK_MODE_COLOR": "#ffffff",
  "FILTER_BUTTON_PRESSED_STATE_BORDER_COLOR": "#000000",
  "FILTER_BUTTON_DISABLED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#000000",
  "FILTER_BUTTON_DISABLED_STATE_BACKGROUND_DARK_MODE_COLOR": "#000000",
  "FILTER_BUTTON_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "FILTER_BUTTON_DISABLED_STATE_LABEL_LIGHT_MODE_COLOR": "#000000",
  "FILTER_BUTTON_DISABLED_STATE_LABEL_DARK_MODE_COLOR": "#ffffff",
  "FILTER_BUTTON_DISABLED_STATE_LABEL_COLOR": "#000000",
  "FILTER_BUTTON_DISABLED_STATE_FEEDBACK_LIGHT_MODE_COLOR": "#000000",
  "FILTER_BUTTON_DISABLED_STATE_FEEDBACK_DARK_MODE_COLOR": "#ffffff",
  "FILTER_BUTTON_DISABLED_STATE_FEEDBACK_COLOR": "#000000",
  "FILTER_BUTTON_DISABLED_STATE_BORDER_LIGHT_MODE_COLOR": "#000000",
  "FILTER_BUTTON_DISABLED_STATE_BORDER_DARK_MODE_COLOR": "#ffffff",
  "FILTER_BUTTON_DISABLED_STATE_BORDER_COLOR": "#000000",
  "FOOTER_VERTICAL_PADDING_SIZE": 16,
  "HEADER_TOP_PADDING_COMPACT_SIZE_CLASS_SIZE": 16,
  "HEADER_TOP_PADDING_NORMAL_SIZE_CLASS_SIZE": 24,
  "HEADER_TOP_PADDING_WIDE_SIZE_CLASS_SIZE": 24,
  "HEADER_TOP_PADDING_SIZE": 24,
  "HEADER_BOTTOM_PADDING_COMPACT_SIZE_CLASS_SIZE": 16,
  "HEADER_BOTTOM_PADDING_NORMAL_SIZE_CLASS_SIZE": 16,
  "HEADER_BOTTOM_PADDING_WIDE_SIZE_CLASS_SIZE": 16,
  "HEADER_BOTTOM_PADDING_SIZE": 16,
  "HEADER_HORIZONTAL_PADDING_COMPACT_SIZE_CLASS_SIZE": 16,
  "HEADER_HORIZONTAL_PADDING_NORMAL_SIZE_CLASS_SIZE": 24,
  "HEADER_HORIZONTAL_PADDING_WIDE_SIZE_CLASS_SIZE": 24,
  "HEADER_HORIZONTAL_PADDING_SIZE": 16,
  "HEADER_NAV_ICON_BUTTON_SPACING_BUTTOM_SIZE": 24,
  "HEADER_NAV_ICON_BUTTON_SPACING_BOTTOM_SIZE": 24,
  "HEADER_CLOSE_BUTTON_ICON_ASSET": "x",
  "HEADER_CLOSE_BUTTON_ICON_WIDTH": 24,
  "HEADER_CLOSE_BUTTON_ICON_HEIGHT": 24,
  "HEADER_CLOSE_BUTTON_ICON_TINTABLE": true,
  "HEADER_MAIN_TEXT_HORIZONTAL_SPACING": 16,
  "HEADER_MAIN_TEXT_MINIMUM_WIDTH": 64,
  "HEADER_MAIN_TEXT_TRANSITION_DURATION": 160,
  "HEADER_MAIN_TEXT_NORMAL_PHASE_SPACING_TOP_SIZE": 8,
  "HEADER_MAIN_TEXT_LIGHT_MODE_TEXT_COLOR": "#000000",
  "HEADER_MAIN_TEXT_DARK_MODE_TEXT_COLOR": "#ffffff",
  "HEADER_MAIN_TEXT_TEXT_COLOR": "#000000",
  "HEADER_SUB_TEXT_SPACING_BOTTOM_SIZE": 8,
  "HEADER_SUB_TEXT_LIGHT_MODE_TEXT_COLOR": "#000000",
  "HEADER_SUB_TEXT_DARK_MODE_TEXT_COLOR": "#ffffff",
  "HEADER_SUB_TEXT_TEXT_COLOR": "#000000",
  "HEADER_DIVIDER_LIGHT_MODE_COLOR": "#000000",
  "HEADER_DIVIDER_DARK_MODE_COLOR": "#ffffff",
  "HEADER_DIVIDER_SIZE": 1,
  "HEADER_DIVIDER_COLOR": "#000000",
  "ICON_BUTTON_SMALL_SIZE_MINIMUM_HEIGHT": 40,
  "ICON_BUTTON_SMALL_SIZE_WIDTH_MULTIPLIER": 1,
  "ICON_BUTTON_SMALL_SIZE_PADDING_SIZE": 8,
  "ICON_BUTTON_MEDIUM_SIZE_MINIMUM_HEIGHT": 48,
  "ICON_BUTTON_MEDIUM_SIZE_WIDTH_MULTIPLIER": 1,
  "ICON_BUTTON_MEDIUM_SIZE_PADDING_SIZE": 12,
  "ICON_BUTTON_LARGE_SIZE_MINIMUM_HEIGHT": 64,
  "ICON_BUTTON_LARGE_SIZE_WIDTH_MULTIPLIER": 1,
  "ICON_BUTTON_LARGE_SIZE_PADDING_SIZE": 20,
  "ICON_BUTTON_NORMAL_SIZE_MINIMUM_WIDTH": 48,
  "ICON_BUTTON_NORMAL_SIZE_MINIMUM_HEIGHT": 48,
  "ICON_BUTTON_NORMAL_SIZE_PADDING_SIZE": 16,
  "ICON_BUTTON_COMPACT_SIZE_MINIMUM_WIDTH": 40,
  "ICON_BUTTON_COMPACT_SIZE_MINIMUM_HEIGHT": 40,
  "ICON_BUTTON_COMPACT_SIZE_MINIMUM_PADDING_SIZE": 12,
  "ICON_BUTTON_COMPACT_SIZE_PADDING_SIZE": 12,
  "ICON_BUTTON_MINIMUM_WIDTH": 48,
  "ICON_BUTTON_MINIMUM_HEIGHT": 48,
  "ICON_BUTTON_PADDING_SIZE": 16,
  "ICON_BUTTON_FOCUS_RING_BUFFER_SIZE": 2,
  "ICON_BUTTON_FOCUS_RING_BORDER_SIZE": 2,
  "ICON_BUTTON_BORDER_RADIUS": 6,
  "ICON_BUTTON_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#006aff",
  "ICON_BUTTON_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#006aff",
  "ICON_BUTTON_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_PRIMARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "#006aff",
  "ICON_BUTTON_PRIMARY_RANK_NORMAL_STATE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#005fe5",
  "ICON_BUTTON_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_PRIMARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#005fe5",
  "ICON_BUTTON_PRIMARY_RANK_HOVER_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_PRIMARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "#005fe5",
  "ICON_BUTTON_PRIMARY_RANK_HOVER_STATE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#0055cc",
  "ICON_BUTTON_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#0055cc",
  "ICON_BUTTON_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_PRIMARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "#0055cc",
  "ICON_BUTTON_PRIMARY_RANK_PRESSED_STATE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#005fe5",
  "ICON_BUTTON_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#005fe5",
  "ICON_BUTTON_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_PRIMARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "#005fe5",
  "ICON_BUTTON_PRIMARY_RANK_FOCUS_STATE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "ICON_BUTTON_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_PRIMARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_PRIMARY_RANK_DISABLED_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "ICON_BUTTON_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_SECONDARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_SECONDARY_RANK_NORMAL_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "ICON_BUTTON_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_SECONDARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "ICON_BUTTON_SECONDARY_RANK_HOVER_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_SECONDARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "ICON_BUTTON_SECONDARY_RANK_HOVER_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#cce1ff",
  "ICON_BUTTON_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#002559",
  "ICON_BUTTON_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_SECONDARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "#cce1ff",
  "ICON_BUTTON_SECONDARY_RANK_PRESSED_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_SECONDARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "ICON_BUTTON_SECONDARY_RANK_FOCUS_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_SECONDARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "ICON_BUTTON_SECONDARY_RANK_FOCUS_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_SECONDARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "ICON_BUTTON_SECONDARY_RANK_FOCUS_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "ICON_BUTTON_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_SECONDARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_SECONDARY_RANK_DISABLED_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "ICON_BUTTON_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "ICON_BUTTON_HOVER_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_HOVER_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "ICON_BUTTON_HOVER_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#cce1ff",
  "ICON_BUTTON_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#002559",
  "ICON_BUTTON_PRESSED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_PRESSED_STATE_BACKGROUND_COLOR": "#cce1ff",
  "ICON_BUTTON_PRESSED_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "ICON_BUTTON_FOCUS_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "ICON_BUTTON_FOCUS_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_FOCUS_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "ICON_BUTTON_FOCUS_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "ICON_BUTTON_DISABLED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_DISABLED_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#006aff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#006aff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "#006aff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_NORMAL_STATE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#005fe5",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#005fe5",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "#005fe5",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_HOVER_STATE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#0055cc",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#0055cc",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "#0055cc",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_PRESSED_STATE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#006aff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#006aff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_BACKGROUND_COLOR": "#006aff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_FOCUS_STATE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_VARIANT_PRIMARY_RANK_DISABLED_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_NORMAL_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_HOVER_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#cce1ff",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#002559",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "#cce1ff",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_PRESSED_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_NORMAL_VARIANT_SECONDARY_RANK_DISABLED_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#cc0023",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#cc0023",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "#cc0023",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_NORMAL_STATE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#b2001e",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#b2001e",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "#b2001e",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_HOVER_STATE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#99001a",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#99001a",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "#99001a",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_PRESSED_STATE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_PRIMARY_RANK_DISABLED_STATE_ICON_COLOR": "#000000",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "#bf0020",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_DARK_MODE_ICON_COLOR": "#ff5a76",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_NORMAL_STATE_ICON_COLOR": "#bf0020",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#ffe5ea",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "#bf0020",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#330009",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_DARK_MODE_ICON_COLOR": "#ff5a76",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_BACKGROUND_COLOR": "#ffe5ea",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_HOVER_STATE_ICON_COLOR": "#bf0020",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#ffccd5",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "#bf0020",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#59000f",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_DARK_MODE_ICON_COLOR": "#ff5a76",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_BACKGROUND_COLOR": "#ffccd5",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_PRESSED_STATE_ICON_COLOR": "#bf0020",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "ICON_BUTTON_DESTRUCTIVE_VARIANT_SECONDARY_RANK_DISABLED_STATE_ICON_COLOR": "#000000",
  "INLINE_SECTION_HEADER_10_HEADING_SIZE": 14,
  "INLINE_SECTION_HEADER_10_HEADING_LEADING": 22,
  "INLINE_SECTION_HEADER_10_HEADING_TRACKING": 0,
  "INLINE_SECTION_HEADER_10_HEADING_WEIGHT": 700,
  "INLINE_SECTION_HEADER_10_HEADING_CASE": "regular",
  "INLINE_SECTION_HEADER_10_HEADING_NUMBER_SPACING": "default",
  "INLINE_SECTION_HEADER_10_HEADING_SCALE": "heading-10",
  "INLINE_SECTION_HEADER_10_HEADING_FONT_FAMILY": "Square Sans Text",
  "INLINE_SECTION_HEADER_10_HEADING_IS_HEADER": true,
  "INLINE_SECTION_HEADER_10_HEADING_VERTICAL_PADDING": 9,
  "INLINE_SECTION_HEADER_10_PARAGRAPH_SIZE": 16,
  "INLINE_SECTION_HEADER_10_PARAGRAPH_LEADING": 24,
  "INLINE_SECTION_HEADER_10_PARAGRAPH_TRACKING": 0,
  "INLINE_SECTION_HEADER_10_PARAGRAPH_WEIGHT": 400,
  "INLINE_SECTION_HEADER_10_PARAGRAPH_CASE": "regular",
  "INLINE_SECTION_HEADER_10_PARAGRAPH_NUMBER_SPACING": "default",
  "INLINE_SECTION_HEADER_10_PARAGRAPH_SCALE": "paragraph-30",
  "INLINE_SECTION_HEADER_10_PARAGRAPH_FONT_FAMILY": "Square Sans Text",
  "INLINE_SECTION_HEADER_10_PARAGRAPH_TOP_PADDING": 0,
  "INLINE_SECTION_HEADER_10_TEXT_LINK_TEXT_SIZE": 14,
  "INLINE_SECTION_HEADER_10_TEXT_LINK_TEXT_LEADING": 22,
  "INLINE_SECTION_HEADER_10_TEXT_LINK_TEXT_TRACKING": 0,
  "INLINE_SECTION_HEADER_10_TEXT_LINK_TEXT_WEIGHT": 600,
  "INLINE_SECTION_HEADER_10_TEXT_LINK_TEXT_CASE": "regular",
  "INLINE_SECTION_HEADER_10_TEXT_LINK_TEXT_NUMBER_SPACING": "default",
  "INLINE_SECTION_HEADER_10_TEXT_LINK_TEXT_SCALE": "paragraph-20",
  "INLINE_SECTION_HEADER_10_TEXT_LINK_TEXT_FONT_FAMILY": "Square Sans Text",
  "INLINE_SECTION_HEADER_10_TEXT_LINK_VERTICAL_PADDING": 0,
  "INLINE_SECTION_HEADER_20_HEADING_SIZE": 19,
  "INLINE_SECTION_HEADER_20_HEADING_LEADING": 26,
  "INLINE_SECTION_HEADER_20_HEADING_TRACKING": 0,
  "INLINE_SECTION_HEADER_20_HEADING_WEIGHT": 700,
  "INLINE_SECTION_HEADER_20_HEADING_CASE": "regular",
  "INLINE_SECTION_HEADER_20_HEADING_NUMBER_SPACING": "default",
  "INLINE_SECTION_HEADER_20_HEADING_SCALE": "heading-20",
  "INLINE_SECTION_HEADER_20_HEADING_FONT_FAMILY": "Square Sans Display",
  "INLINE_SECTION_HEADER_20_HEADING_IS_HEADER": true,
  "INLINE_SECTION_HEADER_20_HEADING_VERTICAL_PADDING": 7,
  "INLINE_SECTION_HEADER_20_PARAGRAPH_SIZE": 16,
  "INLINE_SECTION_HEADER_20_PARAGRAPH_LEADING": 24,
  "INLINE_SECTION_HEADER_20_PARAGRAPH_TRACKING": 0,
  "INLINE_SECTION_HEADER_20_PARAGRAPH_WEIGHT": 400,
  "INLINE_SECTION_HEADER_20_PARAGRAPH_CASE": "regular",
  "INLINE_SECTION_HEADER_20_PARAGRAPH_NUMBER_SPACING": "default",
  "INLINE_SECTION_HEADER_20_PARAGRAPH_SCALE": "paragraph-30",
  "INLINE_SECTION_HEADER_20_PARAGRAPH_FONT_FAMILY": "Square Sans Text",
  "INLINE_SECTION_HEADER_20_PARAGRAPH_TOP_PADDING": 5,
  "INLINE_SECTION_HEADER_20_TEXT_LINK_TEXT_SIZE": 16,
  "INLINE_SECTION_HEADER_20_TEXT_LINK_TEXT_LEADING": 24,
  "INLINE_SECTION_HEADER_20_TEXT_LINK_TEXT_TRACKING": 0,
  "INLINE_SECTION_HEADER_20_TEXT_LINK_TEXT_WEIGHT": 600,
  "INLINE_SECTION_HEADER_20_TEXT_LINK_TEXT_CASE": "regular",
  "INLINE_SECTION_HEADER_20_TEXT_LINK_TEXT_NUMBER_SPACING": "default",
  "INLINE_SECTION_HEADER_20_TEXT_LINK_TEXT_SCALE": "paragraph-30",
  "INLINE_SECTION_HEADER_20_TEXT_LINK_TEXT_FONT_FAMILY": "Square Sans Text",
  "INLINE_SECTION_HEADER_20_TEXT_LINK_VERTICAL_PADDING": 0,
  "INLINE_SECTION_HEADER_30_HEADING_SIZE": 25,
  "INLINE_SECTION_HEADER_30_HEADING_LEADING": 32,
  "INLINE_SECTION_HEADER_30_HEADING_TRACKING": 0,
  "INLINE_SECTION_HEADER_30_HEADING_WEIGHT": 700,
  "INLINE_SECTION_HEADER_30_HEADING_CASE": "regular",
  "INLINE_SECTION_HEADER_30_HEADING_NUMBER_SPACING": "default",
  "INLINE_SECTION_HEADER_30_HEADING_SCALE": "heading-30",
  "INLINE_SECTION_HEADER_30_HEADING_FONT_FAMILY": "Square Sans Display",
  "INLINE_SECTION_HEADER_30_HEADING_IS_HEADER": true,
  "INLINE_SECTION_HEADER_30_HEADING_VERTICAL_PADDING": 4,
  "INLINE_SECTION_HEADER_30_PARAGRAPH_SIZE": 16,
  "INLINE_SECTION_HEADER_30_PARAGRAPH_LEADING": 24,
  "INLINE_SECTION_HEADER_30_PARAGRAPH_TRACKING": 0,
  "INLINE_SECTION_HEADER_30_PARAGRAPH_WEIGHT": 400,
  "INLINE_SECTION_HEADER_30_PARAGRAPH_CASE": "regular",
  "INLINE_SECTION_HEADER_30_PARAGRAPH_NUMBER_SPACING": "default",
  "INLINE_SECTION_HEADER_30_PARAGRAPH_SCALE": "paragraph-30",
  "INLINE_SECTION_HEADER_30_PARAGRAPH_FONT_FAMILY": "Square Sans Text",
  "INLINE_SECTION_HEADER_30_PARAGRAPH_TOP_PADDING": 12,
  "INLINE_SECTION_HEADER_30_TEXT_LINK_TEXT_SIZE": 16,
  "INLINE_SECTION_HEADER_30_TEXT_LINK_TEXT_LEADING": 24,
  "INLINE_SECTION_HEADER_30_TEXT_LINK_TEXT_TRACKING": 0,
  "INLINE_SECTION_HEADER_30_TEXT_LINK_TEXT_WEIGHT": 600,
  "INLINE_SECTION_HEADER_30_TEXT_LINK_TEXT_CASE": "regular",
  "INLINE_SECTION_HEADER_30_TEXT_LINK_TEXT_NUMBER_SPACING": "default",
  "INLINE_SECTION_HEADER_30_TEXT_LINK_TEXT_SCALE": "paragraph-30",
  "INLINE_SECTION_HEADER_30_TEXT_LINK_TEXT_FONT_FAMILY": "Square Sans Text",
  "INLINE_SECTION_HEADER_30_TEXT_LINK_VERTICAL_PADDING": 0,
  "INLINE_SECTION_HEADER_HEADING_LIGHT_MODE_COLOR": "#000000",
  "INLINE_SECTION_HEADER_HEADING_DARK_MODE_COLOR": "#ffffff",
  "INLINE_SECTION_HEADER_HEADING_COLOR": "#000000",
  "INLINE_SECTION_HEADER_PARAGRAPH_LIGHT_MODE_COLOR": "#000000",
  "INLINE_SECTION_HEADER_PARAGRAPH_DARK_MODE_COLOR": "#ffffff",
  "INLINE_SECTION_HEADER_PARAGRAPH_COLOR": "#000000",
  "INLINE_SECTION_HEADER_TEXT_LINK_LIGHT_MODE_COLOR": "#005ad9",
  "INLINE_SECTION_HEADER_TEXT_LINK_DARK_MODE_COLOR": "#4a95ff",
  "INLINE_SECTION_HEADER_TEXT_LINK_NORMAL_STATE_OPACITY": 1,
  "INLINE_SECTION_HEADER_TEXT_LINK_HOVER_STATE_OPACITY": 0.6,
  "INLINE_SECTION_HEADER_TEXT_LINK_PRESSED_STATE_OPACITY": 0.6,
  "INLINE_SECTION_HEADER_TEXT_LINK_DISABLED_STATE_OPACITY": 0.3,
  "INLINE_SECTION_HEADER_TEXT_LINK_COLOR": "#005ad9",
  "INLINE_SECTION_HEADER_HORIZONTAL_SPACING": 8,
  "MODAL_DIALOG_LIGHT_MODE_BACKGROUND_COLOR": "#ffffff",
  "MODAL_DIALOG_DARK_MODE_BACKGROUND_COLOR": "#1c1c1c",
  "MODAL_DIALOG_BORDER_RADIUS": 12,
  "MODAL_DIALOG_ANIMATION_ENTER_TRANSITION_DURATION": 240,
  "MODAL_DIALOG_ANIMATION_ENTER_TRANSITION_EASING": "cubic-bezier(0.52, 0.0, 0.74, 0.0)",
  "MODAL_DIALOG_ANIMATION_EXIT_TRANSITION_DURATION": 160,
  "MODAL_DIALOG_ANIMATION_EXIT_TRANSITION_EASING": "cubic-bezier(0.52, 0.0, 0.74, 0.0)",
  "MODAL_DIALOG_ANIMATION_DURATION": 500,
  "MODAL_DIALOG_NARROW_VIEWPORT_HORIZONTAL_PADDING_SIZE": 24,
  "MODAL_DIALOG_NARROW_VIEWPORT_VERTICAL_PADDING_SIZE": 24,
  "MODAL_DIALOG_MEDIUM_VIEWPORT_WIDTH": 480,
  "MODAL_DIALOG_MEDIUM_VIEWPORT_HORIZONTAL_PADDING_SIZE": 40,
  "MODAL_DIALOG_MEDIUM_VIEWPORT_VERTICAL_PADDING_SIZE": 24,
  "MODAL_DIALOG_WIDE_VIEWPORT_WIDTH": 480,
  "MODAL_DIALOG_WIDE_VIEWPORT_HORIZONTAL_PADDING_SIZE": 32,
  "MODAL_DIALOG_WIDE_VIEWPORT_VERTICAL_PADDING_SIZE": 24,
  "MODAL_DIALOG_BACKGROUND_COLOR": "#ffffff",
  "MODAL_FULL_LIGHT_MODE_BACKGROUND_COLOR": "#ffffff",
  "MODAL_FULL_DARK_MODE_BACKGROUND_COLOR": "#080808",
  "MODAL_FULL_ANIMATION_ENTER_TRANSITION_DURATION": 240,
  "MODAL_FULL_ANIMATION_ENTER_TRANSITION_EASING": "cubic-bezier(0.52, 0.0, 0.74, 0.0)",
  "MODAL_FULL_ANIMATION_EXIT_TRANSITION_DURATION": 160,
  "MODAL_FULL_ANIMATION_EXIT_TRANSITION_EASING": "cubic-bezier(0.52, 0.0, 0.74, 0.0)",
  "MODAL_FULL_FIXED_LAYOUT_WIDTH": 600,
  "MODAL_FULL_NARROW_VIEWPORT_ANIMATION_DURATION": 500,
  "MODAL_FULL_NARROW_VIEWPORT_HORIZONTAL_PADDING_SIZE": 16,
  "MODAL_FULL_NARROW_VIEWPORT_VERTICAL_PADDING_SIZE": 16,
  "MODAL_FULL_MEDIUM_VIEWPORT_ANIMATION_DURATION": 500,
  "MODAL_FULL_MEDIUM_VIEWPORT_HORIZONTAL_PADDING_SIZE": 24,
  "MODAL_FULL_MEDIUM_VIEWPORT_VERTICAL_PADDING_SIZE": 24,
  "MODAL_FULL_WIDE_VIEWPORT_ANIMATION_DURATION": 500,
  "MODAL_FULL_WIDE_VIEWPORT_HORIZONTAL_PADDING_SIZE": 32,
  "MODAL_FULL_WIDE_VIEWPORT_VERTICAL_PADDING_SIZE": 16,
  "MODAL_FULL_BACKGROUND_COLOR": "#ffffff",
  "MODAL_PARTIAL_LIGHT_MODE_BACKGROUND_COLOR": "#ffffff",
  "MODAL_PARTIAL_DARK_MODE_BACKGROUND_COLOR": "#080808",
  "MODAL_PARTIAL_BORDER_RADIUS": 12,
  "MODAL_PARTIAL_ANIMATION_ENTER_TRANSITION_DURATION": 240,
  "MODAL_PARTIAL_ANIMATION_ENTER_TRANSITION_EASING": "cubic-bezier(0.52, 0.0, 0.74, 0.0)",
  "MODAL_PARTIAL_ANIMATION_EXIT_TRANSITION_DURATION": 160,
  "MODAL_PARTIAL_ANIMATION_EXIT_TRANSITION_EASING": "cubic-bezier(0.52, 0.0, 0.74, 0.0)",
  "MODAL_PARTIAL_NARROW_VIEWPORT_ANIMATION_DURATION": 500,
  "MODAL_PARTIAL_NARROW_VIEWPORT_HORIZONTAL_PADDING_SIZE": 16,
  "MODAL_PARTIAL_NARROW_VIEWPORT_HORIZONTAL_SCREEN_BUFFER_SIZE": 0,
  "MODAL_PARTIAL_NARROW_VIEWPORT_VERTICAL_PADDING_SIZE": 16,
  "MODAL_PARTIAL_NARROW_VIEWPORT_VERTICAL_SCREEN_BUFFER_SIZE": 0,
  "MODAL_PARTIAL_MEDIUM_VIEWPORT_ANIMATION_DURATION": 500,
  "MODAL_PARTIAL_MEDIUM_VIEWPORT_WIDTH": 664,
  "MODAL_PARTIAL_MEDIUM_VIEWPORT_HORIZONTAL_PADDING_SIZE": 32,
  "MODAL_PARTIAL_MEDIUM_VIEWPORT_HORIZONTAL_SCREEN_BUFFER_SIZE": 24,
  "MODAL_PARTIAL_MEDIUM_VIEWPORT_VERTICAL_PADDING_SIZE": 32,
  "MODAL_PARTIAL_MEDIUM_VIEWPORT_VERTICAL_SCREEN_BUFFER_SIZE": 24,
  "MODAL_PARTIAL_WIDE_VIEWPORT_ANIMATION_DURATION": 500,
  "MODAL_PARTIAL_WIDE_VIEWPORT_WIDTH": 664,
  "MODAL_PARTIAL_WIDE_VIEWPORT_HORIZONTAL_PADDING_SIZE": 32,
  "MODAL_PARTIAL_WIDE_VIEWPORT_HORIZONTAL_SCREEN_BUFFER_SIZE": 24,
  "MODAL_PARTIAL_WIDE_VIEWPORT_VERTICAL_PADDING_SIZE": 32,
  "MODAL_PARTIAL_WIDE_VIEWPORT_VERTICAL_SCREEN_BUFFER_SIZE": 24,
  "MODAL_PARTIAL_BACKGROUND_COLOR": "#ffffff",
  "MODAL_POPOVER_BACKGROUND_LIGHT_MODE_COLOR": "#ffffff",
  "MODAL_POPOVER_BACKGROUND_DARK_MODE_COLOR": "#2d2d2d",
  "MODAL_POPOVER_BACKGROUND_COLOR": "#ffffff",
  "MODAL_POPOVER_BORDER_RADIUS": 6,
  "MODAL_POPOVER_APPEAR_ANIMATION_PERCENTAGE": 70,
  "MODAL_POPOVER_WIDE_VIEWPORT_PADDING_LEFT_SIZE": 24,
  "MODAL_POPOVER_WIDE_VIEWPORT_PADDING_TOP_SIZE": 8,
  "MODAL_POPOVER_WIDE_VIEWPORT_PADDING_RIGHT_SIZE": 24,
  "MODAL_POPOVER_WIDE_VIEWPORT_PADDING_BOTTOM_SIZE": 24,
  "MODAL_POPOVER_WIDE_VIEWPORT_MAX_HEIGHT_SIZE": 500,
  "MODAL_POPOVER_WIDE_VIEWPORT_MIN_WIDTH_SIZE": 200,
  "MODAL_SHEET_BACKGROUND_LIGHT_MODE_COLOR": "#ffffff",
  "MODAL_SHEET_BACKGROUND_DARK_MODE_COLOR": "#1c1c1c",
  "MODAL_SHEET_BACKGROUND_COLOR": "#ffffff",
  "MODAL_SHEET_BORDER_RADIUS": 12,
  "MODAL_SHEET_NARROW_VIEWPORT_PADDING_LEFT_SIZE": 16,
  "MODAL_SHEET_NARROW_VIEWPORT_PADDING_TOP_SIZE": 24,
  "MODAL_SHEET_NARROW_VIEWPORT_PADDING_RIGHT_SIZE": 16,
  "MODAL_SHEET_NARROW_VIEWPORT_PADDING_BOTTOM_SIZE": 24,
  "MODAL_SHEET_WIDE_VIEWPORT_PADDING_LEFT_SIZE": 40,
  "MODAL_SHEET_WIDE_VIEWPORT_PADDING_TOP_SIZE": 24,
  "MODAL_SHEET_WIDE_VIEWPORT_PADDING_RIGHT_SIZE": 40,
  "MODAL_SHEET_WIDE_VIEWPORT_PADDING_BOTTOM_SIZE": 24,
  "MODAL_SHEET_HANDLE_BACKGROUND_LIGHT_MODE_COLOR": "#000000",
  "MODAL_SHEET_HANDLE_BACKGROUND_DARK_MODE_COLOR": "#ffffff",
  "MODAL_SHEET_HANDLE_BACKGROUND_COLOR": "#000000",
  "MODAL_SHEET_HANDLE_TOP_BUFFER_SIZE": 10,
  "MODAL_SHEET_HANDLE_WIDTH": 40,
  "MODAL_SHEET_HANDLE_HEIGHT": 4,
  "MODAL_SHEET_HANDLE_BORDER_RADIUS": 2,
  "PAGE_INDICATOR_DOT_SIZE": 6,
  "PAGE_INDICATOR_DOT_COLOR": "#000000",
  "PAGE_INDICATOR_SELECTED_SIZE": 8,
  "PAGE_INDICATOR_SELECTED_COLOR": "#006aff",
  "PAGE_INDICATOR_SPACING_SIZE": 6,
  "PAGE_INDICATOR_LIGHT_MODE_DOT_COLOR": "#000000",
  "PAGE_INDICATOR_LIGHT_MODE_SELECTED_COLOR": "#006aff",
  "PAGE_INDICATOR_DARK_MODE_DOT_COLOR": "#ffffff",
  "PAGE_INDICATOR_DARK_MODE_SELECTED_COLOR": "#006aff",
  "PAGINATION_NAV_VERTICAL_MARGIN": 16,
  "PAGINATION_NAV_HORIZONTAL_MARGIN": 8,
  "PAGINATION_NAV_CONTENT_SPACING": 8,
  "PILL_NORMAL_SIZE_TEXT_SIZE": 14,
  "PILL_NORMAL_SIZE_TEXT_LEADING": 22,
  "PILL_NORMAL_SIZE_TEXT_TRACKING": 0,
  "PILL_NORMAL_SIZE_TEXT_WEIGHT": 600,
  "PILL_NORMAL_SIZE_TEXT_CASE": "regular",
  "PILL_NORMAL_SIZE_TEXT_NUMBER_SPACING": "default",
  "PILL_NORMAL_SIZE_TEXT_SCALE": "paragraph-20",
  "PILL_NORMAL_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
  "PILL_NORMAL_SIZE_PADDING_HORIZONTAL_SIZE": 12,
  "PILL_NORMAL_SIZE_PADDING_VERTICAL_SIZE": 5,
  "PILL_NORMAL_SIZE_ICON_LEFT_PADDING": 8,
  "PILL_NORMAL_SIZE_TEXT_EDGE_PADDING": 12,
  "PILL_NORMAL_SIZE_CORNER_RADIUS": 100,
  "PILL_NORMAL_SIZE_ICON_DOT_RADIUS": 5,
  "PILL_NORMAL_SIZE_ICON_SIZE": 16,
  "PILL_NORMAL_SIZE_SPACING_HORIZONTAL": 8,
  "PILL_NORMAL_SIZE_ICON_TO_TEXT_SPACING": 4,
  "PILL_COMPACT_SIZE_TEXT_SIZE": 12,
  "PILL_COMPACT_SIZE_TEXT_LEADING": 18,
  "PILL_COMPACT_SIZE_TEXT_TRACKING": 0,
  "PILL_COMPACT_SIZE_TEXT_WEIGHT": 600,
  "PILL_COMPACT_SIZE_TEXT_CASE": "regular",
  "PILL_COMPACT_SIZE_TEXT_NUMBER_SPACING": "default",
  "PILL_COMPACT_SIZE_TEXT_SCALE": "paragraph-10",
  "PILL_COMPACT_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
  "PILL_COMPACT_SIZE_PADDING_HORIZONTAL_SIZE": 8,
  "PILL_COMPACT_SIZE_PADDING_VERTICAL_SIZE": 3,
  "PILL_COMPACT_SIZE_ICON_LEFT_PADDING": 4,
  "PILL_COMPACT_SIZE_TEXT_EDGE_PADDING": 8,
  "PILL_COMPACT_SIZE_ICON_DOT_RADIUS": 4,
  "PILL_COMPACT_SIZE_ICON_SIZE": 16,
  "PILL_COMPACT_SIZE_SPACING_HORIZONTAL": 6,
  "PILL_COMPACT_SIZE_ICON_TO_TEXT_SPACING": 3,
  "PILL_NORMAL_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "#000000",
  "PILL_NORMAL_VARIANT_BACKGROUND_DARK_MODE_COLOR": "#ffffff",
  "PILL_NORMAL_VARIANT_BACKGROUND_COLOR": "#000000",
  "PILL_NORMAL_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#000000",
  "PILL_NORMAL_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "#ffffff",
  "PILL_NORMAL_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "PILL_NORMAL_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#000000",
  "PILL_NORMAL_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "#ffffff",
  "PILL_NORMAL_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "#000000",
  "PILL_NORMAL_VARIANT_TEXT_LIGHT_MODE_COLOR": "#000000",
  "PILL_NORMAL_VARIANT_TEXT_DARK_MODE_COLOR": "#ffffff",
  "PILL_NORMAL_VARIANT_TEXT_COLOR": "#000000",
  "PILL_NORMAL_VARIANT_ICON_LIGHT_MODE_COLOR": "#000000",
  "PILL_NORMAL_VARIANT_ICON_DARK_MODE_COLOR": "#ffffff",
  "PILL_NORMAL_VARIANT_ICON_COLOR": "#000000",
  "PILL_EMPHASIS_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "#e6f0ff",
  "PILL_EMPHASIS_VARIANT_BACKGROUND_DARK_MODE_COLOR": "#001533",
  "PILL_EMPHASIS_VARIANT_BACKGROUND_COLOR": "#e6f0ff",
  "PILL_EMPHASIS_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#e6f0ff",
  "PILL_EMPHASIS_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "#001533",
  "PILL_EMPHASIS_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "PILL_EMPHASIS_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#cce1ff",
  "PILL_EMPHASIS_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "#002559",
  "PILL_EMPHASIS_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "#cce1ff",
  "PILL_EMPHASIS_VARIANT_TEXT_LIGHT_MODE_COLOR": "#005ad9",
  "PILL_EMPHASIS_VARIANT_TEXT_DARK_MODE_COLOR": "#4a95ff",
  "PILL_EMPHASIS_VARIANT_TEXT_COLOR": "#005ad9",
  "PILL_EMPHASIS_VARIANT_ICON_LIGHT_MODE_COLOR": "#006aff",
  "PILL_EMPHASIS_VARIANT_ICON_DARK_MODE_COLOR": "#006aff",
  "PILL_EMPHASIS_VARIANT_ICON_COLOR": "#006aff",
  "PILL_SUCCESS_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "#e5ffee",
  "PILL_SUCCESS_VARIANT_BACKGROUND_DARK_MODE_COLOR": "#003311",
  "PILL_SUCCESS_VARIANT_BACKGROUND_COLOR": "#e5ffee",
  "PILL_SUCCESS_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#e5ffee",
  "PILL_SUCCESS_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "#003311",
  "PILL_SUCCESS_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "#e5ffee",
  "PILL_SUCCESS_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#ccffdd",
  "PILL_SUCCESS_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "#00591e",
  "PILL_SUCCESS_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "#ccffdd",
  "PILL_SUCCESS_VARIANT_TEXT_LIGHT_MODE_COLOR": "#007d2a",
  "PILL_SUCCESS_VARIANT_TEXT_DARK_MODE_COLOR": "#16d956",
  "PILL_SUCCESS_VARIANT_TEXT_COLOR": "#007d2a",
  "PILL_SUCCESS_VARIANT_ICON_LIGHT_MODE_COLOR": "#00b23b",
  "PILL_SUCCESS_VARIANT_ICON_DARK_MODE_COLOR": "#00b33b",
  "PILL_SUCCESS_VARIANT_ICON_COLOR": "#00b23b",
  "PILL_WARNING_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "#fff2e6",
  "PILL_WARNING_VARIANT_BACKGROUND_DARK_MODE_COLOR": "#331a00",
  "PILL_WARNING_VARIANT_BACKGROUND_COLOR": "#fff2e6",
  "PILL_WARNING_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#fff2e6",
  "PILL_WARNING_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "#331a00",
  "PILL_WARNING_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "#fff2e6",
  "PILL_WARNING_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#ffe6cc",
  "PILL_WARNING_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "#592d00",
  "PILL_WARNING_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "#ffe6cc",
  "PILL_WARNING_VARIANT_TEXT_LIGHT_MODE_COLOR": "#945c25",
  "PILL_WARNING_VARIANT_TEXT_DARK_MODE_COLOR": "#ff9f40",
  "PILL_WARNING_VARIANT_TEXT_COLOR": "#945c25",
  "PILL_WARNING_VARIANT_ICON_LIGHT_MODE_COLOR": "#ff9f40",
  "PILL_WARNING_VARIANT_ICON_DARK_MODE_COLOR": "#ff9f40",
  "PILL_WARNING_VARIANT_ICON_COLOR": "#ff9f40",
  "PILL_CRITICAL_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "#ffe5ea",
  "PILL_CRITICAL_VARIANT_BACKGROUND_DARK_MODE_COLOR": "#330009",
  "PILL_CRITICAL_VARIANT_BACKGROUND_COLOR": "#ffe5ea",
  "PILL_CRITICAL_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#ffe5ea",
  "PILL_CRITICAL_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "#330009",
  "PILL_CRITICAL_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "#ffe5ea",
  "PILL_CRITICAL_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#ffccd5",
  "PILL_CRITICAL_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "#59000f",
  "PILL_CRITICAL_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "#ffccd5",
  "PILL_CRITICAL_VARIANT_TEXT_LIGHT_MODE_COLOR": "#bf0020",
  "PILL_CRITICAL_VARIANT_TEXT_DARK_MODE_COLOR": "#ff5a76",
  "PILL_CRITICAL_VARIANT_TEXT_COLOR": "#bf0020",
  "PILL_CRITICAL_VARIANT_ICON_LIGHT_MODE_COLOR": "#cc0023",
  "PILL_CRITICAL_VARIANT_ICON_DARK_MODE_COLOR": "#cc0023",
  "PILL_CRITICAL_VARIANT_ICON_COLOR": "#cc0023",
  "PILL_INSIGHT_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "#f4e6ff",
  "PILL_INSIGHT_VARIANT_BACKGROUND_DARK_MODE_COLOR": "#1e0033",
  "PILL_INSIGHT_VARIANT_BACKGROUND_COLOR": "#f4e6ff",
  "PILL_INSIGHT_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#f4e6ff",
  "PILL_INSIGHT_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "#1e0033",
  "PILL_INSIGHT_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "#f4e6ff",
  "PILL_INSIGHT_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#eaccff",
  "PILL_INSIGHT_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "#340059",
  "PILL_INSIGHT_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "#eaccff",
  "PILL_INSIGHT_VARIANT_TEXT_LIGHT_MODE_COLOR": "#8716d9",
  "PILL_INSIGHT_VARIANT_TEXT_DARK_MODE_COLOR": "#c26eff",
  "PILL_INSIGHT_VARIANT_TEXT_COLOR": "#8716d9",
  "PILL_INSIGHT_VARIANT_ICON_LIGHT_MODE_COLOR": "#8716d9",
  "PILL_INSIGHT_VARIANT_ICON_DARK_MODE_COLOR": "#8716d9",
  "PILL_INSIGHT_VARIANT_ICON_COLOR": "#8716d9",
  "PILL_ALPHA_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "#ffe6f9",
  "PILL_ALPHA_VARIANT_BACKGROUND_DARK_MODE_COLOR": "#330026",
  "PILL_ALPHA_VARIANT_BACKGROUND_COLOR": "#ffe6f9",
  "PILL_ALPHA_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#ffe6f9",
  "PILL_ALPHA_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "#330026",
  "PILL_ALPHA_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "#ffe6f9",
  "PILL_ALPHA_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#ffccf2",
  "PILL_ALPHA_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "#590043",
  "PILL_ALPHA_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "#ffccf2",
  "PILL_ALPHA_VARIANT_TEXT_LIGHT_MODE_COLOR": "#a82a88",
  "PILL_ALPHA_VARIANT_TEXT_DARK_MODE_COLOR": "#ff43d0",
  "PILL_ALPHA_VARIANT_TEXT_COLOR": "#a82a88",
  "PILL_ALPHA_VARIANT_ICON_LIGHT_MODE_COLOR": "#d936b0",
  "PILL_ALPHA_VARIANT_ICON_DARK_MODE_COLOR": "#d936b0",
  "PILL_ALPHA_VARIANT_ICON_COLOR": "#d936b0",
  "PILL_BETA_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "#e6fff9",
  "PILL_BETA_VARIANT_BACKGROUND_DARK_MODE_COLOR": "#003326",
  "PILL_BETA_VARIANT_BACKGROUND_COLOR": "#e6fff9",
  "PILL_BETA_VARIANT_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#e6fff9",
  "PILL_BETA_VARIANT_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "#003326",
  "PILL_BETA_VARIANT_NORMAL_STATE_BACKGROUND_COLOR": "#e6fff9",
  "PILL_BETA_VARIANT_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#ccfff2",
  "PILL_BETA_VARIANT_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "#005943",
  "PILL_BETA_VARIANT_PRESSED_STATE_BACKGROUND_COLOR": "#ccfff2",
  "PILL_BETA_VARIANT_TEXT_LIGHT_MODE_COLOR": "#0c785d",
  "PILL_BETA_VARIANT_TEXT_DARK_MODE_COLOR": "#16d8a7",
  "PILL_BETA_VARIANT_TEXT_COLOR": "#0c785d",
  "PILL_BETA_VARIANT_ICON_LIGHT_MODE_COLOR": "#12bf94",
  "PILL_BETA_VARIANT_ICON_DARK_MODE_COLOR": "#12bf94",
  "PILL_BETA_VARIANT_ICON_COLOR": "#12bf94",
  "QRCODE_NORMAL_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "#ffffff",
  "QRCODE_NORMAL_VARIANT_BACKGROUND_DARK_MODE_COLOR": "#000000",
  "QRCODE_NORMAL_VARIANT_BACKGROUND_COLOR": "#ffffff",
  "QRCODE_NORMAL_VARIANT_FOREGROUND_LIGHT_MODE_COLOR": "#000000",
  "QRCODE_NORMAL_VARIANT_FOREGROUND_DARK_MODE_COLOR": "#ffffff",
  "QRCODE_NORMAL_VARIANT_FOREGROUND_COLOR": "#000000",
  "QRCODE_NORMAL_VARIANT_ICON_LIGHT_MODE_COLOR": "#006aff",
  "QRCODE_NORMAL_VARIANT_ICON_DARK_MODE_COLOR": "#006aff",
  "QRCODE_NORMAL_VARIANT_ICON_COLOR": "#006aff",
  "QRCODE_MONOCHROME_VARIANT_BACKGROUND_LIGHT_MODE_COLOR": "#ffffff",
  "QRCODE_MONOCHROME_VARIANT_BACKGROUND_DARK_MODE_COLOR": "#000000",
  "QRCODE_MONOCHROME_VARIANT_BACKGROUND_COLOR": "#ffffff",
  "QRCODE_MONOCHROME_VARIANT_FOREGROUND_LIGHT_MODE_COLOR": "#000000",
  "QRCODE_MONOCHROME_VARIANT_FOREGROUND_DARK_MODE_COLOR": "#ffffff",
  "QRCODE_MONOCHROME_VARIANT_FOREGROUND_COLOR": "#000000",
  "QRCODE_MONOCHROME_VARIANT_ICON_LIGHT_MODE_COLOR": "#000000",
  "QRCODE_MONOCHROME_VARIANT_ICON_DARK_MODE_COLOR": "#ffffff",
  "QRCODE_MONOCHROME_VARIANT_ICON_COLOR": "#000000",
  "QUANTITY_INPUT_FIELD_VALUE_TEXT_LIGHT_MODE_COLOR": "#000000",
  "QUANTITY_INPUT_FIELD_VALUE_TEXT_DARK_MODE_COLOR": "#ffffff",
  "QUANTITY_INPUT_FIELD_VALUE_TEXT_SIZE": 48,
  "QUANTITY_INPUT_FIELD_VALUE_TEXT_LEADING": 56,
  "QUANTITY_INPUT_FIELD_VALUE_TEXT_TRACKING": 0,
  "QUANTITY_INPUT_FIELD_VALUE_TEXT_WEIGHT": 500,
  "QUANTITY_INPUT_FIELD_VALUE_TEXT_CASE": "regular",
  "QUANTITY_INPUT_FIELD_VALUE_TEXT_NUMBER_SPACING": "monospaced",
  "QUANTITY_INPUT_FIELD_VALUE_TEXT_SCALE": "heading-30",
  "QUANTITY_INPUT_FIELD_VALUE_TEXT_FONT_FAMILY": "Square Sans Display",
  "QUANTITY_INPUT_FIELD_VALUE_TEXT_PLACEHOLDER_LIGHT_MODE_COLOR": "#000000",
  "QUANTITY_INPUT_FIELD_VALUE_TEXT_PLACEHOLDER_DARK_MODE_COLOR": "#ffffff",
  "QUANTITY_INPUT_FIELD_VALUE_TEXT_PLACEHOLDER_COLOR": "#000000",
  "QUANTITY_INPUT_FIELD_VALUE_TEXT_COLOR": "#000000",
  "RADIO_WIDTH": 20,
  "RADIO_HEIGHT": 20,
  "RADIO_BORDER_RADIUS": 100,
  "RADIO_BORDER_SIZE": 2,
  "RADIO_SVG_RADIUS": 3,
  "RADIO_LIGHT_MODE_FOCUS_RING_COLOR": "#006aff",
  "RADIO_DARK_MODE_FOCUS_RING_COLOR": "#006aff",
  "RADIO_FOCUS_RING_BUFFER_SIZE": 2,
  "RADIO_FOCUS_RING_COLOR": "#006aff",
  "RADIO_NORMAL_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_NORMAL_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "RADIO_NORMAL_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_NORMAL_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#ffffff",
  "RADIO_NORMAL_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "#000000",
  "RADIO_NORMAL_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "#000000",
  "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#006aff",
  "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#006aff",
  "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "#006aff",
  "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "#000000",
  "RADIO_NORMAL_STATE_NORMAL_VALIDITY_SELECTED_VALUE_ICON_COLOR": "#ffffff",
  "RADIO_NORMAL_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_NORMAL_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#cc0023",
  "RADIO_NORMAL_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_NORMAL_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#cc0023",
  "RADIO_NORMAL_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "#000000",
  "RADIO_NORMAL_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "#cc0023",
  "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#cc0023",
  "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#cc0023",
  "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "#cc0023",
  "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "#000000",
  "RADIO_NORMAL_STATE_INVALID_VALIDITY_SELECTED_VALUE_ICON_COLOR": "#ffffff",
  "RADIO_HOVER_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_HOVER_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#006aff",
  "RADIO_HOVER_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_HOVER_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#006aff",
  "RADIO_HOVER_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "#000000",
  "RADIO_HOVER_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "#006aff",
  "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#005fe5",
  "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#005fe5",
  "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "#005fe5",
  "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "#000000",
  "RADIO_HOVER_STATE_NORMAL_VALIDITY_SELECTED_VALUE_ICON_COLOR": "#ffffff",
  "RADIO_HOVER_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_HOVER_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#b2001e",
  "RADIO_HOVER_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_HOVER_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#b2001e",
  "RADIO_HOVER_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "#000000",
  "RADIO_HOVER_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "#b2001e",
  "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#b2001e",
  "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#b2001e",
  "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "#b2001e",
  "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "#000000",
  "RADIO_HOVER_STATE_INVALID_VALIDITY_SELECTED_VALUE_ICON_COLOR": "#ffffff",
  "RADIO_PRESSED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_PRESSED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#0055cc",
  "RADIO_PRESSED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_PRESSED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#0055cc",
  "RADIO_PRESSED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "#000000",
  "RADIO_PRESSED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "#0055cc",
  "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#0055cc",
  "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#0055cc",
  "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "#0055cc",
  "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "#000000",
  "RADIO_PRESSED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_ICON_COLOR": "#ffffff",
  "RADIO_PRESSED_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_PRESSED_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#99001a",
  "RADIO_PRESSED_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_PRESSED_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#99001a",
  "RADIO_PRESSED_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "#000000",
  "RADIO_PRESSED_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "#99001a",
  "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#99001a",
  "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#99001a",
  "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "#99001a",
  "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "#000000",
  "RADIO_PRESSED_STATE_INVALID_VALIDITY_SELECTED_VALUE_ICON_COLOR": "#ffffff",
  "RADIO_FOCUS_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_FOCUS_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#006aff",
  "RADIO_FOCUS_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_FOCUS_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#006aff",
  "RADIO_FOCUS_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "#000000",
  "RADIO_FOCUS_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "#006aff",
  "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#005fe5",
  "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#005fe5",
  "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "#005fe5",
  "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "#000000",
  "RADIO_FOCUS_STATE_NORMAL_VALIDITY_SELECTED_VALUE_ICON_COLOR": "#ffffff",
  "RADIO_FOCUS_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_FOCUS_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#b2001e",
  "RADIO_FOCUS_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_FOCUS_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#b2001e",
  "RADIO_FOCUS_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "#000000",
  "RADIO_FOCUS_STATE_INVALID_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "#b2001e",
  "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#b2001e",
  "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#b2001e",
  "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "#b2001e",
  "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "#000000",
  "RADIO_FOCUS_STATE_INVALID_VALIDITY_SELECTED_VALUE_ICON_COLOR": "#ffffff",
  "RADIO_DISABLED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_DISABLED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "RADIO_DISABLED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "RADIO_DISABLED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#ffffff",
  "RADIO_DISABLED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BACKGROUND_COLOR": "#000000",
  "RADIO_DISABLED_STATE_NORMAL_VALIDITY_UNSELECTED_VALUE_BORDER_COLOR": "#000000",
  "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_LIGHT_MODE_ICON_COLOR": "#ffffff",
  "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_DARK_MODE_ICON_COLOR": "#ffffff",
  "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BACKGROUND_COLOR": "#000000",
  "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_BORDER_COLOR": "#000000",
  "RADIO_DISABLED_STATE_NORMAL_VALIDITY_SELECTED_VALUE_ICON_COLOR": "#ffffff",
  "ROW_HORIZONTAL_SPACING": 12,
  "ROW_MEDIUM_SIZE_TEXT_SIZE": 16,
  "ROW_MEDIUM_SIZE_TEXT_LEADING": 24,
  "ROW_MEDIUM_SIZE_TEXT_TRACKING": 0,
  "ROW_MEDIUM_SIZE_TEXT_WEIGHT": 500,
  "ROW_MEDIUM_SIZE_TEXT_CASE": "regular",
  "ROW_MEDIUM_SIZE_TEXT_NUMBER_SPACING": "default",
  "ROW_MEDIUM_SIZE_TEXT_SCALE": "paragraph-30",
  "ROW_MEDIUM_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
  "ROW_MEDIUM_SIZE_TEXT_VERTICAL_SPACING": 2,
  "ROW_MEDIUM_SIZE_SUBTEXT_SIZE": 14,
  "ROW_MEDIUM_SIZE_SUBTEXT_LEADING": 22,
  "ROW_MEDIUM_SIZE_SUBTEXT_TRACKING": 0,
  "ROW_MEDIUM_SIZE_SUBTEXT_WEIGHT": 400,
  "ROW_MEDIUM_SIZE_SUBTEXT_CASE": "regular",
  "ROW_MEDIUM_SIZE_SUBTEXT_NUMBER_SPACING": "default",
  "ROW_MEDIUM_SIZE_SUBTEXT_SCALE": "paragraph-20",
  "ROW_MEDIUM_SIZE_SUBTEXT_FONT_FAMILY": "Square Sans Text",
  "ROW_MEDIUM_SIZE_SIDE_TEXT_PRIMARY_SIZE": 16,
  "ROW_MEDIUM_SIZE_SIDE_TEXT_PRIMARY_LEADING": 24,
  "ROW_MEDIUM_SIZE_SIDE_TEXT_PRIMARY_TRACKING": 0,
  "ROW_MEDIUM_SIZE_SIDE_TEXT_PRIMARY_WEIGHT": 400,
  "ROW_MEDIUM_SIZE_SIDE_TEXT_PRIMARY_CASE": "regular",
  "ROW_MEDIUM_SIZE_SIDE_TEXT_PRIMARY_NUMBER_SPACING": "default",
  "ROW_MEDIUM_SIZE_SIDE_TEXT_PRIMARY_SCALE": "paragraph-30",
  "ROW_MEDIUM_SIZE_SIDE_TEXT_PRIMARY_FONT_FAMILY": "Square Sans Text",
  "ROW_MEDIUM_SIZE_SIDE_TEXT_SECONDARY_SIZE": 14,
  "ROW_MEDIUM_SIZE_SIDE_TEXT_SECONDARY_LEADING": 22,
  "ROW_MEDIUM_SIZE_SIDE_TEXT_SECONDARY_TRACKING": 0,
  "ROW_MEDIUM_SIZE_SIDE_TEXT_SECONDARY_WEIGHT": 400,
  "ROW_MEDIUM_SIZE_SIDE_TEXT_SECONDARY_CASE": "regular",
  "ROW_MEDIUM_SIZE_SIDE_TEXT_SECONDARY_NUMBER_SPACING": "default",
  "ROW_MEDIUM_SIZE_SIDE_TEXT_SECONDARY_SCALE": "paragraph-20",
  "ROW_MEDIUM_SIZE_SIDE_TEXT_SECONDARY_FONT_FAMILY": "Square Sans Text",
  "ROW_MEDIUM_SIZE_VERTICAL_PADDING": 16,
  "ROW_MEDIUM_SIZE_CARET_ICON_ASSET": "chevron-right",
  "ROW_MEDIUM_SIZE_CARET_ICON_WIDTH": 16,
  "ROW_MEDIUM_SIZE_CARET_ICON_HEIGHT": 16,
  "ROW_MEDIUM_SIZE_CARET_ICON_TINTABLE": true,
  "ROW_SMALL_SIZE_TEXT_SIZE": 14,
  "ROW_SMALL_SIZE_TEXT_LEADING": 22,
  "ROW_SMALL_SIZE_TEXT_TRACKING": 0,
  "ROW_SMALL_SIZE_TEXT_WEIGHT": 600,
  "ROW_SMALL_SIZE_TEXT_CASE": "regular",
  "ROW_SMALL_SIZE_TEXT_NUMBER_SPACING": "default",
  "ROW_SMALL_SIZE_TEXT_SCALE": "paragraph-20",
  "ROW_SMALL_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
  "ROW_SMALL_SIZE_TEXT_VERTICAL_SPACING": 2,
  "ROW_SMALL_SIZE_SUBTEXT_SIZE": 12,
  "ROW_SMALL_SIZE_SUBTEXT_LEADING": 18,
  "ROW_SMALL_SIZE_SUBTEXT_TRACKING": 0,
  "ROW_SMALL_SIZE_SUBTEXT_WEIGHT": 400,
  "ROW_SMALL_SIZE_SUBTEXT_CASE": "regular",
  "ROW_SMALL_SIZE_SUBTEXT_NUMBER_SPACING": "default",
  "ROW_SMALL_SIZE_SUBTEXT_SCALE": "paragraph-10",
  "ROW_SMALL_SIZE_SUBTEXT_FONT_FAMILY": "Square Sans Text",
  "ROW_SMALL_SIZE_SIDE_TEXT_PRIMARY_SIZE": 14,
  "ROW_SMALL_SIZE_SIDE_TEXT_PRIMARY_LEADING": 22,
  "ROW_SMALL_SIZE_SIDE_TEXT_PRIMARY_TRACKING": 0,
  "ROW_SMALL_SIZE_SIDE_TEXT_PRIMARY_WEIGHT": 400,
  "ROW_SMALL_SIZE_SIDE_TEXT_PRIMARY_CASE": "regular",
  "ROW_SMALL_SIZE_SIDE_TEXT_PRIMARY_NUMBER_SPACING": "default",
  "ROW_SMALL_SIZE_SIDE_TEXT_PRIMARY_SCALE": "paragraph-20",
  "ROW_SMALL_SIZE_SIDE_TEXT_PRIMARY_FONT_FAMILY": "Square Sans Text",
  "ROW_SMALL_SIZE_SIDE_TEXT_SECONDARY_SIZE": 12,
  "ROW_SMALL_SIZE_SIDE_TEXT_SECONDARY_LEADING": 18,
  "ROW_SMALL_SIZE_SIDE_TEXT_SECONDARY_TRACKING": 0,
  "ROW_SMALL_SIZE_SIDE_TEXT_SECONDARY_WEIGHT": 400,
  "ROW_SMALL_SIZE_SIDE_TEXT_SECONDARY_CASE": "regular",
  "ROW_SMALL_SIZE_SIDE_TEXT_SECONDARY_NUMBER_SPACING": "default",
  "ROW_SMALL_SIZE_SIDE_TEXT_SECONDARY_SCALE": "paragraph-10",
  "ROW_SMALL_SIZE_SIDE_TEXT_SECONDARY_FONT_FAMILY": "Square Sans Text",
  "ROW_SMALL_SIZE_VERTICAL_PADDING": 9,
  "ROW_SMALL_SIZE_CARET_ICON_ASSET": "chevron-right",
  "ROW_SMALL_SIZE_CARET_ICON_WIDTH": 16,
  "ROW_SMALL_SIZE_CARET_ICON_HEIGHT": 16,
  "ROW_SMALL_SIZE_CARET_ICON_TINTABLE": true,
  "ROW_FOCUS_RING_BUFFER_SIZE": 2,
  "ROW_FOCUS_RING_BORDER_SIZE": 2,
  "ROW_FOCUS_RING_RADIUS": 6,
  "ROW_FOCUS_RING_COLOR": "#006aff",
  "ROW_LIGHT_MODE_FOCUS_RING_COLOR": "#006aff",
  "ROW_DARK_MODE_FOCUS_RING_COLOR": "#006aff",
  "ROW_BACKGROUND_RADIUS": 6,
  "ROW_BACKGROUND_HORIZONTAL_OUTSET_PADDING": 12,
  "ROW_BACKGROUND_VERTICAL_OUTSET_PADDING": 0,
  "ROW_SEPARATOR_HEIGHT": 1,
  "ROW_NORMAL_STATE_TEXT_LIGHT_MODE_COLOR": "#000000",
  "ROW_NORMAL_STATE_TEXT_DARK_MODE_COLOR": "#ffffff",
  "ROW_NORMAL_STATE_TEXT_COLOR": "#000000",
  "ROW_NORMAL_STATE_SUBTEXT_LIGHT_MODE_COLOR": "#000000",
  "ROW_NORMAL_STATE_SUBTEXT_DARK_MODE_COLOR": "#ffffff",
  "ROW_NORMAL_STATE_SUBTEXT_COLOR": "#000000",
  "ROW_NORMAL_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "#000000",
  "ROW_NORMAL_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "#ffffff",
  "ROW_NORMAL_STATE_SIDE_TEXT_PRIMARY_COLOR": "#000000",
  "ROW_NORMAL_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "#000000",
  "ROW_NORMAL_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "#ffffff",
  "ROW_NORMAL_STATE_SIDE_TEXT_SECONDARY_COLOR": "#000000",
  "ROW_NORMAL_STATE_DRILL_LIGHT_MODE_COLOR": "#000000",
  "ROW_NORMAL_STATE_DRILL_DARK_MODE_COLOR": "#ffffff",
  "ROW_NORMAL_STATE_DRILL_COLOR": "#000000",
  "ROW_NORMAL_STATE_SEPARATOR_LIGHT_MODE_COLOR": "#000000",
  "ROW_NORMAL_STATE_SEPARATOR_DARK_MODE_COLOR": "#ffffff",
  "ROW_NORMAL_STATE_SEPARATOR_COLOR": "#000000",
  "ROW_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#000000",
  "ROW_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "#000000",
  "ROW_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "ROW_HOVER_STATE_TEXT_LIGHT_MODE_COLOR": "#000000",
  "ROW_HOVER_STATE_TEXT_DARK_MODE_COLOR": "#ffffff",
  "ROW_HOVER_STATE_TEXT_COLOR": "#000000",
  "ROW_HOVER_STATE_SUBTEXT_LIGHT_MODE_COLOR": "#000000",
  "ROW_HOVER_STATE_SUBTEXT_DARK_MODE_COLOR": "#ffffff",
  "ROW_HOVER_STATE_SUBTEXT_COLOR": "#000000",
  "ROW_HOVER_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "#000000",
  "ROW_HOVER_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "#ffffff",
  "ROW_HOVER_STATE_SIDE_TEXT_PRIMARY_COLOR": "#000000",
  "ROW_HOVER_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "#000000",
  "ROW_HOVER_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "#ffffff",
  "ROW_HOVER_STATE_SIDE_TEXT_SECONDARY_COLOR": "#000000",
  "ROW_HOVER_STATE_DRILL_LIGHT_MODE_COLOR": "#000000",
  "ROW_HOVER_STATE_DRILL_DARK_MODE_COLOR": "#ffffff",
  "ROW_HOVER_STATE_DRILL_COLOR": "#000000",
  "ROW_HOVER_STATE_SEPARATOR_LIGHT_MODE_COLOR": "#000000",
  "ROW_HOVER_STATE_SEPARATOR_DARK_MODE_COLOR": "#000000",
  "ROW_HOVER_STATE_SEPARATOR_COLOR": "#000000",
  "ROW_HOVER_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#e6f0ff",
  "ROW_HOVER_STATE_BACKGROUND_DARK_MODE_COLOR": "#001533",
  "ROW_HOVER_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "ROW_PRESSED_STATE_TEXT_LIGHT_MODE_COLOR": "#000000",
  "ROW_PRESSED_STATE_TEXT_DARK_MODE_COLOR": "#ffffff",
  "ROW_PRESSED_STATE_TEXT_COLOR": "#000000",
  "ROW_PRESSED_STATE_SUBTEXT_LIGHT_MODE_COLOR": "#000000",
  "ROW_PRESSED_STATE_SUBTEXT_DARK_MODE_COLOR": "#ffffff",
  "ROW_PRESSED_STATE_SUBTEXT_COLOR": "#000000",
  "ROW_PRESSED_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "#000000",
  "ROW_PRESSED_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "#ffffff",
  "ROW_PRESSED_STATE_SIDE_TEXT_PRIMARY_COLOR": "#000000",
  "ROW_PRESSED_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "#000000",
  "ROW_PRESSED_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "#ffffff",
  "ROW_PRESSED_STATE_SIDE_TEXT_SECONDARY_COLOR": "#000000",
  "ROW_PRESSED_STATE_DRILL_LIGHT_MODE_COLOR": "#000000",
  "ROW_PRESSED_STATE_DRILL_DARK_MODE_COLOR": "#ffffff",
  "ROW_PRESSED_STATE_DRILL_COLOR": "#000000",
  "ROW_PRESSED_STATE_SEPARATOR_LIGHT_MODE_COLOR": "#000000",
  "ROW_PRESSED_STATE_SEPARATOR_DARK_MODE_COLOR": "#000000",
  "ROW_PRESSED_STATE_SEPARATOR_COLOR": "#000000",
  "ROW_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#cce1ff",
  "ROW_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "#002559",
  "ROW_PRESSED_STATE_BACKGROUND_COLOR": "#cce1ff",
  "ROW_SELECTED_STATE_TEXT_LIGHT_MODE_COLOR": "#005ad9",
  "ROW_SELECTED_STATE_TEXT_DARK_MODE_COLOR": "#4a95ff",
  "ROW_SELECTED_STATE_TEXT_COLOR": "#005ad9",
  "ROW_SELECTED_STATE_SUBTEXT_LIGHT_MODE_COLOR": "#005ad9",
  "ROW_SELECTED_STATE_SUBTEXT_DARK_MODE_COLOR": "#4a95ff",
  "ROW_SELECTED_STATE_SUBTEXT_COLOR": "#005ad9",
  "ROW_SELECTED_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "#005ad9",
  "ROW_SELECTED_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "#4a95ff",
  "ROW_SELECTED_STATE_SIDE_TEXT_PRIMARY_COLOR": "#005ad9",
  "ROW_SELECTED_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "#005ad9",
  "ROW_SELECTED_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "#4a95ff",
  "ROW_SELECTED_STATE_SIDE_TEXT_SECONDARY_COLOR": "#005ad9",
  "ROW_SELECTED_STATE_DRILL_LIGHT_MODE_COLOR": "#000000",
  "ROW_SELECTED_STATE_DRILL_DARK_MODE_COLOR": "#ffffff",
  "ROW_SELECTED_STATE_DRILL_COLOR": "#000000",
  "ROW_SELECTED_STATE_SEPARATOR_LIGHT_MODE_COLOR": "#000000",
  "ROW_SELECTED_STATE_SEPARATOR_DARK_MODE_COLOR": "#000000",
  "ROW_SELECTED_STATE_SEPARATOR_COLOR": "#000000",
  "ROW_SELECTED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#e6f0ff",
  "ROW_SELECTED_STATE_BACKGROUND_DARK_MODE_COLOR": "#001533",
  "ROW_SELECTED_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "ROW_FOCUS_STATE_TEXT_LIGHT_MODE_COLOR": "#000000",
  "ROW_FOCUS_STATE_TEXT_DARK_MODE_COLOR": "#ffffff",
  "ROW_FOCUS_STATE_TEXT_COLOR": "#000000",
  "ROW_FOCUS_STATE_SUBTEXT_LIGHT_MODE_COLOR": "#000000",
  "ROW_FOCUS_STATE_SUBTEXT_DARK_MODE_COLOR": "#ffffff",
  "ROW_FOCUS_STATE_SUBTEXT_COLOR": "#000000",
  "ROW_FOCUS_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "#000000",
  "ROW_FOCUS_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "#ffffff",
  "ROW_FOCUS_STATE_SIDE_TEXT_PRIMARY_COLOR": "#000000",
  "ROW_FOCUS_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "#000000",
  "ROW_FOCUS_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "#ffffff",
  "ROW_FOCUS_STATE_SIDE_TEXT_SECONDARY_COLOR": "#000000",
  "ROW_FOCUS_STATE_DRILL_LIGHT_MODE_COLOR": "#000000",
  "ROW_FOCUS_STATE_DRILL_DARK_MODE_COLOR": "#ffffff",
  "ROW_FOCUS_STATE_DRILL_COLOR": "#000000",
  "ROW_FOCUS_STATE_SEPARATOR_LIGHT_MODE_COLOR": "#000000",
  "ROW_FOCUS_STATE_SEPARATOR_DARK_MODE_COLOR": "#000000",
  "ROW_FOCUS_STATE_SEPARATOR_COLOR": "#000000",
  "ROW_FOCUS_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#e6f0ff",
  "ROW_FOCUS_STATE_BACKGROUND_DARK_MODE_COLOR": "#001533",
  "ROW_FOCUS_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "ROW_DISABLED_STATE_TEXT_LIGHT_MODE_COLOR": "#000000",
  "ROW_DISABLED_STATE_TEXT_DARK_MODE_COLOR": "#ffffff",
  "ROW_DISABLED_STATE_TEXT_COLOR": "#000000",
  "ROW_DISABLED_STATE_SUBTEXT_LIGHT_MODE_COLOR": "#000000",
  "ROW_DISABLED_STATE_SUBTEXT_DARK_MODE_COLOR": "#ffffff",
  "ROW_DISABLED_STATE_SUBTEXT_COLOR": "#000000",
  "ROW_DISABLED_STATE_SIDE_TEXT_PRIMARY_LIGHT_MODE_COLOR": "#000000",
  "ROW_DISABLED_STATE_SIDE_TEXT_PRIMARY_DARK_MODE_COLOR": "#ffffff",
  "ROW_DISABLED_STATE_SIDE_TEXT_PRIMARY_COLOR": "#000000",
  "ROW_DISABLED_STATE_SIDE_TEXT_SECONDARY_LIGHT_MODE_COLOR": "#000000",
  "ROW_DISABLED_STATE_SIDE_TEXT_SECONDARY_DARK_MODE_COLOR": "#ffffff",
  "ROW_DISABLED_STATE_SIDE_TEXT_SECONDARY_COLOR": "#000000",
  "ROW_DISABLED_STATE_DRILL_LIGHT_MODE_COLOR": "#000000",
  "ROW_DISABLED_STATE_DRILL_DARK_MODE_COLOR": "#ffffff",
  "ROW_DISABLED_STATE_DRILL_COLOR": "#000000",
  "ROW_DISABLED_STATE_SEPARATOR_LIGHT_MODE_COLOR": "#000000",
  "ROW_DISABLED_STATE_SEPARATOR_DARK_MODE_COLOR": "#ffffff",
  "ROW_DISABLED_STATE_SEPARATOR_COLOR": "#000000",
  "ROW_DISABLED_STATE_IMAGE_OPACITY": 0.4,
  "ROW_DISABLED_STATE_LEADING_ACCESSORY_OPACITY": 0.4,
  "SEGMENTED_CONTROL_BACKGROUND_NORMAL_STATE_LIGHT_MODE_COLOR": "#000000",
  "SEGMENTED_CONTROL_BACKGROUND_NORMAL_STATE_DARK_MODE_COLOR": "#ffffff",
  "SEGMENTED_CONTROL_BACKGROUND_NORMAL_STATE_COLOR": "#000000",
  "SEGMENTED_CONTROL_BACKGROUND_DISABLED_STATE_LIGHT_MODE_COLOR": "#000000",
  "SEGMENTED_CONTROL_BACKGROUND_DISABLED_STATE_DARK_MODE_COLOR": "#ffffff",
  "SEGMENTED_CONTROL_BACKGROUND_DISABLED_STATE_COLOR": "#000000",
  "SEGMENTED_CONTROL_BACKGROUND_RADIUS": 6,
  "SEGMENTED_CONTROL_PADDING_HORIZONTAL": 4,
  "SEGMENTED_CONTROL_PADDING_VERTICAL": 4,
  "SEGMENTED_CONTROL_ANIMATION_DURATION": 330,
  "SEGMENTED_CONTROL_OPTION_BACKGROUND_NORMAL_STATE_LIGHT_MODE_COLOR": "#000000",
  "SEGMENTED_CONTROL_OPTION_BACKGROUND_NORMAL_STATE_DARK_MODE_COLOR": "#000000",
  "SEGMENTED_CONTROL_OPTION_BACKGROUND_NORMAL_STATE_COLOR": "#000000",
  "SEGMENTED_CONTROL_OPTION_BACKGROUND_SELECTED_STATE_LIGHT_MODE_COLOR": "#ffffff",
  "SEGMENTED_CONTROL_OPTION_BACKGROUND_SELECTED_STATE_DARK_MODE_COLOR": "#ffffff",
  "SEGMENTED_CONTROL_OPTION_BACKGROUND_SELECTED_STATE_COLOR": "#ffffff",
  "SEGMENTED_CONTROL_OPTION_BACKGROUND_HOVER_STATE_LIGHT_MODE_COLOR": "#e6f0ff",
  "SEGMENTED_CONTROL_OPTION_BACKGROUND_HOVER_STATE_DARK_MODE_COLOR": "#001533",
  "SEGMENTED_CONTROL_OPTION_BACKGROUND_HOVER_STATE_COLOR": "#e6f0ff",
  "SEGMENTED_CONTROL_OPTION_BACKGROUND_PRESSED_STATE_LIGHT_MODE_COLOR": "#cce1ff",
  "SEGMENTED_CONTROL_OPTION_BACKGROUND_PRESSED_STATE_DARK_MODE_COLOR": "#002559",
  "SEGMENTED_CONTROL_OPTION_BACKGROUND_PRESSED_STATE_COLOR": "#cce1ff",
  "SEGMENTED_CONTROL_OPTION_BACKGROUND_DISABLED_STATE_LIGHT_MODE_COLOR": "#000000",
  "SEGMENTED_CONTROL_OPTION_BACKGROUND_DISABLED_STATE_DARK_MODE_COLOR": "#000000",
  "SEGMENTED_CONTROL_OPTION_BACKGROUND_DISABLED_STATE_COLOR": "#000000",
  "SEGMENTED_CONTROL_OPTION_BACKGROUND_RADIUS": 4,
  "SEGMENTED_CONTROL_OPTION_PADDING_HORIZONTAL": 8,
  "SEGMENTED_CONTROL_OPTION_PADDING_VERTICAL": 8,
  "SEGMENTED_CONTROL_OPTION_LABEL_SIZE": 16,
  "SEGMENTED_CONTROL_OPTION_LABEL_LEADING": 24,
  "SEGMENTED_CONTROL_OPTION_LABEL_TRACKING": 0,
  "SEGMENTED_CONTROL_OPTION_LABEL_WEIGHT": 600,
  "SEGMENTED_CONTROL_OPTION_LABEL_CASE": "regular",
  "SEGMENTED_CONTROL_OPTION_LABEL_NUMBER_SPACING": "default",
  "SEGMENTED_CONTROL_OPTION_LABEL_SCALE": "paragraph-30",
  "SEGMENTED_CONTROL_OPTION_LABEL_FONT_FAMILY": "Square Sans Text",
  "SEGMENTED_CONTROL_OPTION_LABEL_NORMAL_STATE_LIGHT_MODE_COLOR": "#000000",
  "SEGMENTED_CONTROL_OPTION_LABEL_NORMAL_STATE_DARK_MODE_COLOR": "#ffffff",
  "SEGMENTED_CONTROL_OPTION_LABEL_NORMAL_STATE_COLOR": "#000000",
  "SEGMENTED_CONTROL_OPTION_LABEL_SELECTED_STATE_LIGHT_MODE_COLOR": "#000000",
  "SEGMENTED_CONTROL_OPTION_LABEL_SELECTED_STATE_DARK_MODE_COLOR": "#ffffff",
  "SEGMENTED_CONTROL_OPTION_LABEL_SELECTED_STATE_COLOR": "#000000",
  "SEGMENTED_CONTROL_OPTION_LABEL_HOVER_STATE_LIGHT_MODE_COLOR": "#000000",
  "SEGMENTED_CONTROL_OPTION_LABEL_HOVER_STATE_DARK_MODE_COLOR": "#ffffff",
  "SEGMENTED_CONTROL_OPTION_LABEL_HOVER_STATE_COLOR": "#000000",
  "SEGMENTED_CONTROL_OPTION_LABEL_PRESSED_STATE_LIGHT_MODE_COLOR": "#005ad9",
  "SEGMENTED_CONTROL_OPTION_LABEL_PRESSED_STATE_DARK_MODE_COLOR": "#4a95ff",
  "SEGMENTED_CONTROL_OPTION_LABEL_PRESSED_STATE_COLOR": "#005ad9",
  "SEGMENTED_CONTROL_OPTION_LABEL_DISABLED_STATE_LIGHT_MODE_COLOR": "#000000",
  "SEGMENTED_CONTROL_OPTION_LABEL_DISABLED_STATE_DARK_MODE_COLOR": "#ffffff",
  "SEGMENTED_CONTROL_OPTION_LABEL_DISABLED_STATE_COLOR": "#000000",
  "SELECT_CARET_ICON_ASSET": "chevron-down",
  "SELECT_CARET_ICON_WIDTH": 16,
  "SELECT_CARET_ICON_HEIGHT": 16,
  "SELECT_CARET_ICON_TINTABLE": true,
  "SELECT_CARET_LIGHT_MODE_COLOR": "#000000",
  "SELECT_CARET_DARK_MODE_COLOR": "#ffffff",
  "SELECT_CARET_COLOR": "#000000",
  "STEPPER_BORDER_RADIUS": 6,
  "STEPPER_NORMAL_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#ffffff",
  "STEPPER_NORMAL_STATE_BACKGROUND_DARK_MODE_COLOR": "#080808",
  "STEPPER_NORMAL_STATE_BACKGROUND_COLOR": "#ffffff",
  "STEPPER_NORMAL_STATE_BORDER_SIZE": 1,
  "STEPPER_NORMAL_STATE_NORMAL_VALIDITY_LIGHT_MODE_COLOR": "#000000",
  "STEPPER_NORMAL_STATE_NORMAL_VALIDITY_DARK_MODE_COLOR": "#ffffff",
  "STEPPER_NORMAL_STATE_NORMAL_VALIDITY_COLOR": "#000000",
  "STEPPER_NORMAL_STATE_INVALID_VALIDITY_LIGHT_MODE_COLOR": "#cc0023",
  "STEPPER_NORMAL_STATE_INVALID_VALIDITY_DARK_MODE_COLOR": "#cc0023",
  "STEPPER_NORMAL_STATE_INVALID_VALIDITY_COLOR": "#cc0023",
  "STEPPER_HOVER_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#ffffff",
  "STEPPER_HOVER_STATE_BACKGROUND_DARK_MODE_COLOR": "#080808",
  "STEPPER_HOVER_STATE_BACKGROUND_COLOR": "#ffffff",
  "STEPPER_HOVER_STATE_BORDER_SIZE": 1,
  "STEPPER_HOVER_STATE_NORMAL_VALIDITY_LIGHT_MODE_COLOR": "#006aff",
  "STEPPER_HOVER_STATE_NORMAL_VALIDITY_DARK_MODE_COLOR": "#006aff",
  "STEPPER_HOVER_STATE_NORMAL_VALIDITY_COLOR": "#006aff",
  "STEPPER_HOVER_STATE_INVALID_VALIDITY_LIGHT_MODE_COLOR": "#006aff",
  "STEPPER_HOVER_STATE_INVALID_VALIDITY_DARK_MODE_COLOR": "#006aff",
  "STEPPER_HOVER_STATE_INVALID_VALIDITY_COLOR": "#006aff",
  "STEPPER_FOCUS_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#ffffff",
  "STEPPER_FOCUS_STATE_BACKGROUND_DARK_MODE_COLOR": "#080808",
  "STEPPER_FOCUS_STATE_BACKGROUND_COLOR": "#ffffff",
  "STEPPER_FOCUS_STATE_BORDER_SIZE": 2,
  "STEPPER_FOCUS_STATE_NORMAL_VALIDITY_LIGHT_MODE_COLOR": "#006aff",
  "STEPPER_FOCUS_STATE_NORMAL_VALIDITY_DARK_MODE_COLOR": "#006aff",
  "STEPPER_FOCUS_STATE_NORMAL_VALIDITY_COLOR": "#006aff",
  "STEPPER_FOCUS_STATE_INVALID_VALIDITY_LIGHT_MODE_COLOR": "#006aff",
  "STEPPER_FOCUS_STATE_INVALID_VALIDITY_DARK_MODE_COLOR": "#006aff",
  "STEPPER_FOCUS_STATE_INVALID_VALIDITY_COLOR": "#006aff",
  "STEPPER_DISABLED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#000000",
  "STEPPER_DISABLED_STATE_BACKGROUND_DARK_MODE_COLOR": "#ffffff",
  "STEPPER_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "STEPPER_DISABLED_STATE_BORDER_SIZE": 1,
  "STEPPER_DISABLED_STATE_BORDER_LIGHT_MODE_COLOR": "#000000",
  "STEPPER_DISABLED_STATE_BORDER_DARK_MODE_COLOR": "#ffffff",
  "STEPPER_DISABLED_STATE_BORDER_COLOR": "#000000",
  "STEPPER_PADDING_SIZE": 12,
  "STEPPER_HORIZONTAL_SPACING": 12,
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_SIZE": 16,
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_LEADING": 24,
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_TRACKING": 0,
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_WEIGHT": 400,
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_CASE": "regular",
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_NUMBER_SPACING": "monospaced",
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_SCALE": "paragraph-30",
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_FONT_FAMILY": "Square Sans Text",
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_NORMAL_STATE_LIGHT_MODE_COLOR": "#000000",
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_NORMAL_STATE_DARK_MODE_COLOR": "#ffffff",
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_NORMAL_STATE_COLOR": "#000000",
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_DISABLED_STATE_LIGHT_MODE_COLOR": "#000000",
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_DISABLED_STATE_DARK_MODE_COLOR": "#ffffff",
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_DISABLED_STATE_COLOR": "#000000",
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_PLACEHOLDER_LIGHT_MODE_COLOR": "#000000",
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_PLACEHOLDER_DARK_MODE_COLOR": "#ffffff",
  "STEPPER_QUANTITY_INPUT_FIELD_VALUE_TEXT_PLACEHOLDER_COLOR": "#000000",
  "STEPPER_QUANTITY_INPUT_FIELD_MINIMUM_WIDTH_MULTIPLIER": 1.66,
  "STEPPER_BUTTON_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "STEPPER_BUTTON_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "STEPPER_BUTTON_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "STEPPER_BUTTON_NORMAL_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "STEPPER_BUTTON_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "STEPPER_BUTTON_NORMAL_STATE_ICON_COLOR": "#000000",
  "STEPPER_BUTTON_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "STEPPER_BUTTON_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "STEPPER_BUTTON_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "STEPPER_BUTTON_HOVER_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "STEPPER_BUTTON_HOVER_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "STEPPER_BUTTON_HOVER_STATE_ICON_COLOR": "#000000",
  "STEPPER_BUTTON_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#cce1ff",
  "STEPPER_BUTTON_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "STEPPER_BUTTON_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#002559",
  "STEPPER_BUTTON_PRESSED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "STEPPER_BUTTON_PRESSED_STATE_BACKGROUND_COLOR": "#cce1ff",
  "STEPPER_BUTTON_PRESSED_STATE_ICON_COLOR": "#000000",
  "STEPPER_BUTTON_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "STEPPER_BUTTON_FOCUS_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "STEPPER_BUTTON_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "STEPPER_BUTTON_FOCUS_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "STEPPER_BUTTON_FOCUS_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "STEPPER_BUTTON_FOCUS_STATE_ICON_COLOR": "#000000",
  "STEPPER_BUTTON_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "STEPPER_BUTTON_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "STEPPER_BUTTON_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "STEPPER_BUTTON_DISABLED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "STEPPER_BUTTON_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "STEPPER_BUTTON_DISABLED_STATE_ICON_COLOR": "#000000",
  "STEPPER_BUTTON_BORDER_RADIUS": 4,
  "STEPPER_BUTTON_PADDING_SIZE": 4,
  "STEPPER_BUTTON_WIDTH_MULTIPLIER": 1,
  "STEPPER_BUTTON_MINIMUM_HEIGHT": 24,
  "STEPPER_BUTTON_INCREMENT_ICON_ASSET": "plus",
  "STEPPER_BUTTON_INCREMENT_ICON_WIDTH": 24,
  "STEPPER_BUTTON_INCREMENT_ICON_HEIGHT": 24,
  "STEPPER_BUTTON_INCREMENT_ICON_TINTABLE": true,
  "STEPPER_BUTTON_INCREMENT_WIDTH": 16,
  "STEPPER_BUTTON_INCREMENT_HEIGHT": 16,
  "STEPPER_BUTTON_INCREMENT_SCALE": "paragraph-20",
  "STEPPER_BUTTON_DECREMENT_ICON_ASSET": "minus",
  "STEPPER_BUTTON_DECREMENT_ICON_WIDTH": 24,
  "STEPPER_BUTTON_DECREMENT_ICON_HEIGHT": 24,
  "STEPPER_BUTTON_DECREMENT_ICON_TINTABLE": true,
  "STEPPER_BUTTON_DECREMENT_WIDTH": 16,
  "STEPPER_BUTTON_DECREMENT_HEIGHT": 16,
  "STEPPER_BUTTON_DECREMENT_SCALE": "paragraph-20",
  "STICKY_SECTION_HEADER_TEXT_SIZE": 14,
  "STICKY_SECTION_HEADER_TEXT_LEADING": 22,
  "STICKY_SECTION_HEADER_TEXT_TRACKING": 0,
  "STICKY_SECTION_HEADER_TEXT_WEIGHT": 700,
  "STICKY_SECTION_HEADER_TEXT_CASE": "regular",
  "STICKY_SECTION_HEADER_TEXT_NUMBER_SPACING": "default",
  "STICKY_SECTION_HEADER_TEXT_SCALE": "heading-10",
  "STICKY_SECTION_HEADER_TEXT_FONT_FAMILY": "Square Sans Text",
  "STICKY_SECTION_HEADER_TEXT_IS_HEADER": true,
  "STICKY_SECTION_HEADER_TEXT_LIGHT_MODE_COLOR": "#000000",
  "STICKY_SECTION_HEADER_TEXT_DARK_MODE_COLOR": "#ffffff",
  "STICKY_SECTION_HEADER_TEXT_COLOR": "#000000",
  "STICKY_SECTION_HEADER_VERTICAL_PADDING": 9,
  "STICKY_SECTION_HEADER_BACKGROUND_LIGHT_MODE_COLOR": "#ffffff",
  "STICKY_SECTION_HEADER_BACKGROUND_DARK_MODE_COLOR": "#080808",
  "STICKY_SECTION_HEADER_BACKGROUND_COLOR": "#ffffff",
  "STICKY_SECTION_HEADER_SEPARATOR_LIGHT_MODE_COLOR": "#000000",
  "STICKY_SECTION_HEADER_SEPARATOR_DARK_MODE_COLOR": "#ffffff",
  "STICKY_SECTION_HEADER_SEPARATOR_HEIGHT": 1,
  "STICKY_SECTION_HEADER_SEPARATOR_COLOR": "#000000",
  "TABLE_CELL_HOVER_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#000000",
  "TABLE_CELL_HOVER_STATE_BACKGROUND_DARK_MODE_COLOR": "#ffffff",
  "TABLE_CELL_HOVER_STATE_BACKGROUND_COLOR": "#000000",
  "TABLE_CELL_PRESSED_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#e6f0ff",
  "TABLE_CELL_PRESSED_STATE_BACKGROUND_DARK_MODE_COLOR": "#001533",
  "TABLE_CELL_PRESSED_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "TABLE_CELL_FOCUS_STATE_BACKGROUND_LIGHT_MODE_COLOR": "#000000",
  "TABLE_CELL_FOCUS_STATE_BACKGROUND_DARK_MODE_COLOR": "#ffffff",
  "TABLE_CELL_FOCUS_STATE_BACKGROUND_COLOR": "#000000",
  "TABLE_CELL_DISABLED_STATE_TEXT_LIGHT_MODE_COLOR": "#000000",
  "TABLE_CELL_DISABLED_STATE_TEXT_DARK_MODE_COLOR": "#ffffff",
  "TABLE_CELL_DISABLED_STATE_TEXT_COLOR": "#000000",
  "TAG_HORIZONTAL_SPACING": 4,
  "TAG_MINIMUM_WIDTH_MULTIPLIER": 1.5,
  "TAG_REMOVE_INDICATOR_ICON_ASSET": "x",
  "TAG_REMOVE_INDICATOR_ICON_WIDTH": 24,
  "TAG_REMOVE_INDICATOR_ICON_HEIGHT": 24,
  "TAG_REMOVE_INDICATOR_ICON_TINTABLE": true,
  "TAG_REMOVE_INDICATOR_WIDTH": 16,
  "TAG_REMOVE_INDICATOR_HEIGHT": 16,
  "TAG_REMOVE_INDICATOR_SCALE": "paragraph-10",
  "TAG_DISABLED_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "TAG_DISABLED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "TAG_DISABLED_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "TAG_DISABLED_STATE_DARK_MODE_REMOVE_INDICATOR_COLOR": "#ffffff",
  "TAG_DISABLED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "TAG_DISABLED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "TAG_DISABLED_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "TAG_DISABLED_STATE_LIGHT_MODE_REMOVE_INDICATOR_COLOR": "#000000",
  "TAG_DISABLED_STATE_BACKGROUND_COLOR": "#000000",
  "TAG_DISABLED_STATE_ICON_COLOR": "#000000",
  "TAG_DISABLED_STATE_LABEL_COLOR": "#000000",
  "TAG_DISABLED_STATE_REMOVE_INDICATOR_COLOR": "#000000",
  "TAG_FOCUS_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "TAG_FOCUS_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "TAG_FOCUS_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "TAG_FOCUS_STATE_DARK_MODE_REMOVE_INDICATOR_COLOR": "#ffffff",
  "TAG_FOCUS_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "TAG_FOCUS_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "TAG_FOCUS_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "TAG_FOCUS_STATE_LIGHT_MODE_REMOVE_INDICATOR_COLOR": "#000000",
  "TAG_FOCUS_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "TAG_FOCUS_STATE_ICON_COLOR": "#000000",
  "TAG_FOCUS_STATE_LABEL_COLOR": "#000000",
  "TAG_FOCUS_STATE_REMOVE_INDICATOR_COLOR": "#000000",
  "TAG_HOVER_STATE_DARK_MODE_BACKGROUND_COLOR": "#001533",
  "TAG_HOVER_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "TAG_HOVER_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "TAG_HOVER_STATE_DARK_MODE_REMOVE_INDICATOR_COLOR": "#ffffff",
  "TAG_HOVER_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#e6f0ff",
  "TAG_HOVER_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "TAG_HOVER_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "TAG_HOVER_STATE_LIGHT_MODE_REMOVE_INDICATOR_COLOR": "#000000",
  "TAG_HOVER_STATE_BACKGROUND_COLOR": "#e6f0ff",
  "TAG_HOVER_STATE_ICON_COLOR": "#000000",
  "TAG_HOVER_STATE_LABEL_COLOR": "#000000",
  "TAG_HOVER_STATE_REMOVE_INDICATOR_COLOR": "#000000",
  "TAG_NORMAL_STATE_DARK_MODE_BACKGROUND_COLOR": "#ffffff",
  "TAG_NORMAL_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "TAG_NORMAL_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "TAG_NORMAL_STATE_DARK_MODE_REMOVE_INDICATOR_COLOR": "#ffffff",
  "TAG_NORMAL_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#000000",
  "TAG_NORMAL_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "TAG_NORMAL_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "TAG_NORMAL_STATE_LIGHT_MODE_REMOVE_INDICATOR_COLOR": "#000000",
  "TAG_NORMAL_STATE_BACKGROUND_COLOR": "#000000",
  "TAG_NORMAL_STATE_ICON_COLOR": "#000000",
  "TAG_NORMAL_STATE_LABEL_COLOR": "#000000",
  "TAG_NORMAL_STATE_REMOVE_INDICATOR_COLOR": "#000000",
  "TAG_PRESSED_STATE_DARK_MODE_BACKGROUND_COLOR": "#002559",
  "TAG_PRESSED_STATE_DARK_MODE_ICON_COLOR": "#ffffff",
  "TAG_PRESSED_STATE_DARK_MODE_LABEL_COLOR": "#ffffff",
  "TAG_PRESSED_STATE_DARK_MODE_REMOVE_INDICATOR_COLOR": "#ffffff",
  "TAG_PRESSED_STATE_LIGHT_MODE_BACKGROUND_COLOR": "#cce1ff",
  "TAG_PRESSED_STATE_LIGHT_MODE_ICON_COLOR": "#000000",
  "TAG_PRESSED_STATE_LIGHT_MODE_LABEL_COLOR": "#000000",
  "TAG_PRESSED_STATE_LIGHT_MODE_REMOVE_INDICATOR_COLOR": "#000000",
  "TAG_PRESSED_STATE_BACKGROUND_COLOR": "#cce1ff",
  "TAG_PRESSED_STATE_ICON_COLOR": "#000000",
  "TAG_PRESSED_STATE_LABEL_COLOR": "#000000",
  "TAG_PRESSED_STATE_REMOVE_INDICATOR_COLOR": "#000000",
  "TAG_TEXT_SIZE": 12,
  "TAG_TEXT_LEADING": 18,
  "TAG_TEXT_TRACKING": 0,
  "TAG_TEXT_WEIGHT": 400,
  "TAG_TEXT_CASE": "regular",
  "TAG_TEXT_NUMBER_SPACING": "default",
  "TAG_TEXT_SCALE": "paragraph-10",
  "TAG_TEXT_FONT_FAMILY": "Square Sans Text",
  "TAG_BASIC_FORMAT_LEFT_PADDING": 12,
  "TAG_BASIC_FORMAT_TOP_PADDING": 8,
  "TAG_BASIC_FORMAT_RIGHT_PADDING": 8,
  "TAG_BASIC_FORMAT_BOTTOM_PADDING": 8,
  "TAG_WITH_ICON_FORMAT_LEFT_PADDING": 8,
  "TAG_WITH_ICON_FORMAT_TOP_PADDING": 8,
  "TAG_WITH_ICON_FORMAT_RIGHT_PADDING": 8,
  "TAG_WITH_ICON_FORMAT_BOTTOM_PADDING": 8,
  "TEXT_LINK_GROUP_SEPARATOR_LIGHT_MODE_COLOR": "#000000",
  "TEXT_LINK_GROUP_SEPARATOR_DARK_MODE_COLOR": "#ffffff",
  "TEXT_LINK_GROUP_SEPARATOR_OPACITY": 0.3,
  "TEXT_LINK_GROUP_SEPARATOR_HEIGHT": 8,
  "TEXT_LINK_GROUP_SEPARATOR_WIDTH": 1,
  "TEXT_LINK_GROUP_SEPARATOR_COLOR": "#000000",
  "TEXT_LINK_GROUP_HORIZONTAL_SPACING": 12,
  "TEXT_LINK_GROUP_VERTICAL_SPACING": 0,
  "TEXT_LINK_DARK_MODE_COLOR": "#4a95ff",
  "TEXT_LINK_LIGHT_MODE_COLOR": "#005ad9",
  "TEXT_LINK_SMALL_SIZE_TEXT_SIZE": 14,
  "TEXT_LINK_SMALL_SIZE_TEXT_LEADING": 22,
  "TEXT_LINK_SMALL_SIZE_TEXT_TRACKING": 0,
  "TEXT_LINK_SMALL_SIZE_TEXT_WEIGHT": 600,
  "TEXT_LINK_SMALL_SIZE_TEXT_CASE": "regular",
  "TEXT_LINK_SMALL_SIZE_TEXT_NUMBER_SPACING": "default",
  "TEXT_LINK_SMALL_SIZE_TEXT_SCALE": "paragraph-20",
  "TEXT_LINK_SMALL_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
  "TEXT_LINK_SMALL_SIZE_VERTICAL_PADDING": 9,
  "TEXT_LINK_MEDIUM_SIZE_TEXT_SIZE": 16,
  "TEXT_LINK_MEDIUM_SIZE_TEXT_LEADING": 24,
  "TEXT_LINK_MEDIUM_SIZE_TEXT_TRACKING": 0,
  "TEXT_LINK_MEDIUM_SIZE_TEXT_WEIGHT": 600,
  "TEXT_LINK_MEDIUM_SIZE_TEXT_CASE": "regular",
  "TEXT_LINK_MEDIUM_SIZE_TEXT_NUMBER_SPACING": "default",
  "TEXT_LINK_MEDIUM_SIZE_TEXT_SCALE": "paragraph-30",
  "TEXT_LINK_MEDIUM_SIZE_TEXT_FONT_FAMILY": "Square Sans Text",
  "TEXT_LINK_MEDIUM_SIZE_VERTICAL_PADDING": 12,
  "TEXT_LINK_NORMAL_STATE_OPACITY": 1,
  "TEXT_LINK_HOVER_STATE_OPACITY": 0.6,
  "TEXT_LINK_PRESSED_STATE_OPACITY": 0.6,
  "TEXT_LINK_DISABLED_STATE_OPACITY": 0.3,
  "TEXT_LINK_NORMAL_VARIANT_DARK_MODE_COLOR": "#4a95ff",
  "TEXT_LINK_NORMAL_VARIANT_LIGHT_MODE_COLOR": "#005ad9",
  "TEXT_LINK_NORMAL_VARIANT_COLOR": "#005ad9",
  "TEXT_LINK_DESTRUCTIVE_VARIANT_DARK_MODE_COLOR": "#ff5a76",
  "TEXT_LINK_DESTRUCTIVE_VARIANT_LIGHT_MODE_COLOR": "#bf0020",
  "TEXT_LINK_DESTRUCTIVE_VARIANT_COLOR": "#bf0020",
  "TEXT_LINK_COLOR": "#005ad9",
  "TEXTAREA_FONT_SIZE": 16,
  "TEXTAREA_FONT_LEADING": 24,
  "TEXTAREA_FONT_TRACKING": 0,
  "TEXTAREA_FONT_WEIGHT": 400,
  "TEXTAREA_FONT_CASE": "regular",
  "TEXTAREA_FONT_NUMBER_SPACING": "default",
  "TEXTAREA_FONT_SCALE": "paragraph-30",
  "TEXTAREA_FONT_FONT_FAMILY": "Square Sans Text",
  "TEXTAREA_HEIGHT": 112,
  "TEXTAREA_MIN_HEIGHT": 112,
  "TEXTAREA_MINIMUM_HEIGHT": 112,
  "TEXTAREA_MAXIMUM_HEIGHT": 320,
  "TEXTAREA_PLACEHOLDER_LIGHT_MODE_COLOR": "#000000",
  "TEXTAREA_PLACEHOLDER_DARK_MODE_COLOR": "#ffffff",
  "TEXTAREA_PLACEHOLDER_COLOR": "#000000",
  "TOGGLE_WIDTH": 40,
  "TOGGLE_HEIGHT": 24,
  "TOGGLE_BORDER_RADIUS": 100,
  "TOGGLE_BORDER_SIZE": 2,
  "TOGGLE_PADDING_VERTICAL": 5,
  "TOGGLE_PADDING_HORIZONTAL": 5,
  "TOGGLE_FOCUS_RING_BUFFER_SIZE": 0,
  "TOGGLE_FOCUS_RING_BORDER_SIZE": 2,
  "TOGGLE_FOCUS_RING_LIGHT_MODE_COLOR": "#006aff",
  "TOGGLE_FOCUS_RING_DARK_MODE_COLOR": "#006aff",
  "TOGGLE_FOCUS_RING_COLOR": "#006aff",
  "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "#000000",
  "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "#000000",
  "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#ffffff",
  "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_DARK_MODE_TRACK_COLOR": "#000000",
  "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_DARK_MODE_THUMB_COLOR": "#ffffff",
  "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_BORDER_COLOR": "#000000",
  "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_TRACK_COLOR": "#000000",
  "TOGGLE_NORMAL_STATE_UNSELECTED_VALUE_THUMB_COLOR": "#000000",
  "TOGGLE_NORMAL_STATE_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#006aff",
  "TOGGLE_NORMAL_STATE_SELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "#006aff",
  "TOGGLE_NORMAL_STATE_SELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "#ffffff",
  "TOGGLE_NORMAL_STATE_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#006aff",
  "TOGGLE_NORMAL_STATE_SELECTED_VALUE_DARK_MODE_TRACK_COLOR": "#006aff",
  "TOGGLE_NORMAL_STATE_SELECTED_VALUE_DARK_MODE_THUMB_COLOR": "#ffffff",
  "TOGGLE_NORMAL_STATE_SELECTED_VALUE_BORDER_COLOR": "#006aff",
  "TOGGLE_NORMAL_STATE_SELECTED_VALUE_TRACK_COLOR": "#006aff",
  "TOGGLE_NORMAL_STATE_SELECTED_VALUE_THUMB_COLOR": "#ffffff",
  "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#006aff",
  "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "#000000",
  "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "#006aff",
  "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#006aff",
  "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_DARK_MODE_TRACK_COLOR": "#000000",
  "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_DARK_MODE_THUMB_COLOR": "#006aff",
  "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_BORDER_COLOR": "#006aff",
  "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_TRACK_COLOR": "#000000",
  "TOGGLE_HOVER_STATE_UNSELECTED_VALUE_THUMB_COLOR": "#006aff",
  "TOGGLE_HOVER_STATE_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#005fe5",
  "TOGGLE_HOVER_STATE_SELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "#005fe5",
  "TOGGLE_HOVER_STATE_SELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "#ffffff",
  "TOGGLE_HOVER_STATE_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#005fe5",
  "TOGGLE_HOVER_STATE_SELECTED_VALUE_DARK_MODE_TRACK_COLOR": "#005fe5",
  "TOGGLE_HOVER_STATE_SELECTED_VALUE_DARK_MODE_THUMB_COLOR": "#ffffff",
  "TOGGLE_HOVER_STATE_SELECTED_VALUE_BORDER_COLOR": "#005fe5",
  "TOGGLE_HOVER_STATE_SELECTED_VALUE_TRACK_COLOR": "#005fe5",
  "TOGGLE_HOVER_STATE_SELECTED_VALUE_THUMB_COLOR": "#ffffff",
  "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#0055cc",
  "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "#000000",
  "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "#0055cc",
  "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#0055cc",
  "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_DARK_MODE_TRACK_COLOR": "#000000",
  "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_DARK_MODE_THUMB_COLOR": "#0055cc",
  "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_BORDER_COLOR": "#0055cc",
  "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_TRACK_COLOR": "#000000",
  "TOGGLE_PRESSED_STATE_UNSELECTED_VALUE_THUMB_COLOR": "#0055cc",
  "TOGGLE_PRESSED_STATE_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#0055cc",
  "TOGGLE_PRESSED_STATE_SELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "#0055cc",
  "TOGGLE_PRESSED_STATE_SELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "#ffffff",
  "TOGGLE_PRESSED_STATE_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#0055cc",
  "TOGGLE_PRESSED_STATE_SELECTED_VALUE_DARK_MODE_TRACK_COLOR": "#0055cc",
  "TOGGLE_PRESSED_STATE_SELECTED_VALUE_DARK_MODE_THUMB_COLOR": "#ffffff",
  "TOGGLE_PRESSED_STATE_SELECTED_VALUE_BORDER_COLOR": "#0055cc",
  "TOGGLE_PRESSED_STATE_SELECTED_VALUE_TRACK_COLOR": "#0055cc",
  "TOGGLE_PRESSED_STATE_SELECTED_VALUE_THUMB_COLOR": "#ffffff",
  "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#006aff",
  "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "#000000",
  "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "#006aff",
  "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#006aff",
  "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_DARK_MODE_TRACK_COLOR": "#000000",
  "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_DARK_MODE_THUMB_COLOR": "#006aff",
  "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_BORDER_COLOR": "#006aff",
  "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_TRACK_COLOR": "#000000",
  "TOGGLE_FOCUS_STATE_UNSELECTED_VALUE_THUMB_COLOR": "#006aff",
  "TOGGLE_FOCUS_STATE_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#005fe5",
  "TOGGLE_FOCUS_STATE_SELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "#005fe5",
  "TOGGLE_FOCUS_STATE_SELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "#ffffff",
  "TOGGLE_FOCUS_STATE_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#005fe5",
  "TOGGLE_FOCUS_STATE_SELECTED_VALUE_DARK_MODE_TRACK_COLOR": "#005fe5",
  "TOGGLE_FOCUS_STATE_SELECTED_VALUE_DARK_MODE_THUMB_COLOR": "#ffffff",
  "TOGGLE_FOCUS_STATE_SELECTED_VALUE_BORDER_COLOR": "#005fe5",
  "TOGGLE_FOCUS_STATE_SELECTED_VALUE_TRACK_COLOR": "#005fe5",
  "TOGGLE_FOCUS_STATE_SELECTED_VALUE_THUMB_COLOR": "#ffffff",
  "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "#000000",
  "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "#000000",
  "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#ffffff",
  "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_DARK_MODE_TRACK_COLOR": "#ffffff",
  "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_DARK_MODE_THUMB_COLOR": "#ffffff",
  "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_BORDER_COLOR": "#000000",
  "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_TRACK_COLOR": "#000000",
  "TOGGLE_DISABLED_STATE_UNSELECTED_VALUE_THUMB_COLOR": "#000000",
  "TOGGLE_DISABLED_STATE_SELECTED_VALUE_LIGHT_MODE_BORDER_COLOR": "#000000",
  "TOGGLE_DISABLED_STATE_SELECTED_VALUE_LIGHT_MODE_TRACK_COLOR": "#000000",
  "TOGGLE_DISABLED_STATE_SELECTED_VALUE_LIGHT_MODE_THUMB_COLOR": "#ffffff",
  "TOGGLE_DISABLED_STATE_SELECTED_VALUE_DARK_MODE_BORDER_COLOR": "#000000",
  "TOGGLE_DISABLED_STATE_SELECTED_VALUE_DARK_MODE_TRACK_COLOR": "#ffffff",
  "TOGGLE_DISABLED_STATE_SELECTED_VALUE_DARK_MODE_THUMB_COLOR": "#ffffff",
  "TOGGLE_DISABLED_STATE_SELECTED_VALUE_BORDER_COLOR": "#000000",
  "TOGGLE_DISABLED_STATE_SELECTED_VALUE_TRACK_COLOR": "#000000",
  "TOGGLE_DISABLED_STATE_SELECTED_VALUE_THUMB_COLOR": "#ffffff",
  "CORE_ANIMATION_ENTER_TRANSITION_EASING": "cubic-bezier(0.26, 0.10, 0.48, 1.0)",
  "CORE_ANIMATION_ENTER_TRANSITION_FAST_SPEED_DURATION": 100,
  "CORE_ANIMATION_ENTER_TRANSITION_MODERATE_SPEED_DURATION": 240,
  "CORE_ANIMATION_ENTER_TRANSITION_SLOW_SPEED_DURATION": 400,
  "CORE_ANIMATION_EXIT_TRANSITION_EASING": "cubic-bezier(0.52, 0.0, 0.74, 0.0)",
  "CORE_ANIMATION_EXIT_TRANSITION_FAST_SPEED_DURATION": 100,
  "CORE_ANIMATION_EXIT_TRANSITION_MODERATE_SPEED_DURATION": 160,
  "CORE_ANIMATION_EXIT_TRANSITION_SLOW_SPEED_DURATION": 300,
  "CORE_ANIMATION_MOVE_TRANSITION_EASING": "cubic-bezier(0.76, 0.0, 0.24, 1.0)",
  "CORE_ANIMATION_MOVE_TRANSITION_FAST_SPEED_DURATION": 100,
  "CORE_ANIMATION_MOVE_TRANSITION_MODERATE_SPEED_DURATION": 240,
  "CORE_ANIMATION_MOVE_TRANSITION_SLOW_SPEED_DURATION": 400,
  "CORE_BORDER_10": 1,
  "CORE_BREAKPOINT_EXTRA_WIDE_MIN_WIDTH": 1024,
  "CORE_BREAKPOINT_WIDE_MIN_WIDTH": 800,
  "CORE_BREAKPOINT_WIDE_MIN_MAX_WIDTH": 1023,
  "CORE_BREAKPOINT_MEDIUM_MIN_WIDTH": 600,
  "CORE_BREAKPOINT_MEDIUM_MAX_WIDTH": 839,
  "CORE_BREAKPOINT_NARROW_MIN_WIDTH": 0,
  "CORE_BREAKPOINT_NARROW_MAX_WIDTH": 599,
  "CORE_TEXT_10_LIGHT_MODE_COLOR": "#000000",
  "CORE_TEXT_10_DARK_MODE_COLOR": "#ffffff",
  "CORE_TEXT_10_COLOR": "#000000",
  "CORE_TEXT_20_LIGHT_MODE_COLOR": "#000000",
  "CORE_TEXT_20_DARK_MODE_COLOR": "#ffffff",
  "CORE_TEXT_20_COLOR": "#000000",
  "CORE_TEXT_30_LIGHT_MODE_COLOR": "#000000",
  "CORE_TEXT_30_DARK_MODE_COLOR": "#ffffff",
  "CORE_TEXT_30_COLOR": "#000000",
  "CORE_TEXT_INVERSE_LIGHT_MODE_COLOR": "#ffffff",
  "CORE_TEXT_INVERSE_DARK_MODE_COLOR": "#000000",
  "CORE_TEXT_INVERSE_COLOR": "#ffffff",
  "CORE_TEXT_BLACK_LIGHT_MODE_COLOR": "#000000",
  "CORE_TEXT_BLACK_DARK_MODE_COLOR": "#000000",
  "CORE_TEXT_BLACK_COLOR": "#000000",
  "CORE_TEXT_WHITE_LIGHT_MODE_COLOR": "#ffffff",
  "CORE_TEXT_WHITE_DARK_MODE_COLOR": "#ffffff",
  "CORE_TEXT_WHITE_COLOR": "#ffffff",
  "CORE_FILL_10_LIGHT_MODE_COLOR": "#000000",
  "CORE_FILL_10_DARK_MODE_COLOR": "#ffffff",
  "CORE_FILL_10_COLOR": "#000000",
  "CORE_FILL_20_LIGHT_MODE_COLOR": "#000000",
  "CORE_FILL_20_DARK_MODE_COLOR": "#ffffff",
  "CORE_FILL_20_COLOR": "#000000",
  "CORE_FILL_30_LIGHT_MODE_COLOR": "#000000",
  "CORE_FILL_30_DARK_MODE_COLOR": "#ffffff",
  "CORE_FILL_30_COLOR": "#000000",
  "CORE_FILL_40_LIGHT_MODE_COLOR": "#000000",
  "CORE_FILL_40_DARK_MODE_COLOR": "#ffffff",
  "CORE_FILL_40_COLOR": "#000000",
  "CORE_FILL_50_LIGHT_MODE_COLOR": "#000000",
  "CORE_FILL_50_DARK_MODE_COLOR": "#ffffff",
  "CORE_FILL_50_COLOR": "#000000",
  "CORE_FILL_INVERSE_LIGHT_MODE_COLOR": "#ffffff",
  "CORE_FILL_INVERSE_DARK_MODE_COLOR": "#000000",
  "CORE_FILL_INVERSE_COLOR": "#ffffff",
  "CORE_FILL_BLACK_LIGHT_MODE_COLOR": "#000000",
  "CORE_FILL_BLACK_DARK_MODE_COLOR": "#000000",
  "CORE_FILL_BLACK_COLOR": "#000000",
  "CORE_FILL_WHITE_LIGHT_MODE_COLOR": "#ffffff",
  "CORE_FILL_WHITE_DARK_MODE_COLOR": "#ffffff",
  "CORE_FILL_WHITE_COLOR": "#ffffff",
  "CORE_DIVIDER_10_LIGHT_MODE_COLOR": "#000000",
  "CORE_DIVIDER_10_DARK_MODE_COLOR": "#ffffff",
  "CORE_DIVIDER_10_COLOR": "#000000",
  "CORE_DIVIDER_20_LIGHT_MODE_COLOR": "#000000",
  "CORE_DIVIDER_20_DARK_MODE_COLOR": "#ffffff",
  "CORE_DIVIDER_20_COLOR": "#000000",
  "CORE_SURFACE_5_LIGHT_MODE_COLOR": "#ffffff",
  "CORE_SURFACE_5_DARK_MODE_COLOR": "#080808",
  "CORE_SURFACE_5_COLOR": "#ffffff",
  "CORE_SURFACE_10_LIGHT_MODE_COLOR": "#ffffff",
  "CORE_SURFACE_10_DARK_MODE_COLOR": "#141414",
  "CORE_SURFACE_10_COLOR": "#ffffff",
  "CORE_SURFACE_20_LIGHT_MODE_COLOR": "#ffffff",
  "CORE_SURFACE_20_DARK_MODE_COLOR": "#1c1c1c",
  "CORE_SURFACE_20_COLOR": "#ffffff",
  "CORE_SURFACE_30_LIGHT_MODE_COLOR": "#ffffff",
  "CORE_SURFACE_30_DARK_MODE_COLOR": "#2d2d2d",
  "CORE_SURFACE_30_COLOR": "#ffffff",
  "CORE_SURFACE_INVERSE_LIGHT_MODE_COLOR": "#1a1a1a",
  "CORE_SURFACE_INVERSE_DARK_MODE_COLOR": "#ffffff",
  "CORE_SURFACE_INVERSE_COLOR": "#1a1a1a",
  "CORE_SURFACE_OVERLAY_LIGHT_MODE_COLOR": "#000000",
  "CORE_SURFACE_OVERLAY_DARK_MODE_COLOR": "#000000",
  "CORE_SURFACE_OVERLAY_COLOR": "#000000",
  "CORE_EMPHASIS_FILL_LIGHT_MODE_COLOR": "#006aff",
  "CORE_EMPHASIS_FILL_DARK_MODE_COLOR": "#006aff",
  "CORE_EMPHASIS_FILL_COLOR": "#006aff",
  "CORE_EMPHASIS_TEXT_LIGHT_MODE_COLOR": "#005ad9",
  "CORE_EMPHASIS_TEXT_DARK_MODE_COLOR": "#4a95ff",
  "CORE_EMPHASIS_TEXT_COLOR": "#005ad9",
  "CORE_EMPHASIS_10_LIGHT_MODE_COLOR": "#0055cc",
  "CORE_EMPHASIS_10_DARK_MODE_COLOR": "#0055cc",
  "CORE_EMPHASIS_10_COLOR": "#0055cc",
  "CORE_EMPHASIS_20_LIGHT_MODE_COLOR": "#005fe5",
  "CORE_EMPHASIS_20_DARK_MODE_COLOR": "#005fe5",
  "CORE_EMPHASIS_20_COLOR": "#005fe5",
  "CORE_EMPHASIS_30_LIGHT_MODE_COLOR": "#cce1ff",
  "CORE_EMPHASIS_30_DARK_MODE_COLOR": "#002559",
  "CORE_EMPHASIS_30_COLOR": "#cce1ff",
  "CORE_EMPHASIS_40_LIGHT_MODE_COLOR": "#e6f0ff",
  "CORE_EMPHASIS_40_DARK_MODE_COLOR": "#001533",
  "CORE_EMPHASIS_40_COLOR": "#e6f0ff",
  "CORE_SUCCESS_FILL_LIGHT_MODE_COLOR": "#00b23b",
  "CORE_SUCCESS_FILL_DARK_MODE_COLOR": "#00b33b",
  "CORE_SUCCESS_FILL_COLOR": "#00b23b",
  "CORE_SUCCESS_TEXT_LIGHT_MODE_COLOR": "#007d2a",
  "CORE_SUCCESS_TEXT_DARK_MODE_COLOR": "#16d956",
  "CORE_SUCCESS_TEXT_COLOR": "#007d2a",
  "CORE_SUCCESS_10_LIGHT_MODE_COLOR": "#00802a",
  "CORE_SUCCESS_10_DARK_MODE_COLOR": "#00802a",
  "CORE_SUCCESS_10_COLOR": "#00802a",
  "CORE_SUCCESS_20_LIGHT_MODE_COLOR": "#009933",
  "CORE_SUCCESS_20_DARK_MODE_COLOR": "#009933",
  "CORE_SUCCESS_20_COLOR": "#009933",
  "CORE_SUCCESS_30_LIGHT_MODE_COLOR": "#ccffdd",
  "CORE_SUCCESS_30_DARK_MODE_COLOR": "#00591e",
  "CORE_SUCCESS_30_COLOR": "#ccffdd",
  "CORE_SUCCESS_40_LIGHT_MODE_COLOR": "#e5ffee",
  "CORE_SUCCESS_40_DARK_MODE_COLOR": "#003311",
  "CORE_SUCCESS_40_COLOR": "#e5ffee",
  "CORE_WARNING_FILL_LIGHT_MODE_COLOR": "#ff9f40",
  "CORE_WARNING_FILL_DARK_MODE_COLOR": "#ff9f40",
  "CORE_WARNING_FILL_COLOR": "#ff9f40",
  "CORE_WARNING_TEXT_LIGHT_MODE_COLOR": "#945c25",
  "CORE_WARNING_TEXT_DARK_MODE_COLOR": "#ff9f40",
  "CORE_WARNING_TEXT_COLOR": "#945c25",
  "CORE_WARNING_10_LIGHT_MODE_COLOR": "#cc8033",
  "CORE_WARNING_10_DARK_MODE_COLOR": "#cc8033",
  "CORE_WARNING_10_COLOR": "#cc8033",
  "CORE_WARNING_20_LIGHT_MODE_COLOR": "#e68f39",
  "CORE_WARNING_20_DARK_MODE_COLOR": "#e68f39",
  "CORE_WARNING_20_COLOR": "#e68f39",
  "CORE_WARNING_30_LIGHT_MODE_COLOR": "#ffe6cc",
  "CORE_WARNING_30_DARK_MODE_COLOR": "#592d00",
  "CORE_WARNING_30_COLOR": "#ffe6cc",
  "CORE_WARNING_40_LIGHT_MODE_COLOR": "#fff2e6",
  "CORE_WARNING_40_DARK_MODE_COLOR": "#331a00",
  "CORE_WARNING_40_COLOR": "#fff2e6",
  "CORE_CRITICAL_FILL_LIGHT_MODE_COLOR": "#cc0023",
  "CORE_CRITICAL_FILL_DARK_MODE_COLOR": "#cc0023",
  "CORE_CRITICAL_FILL_COLOR": "#cc0023",
  "CORE_CRITICAL_TEXT_LIGHT_MODE_COLOR": "#bf0020",
  "CORE_CRITICAL_TEXT_DARK_MODE_COLOR": "#ff5a76",
  "CORE_CRITICAL_TEXT_COLOR": "#bf0020",
  "CORE_CRITICAL_10_LIGHT_MODE_COLOR": "#99001a",
  "CORE_CRITICAL_10_DARK_MODE_COLOR": "#99001a",
  "CORE_CRITICAL_10_COLOR": "#99001a",
  "CORE_CRITICAL_20_LIGHT_MODE_COLOR": "#b2001e",
  "CORE_CRITICAL_20_DARK_MODE_COLOR": "#b2001e",
  "CORE_CRITICAL_20_COLOR": "#b2001e",
  "CORE_CRITICAL_30_LIGHT_MODE_COLOR": "#ffccd5",
  "CORE_CRITICAL_30_DARK_MODE_COLOR": "#59000f",
  "CORE_CRITICAL_30_COLOR": "#ffccd5",
  "CORE_CRITICAL_40_LIGHT_MODE_COLOR": "#ffe5ea",
  "CORE_CRITICAL_40_DARK_MODE_COLOR": "#330009",
  "CORE_CRITICAL_40_COLOR": "#ffe5ea",
  "CORE_FOCUS_LIGHT_MODE_COLOR": "#006aff",
  "CORE_FOCUS_DARK_MODE_COLOR": "#006aff",
  "CORE_FOCUS_COLOR": "#006aff",
  "CORE_GREEN_FILL_LIGHT_MODE_COLOR": "#00b23b",
  "CORE_GREEN_FILL_DARK_MODE_COLOR": "#00b33b",
  "CORE_GREEN_FILL_COLOR": "#00b23b",
  "CORE_GREEN_TEXT_LIGHT_MODE_COLOR": "#007d2a",
  "CORE_GREEN_TEXT_DARK_MODE_COLOR": "#16d956",
  "CORE_GREEN_TEXT_COLOR": "#007d2a",
  "CORE_GREEN_10_LIGHT_MODE_COLOR": "#00802a",
  "CORE_GREEN_10_DARK_MODE_COLOR": "#00802a",
  "CORE_GREEN_10_COLOR": "#00802a",
  "CORE_GREEN_20_LIGHT_MODE_COLOR": "#009933",
  "CORE_GREEN_20_DARK_MODE_COLOR": "#009933",
  "CORE_GREEN_20_COLOR": "#009933",
  "CORE_GREEN_30_LIGHT_MODE_COLOR": "#ccffdd",
  "CORE_GREEN_30_DARK_MODE_COLOR": "#00591e",
  "CORE_GREEN_30_COLOR": "#ccffdd",
  "CORE_GREEN_40_LIGHT_MODE_COLOR": "#e5ffee",
  "CORE_GREEN_40_DARK_MODE_COLOR": "#003311",
  "CORE_GREEN_40_COLOR": "#e5ffee",
  "CORE_FOREST_FILL_LIGHT_MODE_COLOR": "#19802a",
  "CORE_FOREST_FILL_DARK_MODE_COLOR": "#19802a",
  "CORE_FOREST_FILL_COLOR": "#19802a",
  "CORE_FOREST_TEXT_LIGHT_MODE_COLOR": "#007d2a",
  "CORE_FOREST_TEXT_DARK_MODE_COLOR": "#16d956",
  "CORE_FOREST_TEXT_COLOR": "#007d2a",
  "CORE_FOREST_10_LIGHT_MODE_COLOR": "#0f4d19",
  "CORE_FOREST_10_DARK_MODE_COLOR": "#0f4d19",
  "CORE_FOREST_10_COLOR": "#0f4d19",
  "CORE_FOREST_20_LIGHT_MODE_COLOR": "#146622",
  "CORE_FOREST_20_DARK_MODE_COLOR": "#146622",
  "CORE_FOREST_20_COLOR": "#146622",
  "CORE_FOREST_30_LIGHT_MODE_COLOR": "#ccffd5",
  "CORE_FOREST_30_DARK_MODE_COLOR": "#00590f",
  "CORE_FOREST_30_COLOR": "#ccffd5",
  "CORE_FOREST_40_LIGHT_MODE_COLOR": "#e6ffea",
  "CORE_FOREST_40_DARK_MODE_COLOR": "#003308",
  "CORE_FOREST_40_COLOR": "#e6ffea",
  "CORE_TEAL_FILL_LIGHT_MODE_COLOR": "#12bf94",
  "CORE_TEAL_FILL_DARK_MODE_COLOR": "#12bf94",
  "CORE_TEAL_FILL_COLOR": "#12bf94",
  "CORE_TEAL_TEXT_LIGHT_MODE_COLOR": "#0c785d",
  "CORE_TEAL_TEXT_DARK_MODE_COLOR": "#16d8a7",
  "CORE_TEAL_TEXT_COLOR": "#0c785d",
  "CORE_TEAL_10_LIGHT_MODE_COLOR": "#0d8c6d",
  "CORE_TEAL_10_DARK_MODE_COLOR": "#0d8c6d",
  "CORE_TEAL_10_COLOR": "#0d8c6d",
  "CORE_TEAL_20_LIGHT_MODE_COLOR": "#10a680",
  "CORE_TEAL_20_DARK_MODE_COLOR": "#10a680",
  "CORE_TEAL_20_COLOR": "#10a680",
  "CORE_TEAL_30_LIGHT_MODE_COLOR": "#ccfff2",
  "CORE_TEAL_30_DARK_MODE_COLOR": "#005943",
  "CORE_TEAL_30_COLOR": "#ccfff2",
  "CORE_TEAL_40_LIGHT_MODE_COLOR": "#e6fff9",
  "CORE_TEAL_40_DARK_MODE_COLOR": "#003326",
  "CORE_TEAL_40_COLOR": "#e6fff9",
  "CORE_BLUE_FILL_LIGHT_MODE_COLOR": "#006aff",
  "CORE_BLUE_FILL_DARK_MODE_COLOR": "#006aff",
  "CORE_BLUE_FILL_COLOR": "#006aff",
  "CORE_BLUE_TEXT_LIGHT_MODE_COLOR": "#005ad9",
  "CORE_BLUE_TEXT_DARK_MODE_COLOR": "#4a95ff",
  "CORE_BLUE_TEXT_COLOR": "#005ad9",
  "CORE_BLUE_10_LIGHT_MODE_COLOR": "#0055cc",
  "CORE_BLUE_10_DARK_MODE_COLOR": "#0055cc",
  "CORE_BLUE_10_COLOR": "#0055cc",
  "CORE_BLUE_20_LIGHT_MODE_COLOR": "#005fe5",
  "CORE_BLUE_20_DARK_MODE_COLOR": "#005fe5",
  "CORE_BLUE_20_COLOR": "#005fe5",
  "CORE_BLUE_30_LIGHT_MODE_COLOR": "#cce1ff",
  "CORE_BLUE_30_DARK_MODE_COLOR": "#002559",
  "CORE_BLUE_30_COLOR": "#cce1ff",
  "CORE_BLUE_40_LIGHT_MODE_COLOR": "#e6f0ff",
  "CORE_BLUE_40_DARK_MODE_COLOR": "#001533",
  "CORE_BLUE_40_COLOR": "#e6f0ff",
  "CORE_SKY_FILL_LIGHT_MODE_COLOR": "#2693ff",
  "CORE_SKY_FILL_DARK_MODE_COLOR": "#2693ff",
  "CORE_SKY_FILL_COLOR": "#2693ff",
  "CORE_SKY_TEXT_LIGHT_MODE_COLOR": "#0f65ba",
  "CORE_SKY_TEXT_DARK_MODE_COLOR": "#2e97ff",
  "CORE_SKY_TEXT_COLOR": "#0f65ba",
  "CORE_SKY_10_LIGHT_MODE_COLOR": "#1f75cc",
  "CORE_SKY_10_DARK_MODE_COLOR": "#1f75cc",
  "CORE_SKY_10_COLOR": "#1f75cc",
  "CORE_SKY_20_LIGHT_MODE_COLOR": "#2284e6",
  "CORE_SKY_20_DARK_MODE_COLOR": "#2284e6",
  "CORE_SKY_20_COLOR": "#2284e6",
  "CORE_SKY_30_LIGHT_MODE_COLOR": "#cce6ff",
  "CORE_SKY_30_DARK_MODE_COLOR": "#002d59",
  "CORE_SKY_30_COLOR": "#cce6ff",
  "CORE_SKY_40_LIGHT_MODE_COLOR": "#e6f2ff",
  "CORE_SKY_40_DARK_MODE_COLOR": "#001a33",
  "CORE_SKY_40_COLOR": "#e6f2ff",
  "CORE_PURPLE_FILL_LIGHT_MODE_COLOR": "#8716d9",
  "CORE_PURPLE_FILL_DARK_MODE_COLOR": "#8716d9",
  "CORE_PURPLE_FILL_COLOR": "#8716d9",
  "CORE_PURPLE_TEXT_LIGHT_MODE_COLOR": "#8716d9",
  "CORE_PURPLE_TEXT_DARK_MODE_COLOR": "#c26eff",
  "CORE_PURPLE_TEXT_COLOR": "#8716d9",
  "CORE_PURPLE_10_LIGHT_MODE_COLOR": "#6811a6",
  "CORE_PURPLE_10_DARK_MODE_COLOR": "#6811a6",
  "CORE_PURPLE_10_COLOR": "#6811a6",
  "CORE_PURPLE_20_LIGHT_MODE_COLOR": "#7813bf",
  "CORE_PURPLE_20_DARK_MODE_COLOR": "#7813bf",
  "CORE_PURPLE_20_COLOR": "#7813bf",
  "CORE_PURPLE_30_LIGHT_MODE_COLOR": "#eaccff",
  "CORE_PURPLE_30_DARK_MODE_COLOR": "#340059",
  "CORE_PURPLE_30_COLOR": "#eaccff",
  "CORE_PURPLE_40_LIGHT_MODE_COLOR": "#f4e6ff",
  "CORE_PURPLE_40_DARK_MODE_COLOR": "#1e0033",
  "CORE_PURPLE_40_COLOR": "#f4e6ff",
  "CORE_PINK_FILL_LIGHT_MODE_COLOR": "#d936b0",
  "CORE_PINK_FILL_DARK_MODE_COLOR": "#d936b0",
  "CORE_PINK_FILL_COLOR": "#d936b0",
  "CORE_PINK_TEXT_LIGHT_MODE_COLOR": "#a82a88",
  "CORE_PINK_TEXT_DARK_MODE_COLOR": "#ff43d0",
  "CORE_PINK_TEXT_COLOR": "#a82a88",
  "CORE_PINK_10_LIGHT_MODE_COLOR": "#a62987",
  "CORE_PINK_10_DARK_MODE_COLOR": "#a62987",
  "CORE_PINK_10_COLOR": "#a62987",
  "CORE_PINK_20_LIGHT_MODE_COLOR": "#bf309b",
  "CORE_PINK_20_DARK_MODE_COLOR": "#bf309b",
  "CORE_PINK_20_COLOR": "#bf309b",
  "CORE_PINK_30_LIGHT_MODE_COLOR": "#ffccf2",
  "CORE_PINK_30_DARK_MODE_COLOR": "#590043",
  "CORE_PINK_30_COLOR": "#ffccf2",
  "CORE_PINK_40_LIGHT_MODE_COLOR": "#ffe6f9",
  "CORE_PINK_40_DARK_MODE_COLOR": "#330026",
  "CORE_PINK_40_COLOR": "#ffe6f9",
  "CORE_BURGUNDY_FILL_LIGHT_MODE_COLOR": "#990838",
  "CORE_BURGUNDY_FILL_DARK_MODE_COLOR": "#990838",
  "CORE_BURGUNDY_FILL_COLOR": "#990838",
  "CORE_BURGUNDY_TEXT_LIGHT_MODE_COLOR": "#990838",
  "CORE_BURGUNDY_TEXT_DARK_MODE_COLOR": "#ff568e",
  "CORE_BURGUNDY_TEXT_COLOR": "#990838",
  "CORE_BURGUNDY_10_LIGHT_MODE_COLOR": "#660525",
  "CORE_BURGUNDY_10_DARK_MODE_COLOR": "#660525",
  "CORE_BURGUNDY_10_COLOR": "#660525",
  "CORE_BURGUNDY_20_LIGHT_MODE_COLOR": "#80062f",
  "CORE_BURGUNDY_20_DARK_MODE_COLOR": "#80062f",
  "CORE_BURGUNDY_20_COLOR": "#80062f",
  "CORE_BURGUNDY_30_LIGHT_MODE_COLOR": "#ffccdd",
  "CORE_BURGUNDY_30_DARK_MODE_COLOR": "#59001e",
  "CORE_BURGUNDY_30_COLOR": "#ffccdd",
  "CORE_BURGUNDY_40_LIGHT_MODE_COLOR": "#ffe6ee",
  "CORE_BURGUNDY_40_DARK_MODE_COLOR": "#330011",
  "CORE_BURGUNDY_40_COLOR": "#ffe6ee",
  "CORE_RED_FILL_LIGHT_MODE_COLOR": "#cc0023",
  "CORE_RED_FILL_DARK_MODE_COLOR": "#cc0023",
  "CORE_RED_FILL_COLOR": "#cc0023",
  "CORE_RED_TEXT_LIGHT_MODE_COLOR": "#bf0020",
  "CORE_RED_TEXT_DARK_MODE_COLOR": "#ff5a76",
  "CORE_RED_TEXT_COLOR": "#bf0020",
  "CORE_RED_10_LIGHT_MODE_COLOR": "#99001a",
  "CORE_RED_10_DARK_MODE_COLOR": "#99001a",
  "CORE_RED_10_COLOR": "#99001a",
  "CORE_RED_20_LIGHT_MODE_COLOR": "#b2001e",
  "CORE_RED_20_DARK_MODE_COLOR": "#b2001e",
  "CORE_RED_20_COLOR": "#b2001e",
  "CORE_RED_30_LIGHT_MODE_COLOR": "#ffccd5",
  "CORE_RED_30_DARK_MODE_COLOR": "#59000f",
  "CORE_RED_30_COLOR": "#ffccd5",
  "CORE_RED_40_LIGHT_MODE_COLOR": "#ffe5ea",
  "CORE_RED_40_DARK_MODE_COLOR": "#330009",
  "CORE_RED_40_COLOR": "#ffe5ea",
  "CORE_ORANGE_FILL_LIGHT_MODE_COLOR": "#f25b3d",
  "CORE_ORANGE_FILL_DARK_MODE_COLOR": "#f25b3d",
  "CORE_ORANGE_FILL_COLOR": "#f25b3d",
  "CORE_ORANGE_TEXT_LIGHT_MODE_COLOR": "#a83f2a",
  "CORE_ORANGE_TEXT_DARK_MODE_COLOR": "#ff5f3f",
  "CORE_ORANGE_TEXT_COLOR": "#a83f2a",
  "CORE_ORANGE_10_LIGHT_MODE_COLOR": "#bf4830",
  "CORE_ORANGE_10_DARK_MODE_COLOR": "#bf4830",
  "CORE_ORANGE_10_COLOR": "#bf4830",
  "CORE_ORANGE_20_LIGHT_MODE_COLOR": "#db5237",
  "CORE_ORANGE_20_DARK_MODE_COLOR": "#db5237",
  "CORE_ORANGE_20_COLOR": "#db5237",
  "CORE_ORANGE_30_LIGHT_MODE_COLOR": "#ffd5cc",
  "CORE_ORANGE_30_DARK_MODE_COLOR": "#590f00",
  "CORE_ORANGE_30_COLOR": "#ffd5cc",
  "CORE_ORANGE_40_LIGHT_MODE_COLOR": "#ffeae6",
  "CORE_ORANGE_40_DARK_MODE_COLOR": "#330800",
  "CORE_ORANGE_40_COLOR": "#ffeae6",
  "CORE_GOLD_FILL_LIGHT_MODE_COLOR": "#ff9f40",
  "CORE_GOLD_FILL_DARK_MODE_COLOR": "#ff9f40",
  "CORE_GOLD_FILL_COLOR": "#ff9f40",
  "CORE_GOLD_TEXT_LIGHT_MODE_COLOR": "#945c25",
  "CORE_GOLD_TEXT_DARK_MODE_COLOR": "#ff9f40",
  "CORE_GOLD_TEXT_COLOR": "#945c25",
  "CORE_GOLD_10_LIGHT_MODE_COLOR": "#cc8033",
  "CORE_GOLD_10_DARK_MODE_COLOR": "#cc8033",
  "CORE_GOLD_10_COLOR": "#cc8033",
  "CORE_GOLD_20_LIGHT_MODE_COLOR": "#e68f39",
  "CORE_GOLD_20_DARK_MODE_COLOR": "#e68f39",
  "CORE_GOLD_20_COLOR": "#e68f39",
  "CORE_GOLD_30_LIGHT_MODE_COLOR": "#ffe6cc",
  "CORE_GOLD_30_DARK_MODE_COLOR": "#592d00",
  "CORE_GOLD_30_COLOR": "#ffe6cc",
  "CORE_GOLD_40_LIGHT_MODE_COLOR": "#fff2e6",
  "CORE_GOLD_40_DARK_MODE_COLOR": "#331a00",
  "CORE_GOLD_40_COLOR": "#fff2e6",
  "CORE_YELLOW_FILL_LIGHT_MODE_COLOR": "#ffbf00",
  "CORE_YELLOW_FILL_DARK_MODE_COLOR": "#ffbf00",
  "CORE_YELLOW_FILL_COLOR": "#ffbf00",
  "CORE_YELLOW_TEXT_LIGHT_MODE_COLOR": "#876500",
  "CORE_YELLOW_TEXT_DARK_MODE_COLOR": "#ffbf00",
  "CORE_YELLOW_TEXT_COLOR": "#876500",
  "CORE_YELLOW_10_LIGHT_MODE_COLOR": "#cc9900",
  "CORE_YELLOW_10_DARK_MODE_COLOR": "#cc9900",
  "CORE_YELLOW_10_COLOR": "#cc9900",
  "CORE_YELLOW_20_LIGHT_MODE_COLOR": "#e5ac00",
  "CORE_YELLOW_20_DARK_MODE_COLOR": "#e5ac00",
  "CORE_YELLOW_20_COLOR": "#e5ac00",
  "CORE_YELLOW_30_LIGHT_MODE_COLOR": "#fff2cc",
  "CORE_YELLOW_30_DARK_MODE_COLOR": "#594300",
  "CORE_YELLOW_30_COLOR": "#fff2cc",
  "CORE_YELLOW_40_LIGHT_MODE_COLOR": "#fff9e5",
  "CORE_YELLOW_40_DARK_MODE_COLOR": "#332600",
  "CORE_YELLOW_40_COLOR": "#fff9e5",
  "CORE_TAUPE_FILL_LIGHT_MODE_COLOR": "#a67c53",
  "CORE_TAUPE_FILL_DARK_MODE_COLOR": "#a67c53",
  "CORE_TAUPE_FILL_COLOR": "#a67c53",
  "CORE_TAUPE_TEXT_LIGHT_MODE_COLOR": "#826141",
  "CORE_TAUPE_TEXT_DARK_MODE_COLOR": "#c99866",
  "CORE_TAUPE_TEXT_COLOR": "#826141",
  "CORE_TAUPE_10_LIGHT_MODE_COLOR": "#735639",
  "CORE_TAUPE_10_DARK_MODE_COLOR": "#735639",
  "CORE_TAUPE_10_COLOR": "#735639",
  "CORE_TAUPE_20_LIGHT_MODE_COLOR": "#8c6946",
  "CORE_TAUPE_20_DARK_MODE_COLOR": "#8c6946",
  "CORE_TAUPE_20_COLOR": "#8c6946",
  "CORE_TAUPE_30_LIGHT_MODE_COLOR": "#ffe6cc",
  "CORE_TAUPE_30_DARK_MODE_COLOR": "#592d00",
  "CORE_TAUPE_30_COLOR": "#ffe6cc",
  "CORE_TAUPE_40_LIGHT_MODE_COLOR": "#fff2e6",
  "CORE_TAUPE_40_DARK_MODE_COLOR": "#331a00",
  "CORE_TAUPE_40_COLOR": "#fff2e6",
  "CORE_BROWN_FILL_LIGHT_MODE_COLOR": "#664a2e",
  "CORE_BROWN_FILL_DARK_MODE_COLOR": "#664d33",
  "CORE_BROWN_FILL_COLOR": "#664a2e",
  "CORE_BROWN_TEXT_LIGHT_MODE_COLOR": "#664a2e",
  "CORE_BROWN_TEXT_DARK_MODE_COLOR": "#c99866",
  "CORE_BROWN_TEXT_COLOR": "#664a2e",
  "CORE_BROWN_10_LIGHT_MODE_COLOR": "#332517",
  "CORE_BROWN_10_DARK_MODE_COLOR": "#33261a",
  "CORE_BROWN_10_COLOR": "#332517",
  "CORE_BROWN_20_LIGHT_MODE_COLOR": "#4d3722",
  "CORE_BROWN_20_DARK_MODE_COLOR": "#4d3926",
  "CORE_BROWN_20_COLOR": "#4d3722",
  "CORE_BROWN_30_LIGHT_MODE_COLOR": "#ffe6cc",
  "CORE_BROWN_30_DARK_MODE_COLOR": "#592d00",
  "CORE_BROWN_30_COLOR": "#ffe6cc",
  "CORE_BROWN_40_LIGHT_MODE_COLOR": "#fff2e6",
  "CORE_BROWN_40_DARK_MODE_COLOR": "#331900",
  "CORE_BROWN_40_COLOR": "#fff2e6",
  "CORE_EXTRA_WIDE_VIEWPORT_GRID_COLUMN_COUNT": 4,
  "CORE_EXTRA_WIDE_VIEWPORT_GRID_HORIZONTAL_SPACING": 16,
  "CORE_EXTRA_WIDE_VIEWPORT_GRID_VERTICAL_SPACING": 16,
  "CORE_EXTRA_WIDE_VIEWPORT_GRID_ITEM_SMALL_SIZE_COLUMN_SPAN": 1,
  "CORE_EXTRA_WIDE_VIEWPORT_GRID_ITEM_MEDIUM_SIZE_COLUMN_SPAN": 2,
  "CORE_EXTRA_WIDE_VIEWPORT_GRID_ITEM_LARGE_SIZE_COLUMN_SPAN": 3,
  "CORE_EXTRA_WIDE_VIEWPORT_GRID_ITEM_FULL_SIZE_COLUMN_SPAN": 4,
  "CORE_WIDE_VIEWPORT_GRID_COLUMN_COUNT": 4,
  "CORE_WIDE_VIEWPORT_GRID_HORIZONTAL_SPACING": 16,
  "CORE_WIDE_VIEWPORT_GRID_VERTICAL_SPACING": 16,
  "CORE_WIDE_VIEWPORT_GRID_ITEM_SMALL_SIZE_COLUMN_SPAN": 1,
  "CORE_WIDE_VIEWPORT_GRID_ITEM_MEDIUM_SIZE_COLUMN_SPAN": 2,
  "CORE_WIDE_VIEWPORT_GRID_ITEM_LARGE_SIZE_COLUMN_SPAN": 3,
  "CORE_WIDE_VIEWPORT_GRID_ITEM_FULL_SIZE_COLUMN_SPAN": 4,
  "CORE_MEDIUM_VIEWPORT_GRID_COLUMN_COUNT": 2,
  "CORE_MEDIUM_VIEWPORT_GRID_HORIZONTAL_SPACING": 16,
  "CORE_MEDIUM_VIEWPORT_GRID_VERTICAL_SPACING": 16,
  "CORE_MEDIUM_VIEWPORT_GRID_ITEM_SMALL_SIZE_COLUMN_SPAN": 1,
  "CORE_MEDIUM_VIEWPORT_GRID_ITEM_MEDIUM_SIZE_COLUMN_SPAN": 1,
  "CORE_MEDIUM_VIEWPORT_GRID_ITEM_LARGE_SIZE_COLUMN_SPAN": 1,
  "CORE_MEDIUM_VIEWPORT_GRID_ITEM_FULL_SIZE_COLUMN_SPAN": 2,
  "CORE_NARROW_VIEWPORT_GRID_COLUMN_COUNT": 1,
  "CORE_NARROW_VIEWPORT_GRID_HORIZONTAL_SPACING": 16,
  "CORE_NARROW_VIEWPORT_GRID_VERTICAL_SPACING": 16,
  "CORE_NARROW_VIEWPORT_GRID_ITEM_SMALL_SIZE_COLUMN_SPAN": 1,
  "CORE_NARROW_VIEWPORT_GRID_ITEM_MEDIUM_SIZE_COLUMN_SPAN": 1,
  "CORE_NARROW_VIEWPORT_GRID_ITEM_LARGE_SIZE_COLUMN_SPAN": 1,
  "CORE_NARROW_VIEWPORT_GRID_ITEM_FULL_SIZE_COLUMN_SPAN": 1,
  "CORE_ICON_EXPAND_16_FIDELITY_ASSET": "chevron-down",
  "CORE_ICON_EXPAND_16_FIDELITY_WIDTH": 16,
  "CORE_ICON_EXPAND_16_FIDELITY_HEIGHT": 16,
  "CORE_ICON_EXPAND_16_FIDELITY_TINTABLE": true,
  "CORE_ICON_COLLAPSE_16_FIDELITY_ASSET": "chevron-up",
  "CORE_ICON_COLLAPSE_16_FIDELITY_WIDTH": 16,
  "CORE_ICON_COLLAPSE_16_FIDELITY_HEIGHT": 16,
  "CORE_ICON_COLLAPSE_16_FIDELITY_TINTABLE": true,
  "CORE_ICON_CONTINUE_16_FIDELITY_ASSET": "chevron-right",
  "CORE_ICON_CONTINUE_16_FIDELITY_WIDTH": 16,
  "CORE_ICON_CONTINUE_16_FIDELITY_HEIGHT": 16,
  "CORE_ICON_CONTINUE_16_FIDELITY_TINTABLE": true,
  "CORE_ICON_RETURN_16_FIDELITY_ASSET": "chevron-left",
  "CORE_ICON_RETURN_16_FIDELITY_WIDTH": 16,
  "CORE_ICON_RETURN_16_FIDELITY_HEIGHT": 16,
  "CORE_ICON_RETURN_16_FIDELITY_TINTABLE": true,
  "CORE_ICON_CLEAR_24_FIDELITY_ASSET": "x",
  "CORE_ICON_CLEAR_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_CLEAR_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_CLEAR_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_CLOSE_24_FIDELITY_ASSET": "x",
  "CORE_ICON_CLOSE_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_CLOSE_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_CLOSE_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_ADD_24_FIDELITY_ASSET": "plus",
  "CORE_ICON_ADD_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_ADD_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_ADD_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_REMOVE_24_FIDELITY_ASSET": "minus",
  "CORE_ICON_REMOVE_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_REMOVE_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_REMOVE_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_BACK_24_FIDELITY_ASSET": "arrow-left",
  "CORE_ICON_BACK_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_BACK_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_BACK_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_PREVIOUS_24_FIDELITY_ASSET": "arrow-left",
  "CORE_ICON_PREVIOUS_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_PREVIOUS_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_PREVIOUS_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_FORWARD_24_FIDELITY_ASSET": "arrow-right",
  "CORE_ICON_FORWARD_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_FORWARD_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_FORWARD_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_NEXT_24_FIDELITY_ASSET": "arrow-right",
  "CORE_ICON_NEXT_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_NEXT_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_NEXT_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_ASCEND_24_FIDELITY_ASSET": "arrow-up",
  "CORE_ICON_ASCEND_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_ASCEND_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_ASCEND_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_DESCEND_24_FIDELITY_ASSET": "arrow-down",
  "CORE_ICON_DESCEND_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_DESCEND_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_DESCEND_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_MORE_24_FIDELITY_ASSET": "ellipsis",
  "CORE_ICON_MORE_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_MORE_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_MORE_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_MENU_24_FIDELITY_ASSET": "hamburger-lines",
  "CORE_ICON_MENU_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_MENU_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_MENU_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_LOADING_24_FIDELITY_ASSET": "radial-spinner",
  "CORE_ICON_LOADING_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_LOADING_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_LOADING_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_SEARCH_24_FIDELITY_ASSET": "magnifying-glass",
  "CORE_ICON_SEARCH_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_SEARCH_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_SEARCH_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_DRAG_24_FIDELITY_ASSET": "grip-dots-vertical",
  "CORE_ICON_DRAG_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_DRAG_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_DRAG_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_WARN_24_FIDELITY_ASSET": "exclamation-circle",
  "CORE_ICON_WARN_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_WARN_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_WARN_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_WARNING_24_FIDELITY_ASSET": "exclamation-circle",
  "CORE_ICON_WARNING_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_WARNING_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_WARNING_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_SUCCEED_24_FIDELITY_ASSET": "checkmark-circle",
  "CORE_ICON_SUCCEED_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_SUCCEED_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_SUCCEED_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_SUCCESS_24_FIDELITY_ASSET": "checkmark-circle",
  "CORE_ICON_SUCCESS_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_SUCCESS_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_SUCCESS_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_INFORM_24_FIDELITY_ASSET": "i-circle",
  "CORE_ICON_INFORM_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_INFORM_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_INFORM_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_INFO_24_FIDELITY_ASSET": "i-circle",
  "CORE_ICON_INFO_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_INFO_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_INFO_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_DENY_24_FIDELITY_ASSET": "no-entry-circle",
  "CORE_ICON_DENY_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_DENY_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_DENY_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_DENIED_24_FIDELITY_ASSET": "no-entry-circle",
  "CORE_ICON_DENIED_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_DENIED_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_DENIED_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_CANCEL_24_FIDELITY_ASSET": "x-circle",
  "CORE_ICON_CANCEL_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_CANCEL_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_CANCEL_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_CANCELLED_24_FIDELITY_ASSET": "x-circle",
  "CORE_ICON_CANCELLED_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_CANCELLED_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_CANCELLED_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_RECOMMEND_24_FIDELITY_ASSET": "lightning-bolt",
  "CORE_ICON_RECOMMEND_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_RECOMMEND_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_RECOMMEND_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_RECOMMENDATION_24_FIDELITY_ASSET": "lightning-bolt",
  "CORE_ICON_RECOMMENDATION_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_RECOMMENDATION_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_RECOMMENDATION_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_REFRESH_24_FIDELITY_ASSET": "dual-rotating-arrows",
  "CORE_ICON_REFRESH_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_REFRESH_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_REFRESH_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_CYCLE_24_FIDELITY_ASSET": "dual-rotating-arrows",
  "CORE_ICON_CYCLE_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_CYCLE_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_CYCLE_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_DELETE_24_FIDELITY_ASSET": "trashcan",
  "CORE_ICON_DELETE_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_DELETE_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_DELETE_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_CHECKMARK_24_FIDELITY_ASSET": "check",
  "CORE_ICON_CHECKMARK_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_CHECKMARK_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_CHECKMARK_24_FIDELITY_TINTABLE": true,
  "CORE_ICON_HELP_24_FIDELITY_ASSET": "question-mark-circle",
  "CORE_ICON_HELP_24_FIDELITY_WIDTH": 24,
  "CORE_ICON_HELP_24_FIDELITY_HEIGHT": 24,
  "CORE_ICON_HELP_24_FIDELITY_TINTABLE": true,
  "CORE_BASE_SIZE": 8,
  "CORE_TEXT_SIZE": 16,
  "CORE_SPACE_10_SIZE": 8,
  "CORE_METRICS_SPACING_25": 2,
  "CORE_METRICS_SPACING_50": 4,
  "CORE_METRICS_SPACING_100": 8,
  "CORE_METRICS_SPACING_150": 12,
  "CORE_METRICS_SPACING_200": 16,
  "CORE_METRICS_SPACING_300": 24,
  "CORE_METRICS_SPACING_400": 32,
  "CORE_METRICS_SPACING_500": 40,
  "CORE_METRICS_SPACING_600": 48,
  "CORE_METRICS_SPACING_800": 64,
  "CORE_METRICS_SPACING_1000": 80,
  "CORE_METRICS_SPACING_1500": 120,
  "CORE_METRICS_SPACING_2000": 160,
  "CORE_RADIUS_10": 6,
  "CORE_RADIUS_20": 12,
  "CORE_HORIZONTAL_SIZE_CLASS_REGULAR_THRESHOLD": 600,
  "CORE_HORIZONTAL_SIZE_CLASS_WIDE_THRESHOLD": 1200,
  "CORE_VERTICAL_SIZE_CLASS_REGULAR_THRESHOLD": 600,
  "CORE_VERTICAL_SIZE_CLASS_TALL_THRESHOLD": 1200,
  "CORE_SMALL_SIZE_MINIMUM_HEIGHT": 40,
  "CORE_MEDIUM_SIZE_MINIMUM_HEIGHT": 48,
  "CORE_LARGE_SIZE_MINIMUM_HEIGHT": 64,
  "CORE_FOCUS_RING_BUFFER_SIZE": 2,
  "CORE_FOCUS_RING_BORDER_SIZE": 2,
  "CORE_FOCUS_RING_LIGHT_MODE_COLOR": "#006aff",
  "CORE_FOCUS_RING_DARK_MODE_COLOR": "#006aff",
  "CORE_FOCUS_RING_COLOR": "#006aff",
  "CORE_TYPE_DISPLAY_10_SIZE": 32,
  "CORE_TYPE_DISPLAY_10_LEADING": 40,
  "CORE_TYPE_DISPLAY_10_TRACKING": 0,
  "CORE_TYPE_DISPLAY_10_WEIGHT": 700,
  "CORE_TYPE_DISPLAY_10_CASE": "regular",
  "CORE_TYPE_DISPLAY_10_NUMBER_SPACING": "default",
  "CORE_TYPE_DISPLAY_10_SCALE": "heading-30",
  "CORE_TYPE_DISPLAY_10_FONT_FAMILY": "Square Sans Display",
  "CORE_TYPE_DISPLAY_20_SIZE": 48,
  "CORE_TYPE_DISPLAY_20_LEADING": 56,
  "CORE_TYPE_DISPLAY_20_TRACKING": 0,
  "CORE_TYPE_DISPLAY_20_WEIGHT": 500,
  "CORE_TYPE_DISPLAY_20_CASE": "regular",
  "CORE_TYPE_DISPLAY_20_NUMBER_SPACING": "default",
  "CORE_TYPE_DISPLAY_20_SCALE": "heading-30",
  "CORE_TYPE_DISPLAY_20_FONT_FAMILY": "Square Sans Display",
  "CORE_TYPE_DISPLAY_FONT_FAMILY": "Square Sans Display",
  "CORE_TYPE_HEADING_5_SIZE": 12,
  "CORE_TYPE_HEADING_5_LEADING": 20,
  "CORE_TYPE_HEADING_5_TRACKING": 0.05,
  "CORE_TYPE_HEADING_5_WEIGHT": 500,
  "CORE_TYPE_HEADING_5_CASE": "uppercase",
  "CORE_TYPE_HEADING_5_NUMBER_SPACING": "default",
  "CORE_TYPE_HEADING_5_SCALE": "heading-5",
  "CORE_TYPE_HEADING_5_FONT_FAMILY": "Square Sans Text",
  "CORE_TYPE_HEADING_5_IS_HEADER": true,
  "CORE_TYPE_HEADING_10_SIZE": 14,
  "CORE_TYPE_HEADING_10_LEADING": 22,
  "CORE_TYPE_HEADING_10_TRACKING": 0,
  "CORE_TYPE_HEADING_10_WEIGHT": 700,
  "CORE_TYPE_HEADING_10_CASE": "regular",
  "CORE_TYPE_HEADING_10_NUMBER_SPACING": "default",
  "CORE_TYPE_HEADING_10_SCALE": "heading-10",
  "CORE_TYPE_HEADING_10_FONT_FAMILY": "Square Sans Text",
  "CORE_TYPE_HEADING_10_IS_HEADER": true,
  "CORE_TYPE_HEADING_20_SIZE": 19,
  "CORE_TYPE_HEADING_20_LEADING": 26,
  "CORE_TYPE_HEADING_20_TRACKING": 0,
  "CORE_TYPE_HEADING_20_WEIGHT": 700,
  "CORE_TYPE_HEADING_20_CASE": "regular",
  "CORE_TYPE_HEADING_20_NUMBER_SPACING": "default",
  "CORE_TYPE_HEADING_20_SCALE": "heading-20",
  "CORE_TYPE_HEADING_20_FONT_FAMILY": "Square Sans Display",
  "CORE_TYPE_HEADING_20_IS_HEADER": true,
  "CORE_TYPE_HEADING_30_SIZE": 25,
  "CORE_TYPE_HEADING_30_LEADING": 32,
  "CORE_TYPE_HEADING_30_TRACKING": 0,
  "CORE_TYPE_HEADING_30_WEIGHT": 700,
  "CORE_TYPE_HEADING_30_CASE": "regular",
  "CORE_TYPE_HEADING_30_NUMBER_SPACING": "default",
  "CORE_TYPE_HEADING_30_SCALE": "heading-30",
  "CORE_TYPE_HEADING_30_FONT_FAMILY": "Square Sans Display",
  "CORE_TYPE_HEADING_30_IS_HEADER": true,
  "CORE_TYPE_PARAGRAPH_10_SIZE": 12,
  "CORE_TYPE_PARAGRAPH_10_LEADING": 18,
  "CORE_TYPE_PARAGRAPH_10_TRACKING": 0,
  "CORE_TYPE_PARAGRAPH_10_WEIGHT": 400,
  "CORE_TYPE_PARAGRAPH_10_CASE": "regular",
  "CORE_TYPE_PARAGRAPH_10_NUMBER_SPACING": "default",
  "CORE_TYPE_PARAGRAPH_10_SCALE": "paragraph-10",
  "CORE_TYPE_PARAGRAPH_10_FONT_FAMILY": "Square Sans Text",
  "CORE_TYPE_PARAGRAPH_20_SIZE": 14,
  "CORE_TYPE_PARAGRAPH_20_LEADING": 22,
  "CORE_TYPE_PARAGRAPH_20_TRACKING": 0,
  "CORE_TYPE_PARAGRAPH_20_WEIGHT": 400,
  "CORE_TYPE_PARAGRAPH_20_CASE": "regular",
  "CORE_TYPE_PARAGRAPH_20_NUMBER_SPACING": "default",
  "CORE_TYPE_PARAGRAPH_20_SCALE": "paragraph-20",
  "CORE_TYPE_PARAGRAPH_20_FONT_FAMILY": "Square Sans Text",
  "CORE_TYPE_PARAGRAPH_30_SIZE": 16,
  "CORE_TYPE_PARAGRAPH_30_LEADING": 24,
  "CORE_TYPE_PARAGRAPH_30_TRACKING": 0,
  "CORE_TYPE_PARAGRAPH_30_WEIGHT": 400,
  "CORE_TYPE_PARAGRAPH_30_CASE": "regular",
  "CORE_TYPE_PARAGRAPH_30_NUMBER_SPACING": "default",
  "CORE_TYPE_PARAGRAPH_30_SCALE": "paragraph-30",
  "CORE_TYPE_PARAGRAPH_30_FONT_FAMILY": "Square Sans Text",
  "CORE_TYPE_MEDIUM_10_SIZE": 12,
  "CORE_TYPE_MEDIUM_10_LEADING": 18,
  "CORE_TYPE_MEDIUM_10_TRACKING": 0,
  "CORE_TYPE_MEDIUM_10_WEIGHT": 500,
  "CORE_TYPE_MEDIUM_10_CASE": "regular",
  "CORE_TYPE_MEDIUM_10_NUMBER_SPACING": "default",
  "CORE_TYPE_MEDIUM_10_SCALE": "paragraph-10",
  "CORE_TYPE_MEDIUM_10_FONT_FAMILY": "Square Sans Text",
  "CORE_TYPE_MEDIUM_20_SIZE": 14,
  "CORE_TYPE_MEDIUM_20_LEADING": 22,
  "CORE_TYPE_MEDIUM_20_TRACKING": 0,
  "CORE_TYPE_MEDIUM_20_WEIGHT": 500,
  "CORE_TYPE_MEDIUM_20_CASE": "regular",
  "CORE_TYPE_MEDIUM_20_NUMBER_SPACING": "default",
  "CORE_TYPE_MEDIUM_20_SCALE": "paragraph-20",
  "CORE_TYPE_MEDIUM_20_FONT_FAMILY": "Square Sans Text",
  "CORE_TYPE_MEDIUM_30_SIZE": 16,
  "CORE_TYPE_MEDIUM_30_LEADING": 24,
  "CORE_TYPE_MEDIUM_30_TRACKING": 0,
  "CORE_TYPE_MEDIUM_30_WEIGHT": 500,
  "CORE_TYPE_MEDIUM_30_CASE": "regular",
  "CORE_TYPE_MEDIUM_30_NUMBER_SPACING": "default",
  "CORE_TYPE_MEDIUM_30_SCALE": "paragraph-30",
  "CORE_TYPE_MEDIUM_30_FONT_FAMILY": "Square Sans Text",
  "CORE_TYPE_MEDIUM_WEIGHT": 500,
  "CORE_TYPE_SEMIBOLD_10_SIZE": 12,
  "CORE_TYPE_SEMIBOLD_10_LEADING": 18,
  "CORE_TYPE_SEMIBOLD_10_TRACKING": 0,
  "CORE_TYPE_SEMIBOLD_10_WEIGHT": 600,
  "CORE_TYPE_SEMIBOLD_10_CASE": "regular",
  "CORE_TYPE_SEMIBOLD_10_NUMBER_SPACING": "default",
  "CORE_TYPE_SEMIBOLD_10_SCALE": "paragraph-10",
  "CORE_TYPE_SEMIBOLD_10_FONT_FAMILY": "Square Sans Text",
  "CORE_TYPE_SEMIBOLD_20_SIZE": 14,
  "CORE_TYPE_SEMIBOLD_20_LEADING": 22,
  "CORE_TYPE_SEMIBOLD_20_TRACKING": 0,
  "CORE_TYPE_SEMIBOLD_20_WEIGHT": 600,
  "CORE_TYPE_SEMIBOLD_20_CASE": "regular",
  "CORE_TYPE_SEMIBOLD_20_NUMBER_SPACING": "default",
  "CORE_TYPE_SEMIBOLD_20_SCALE": "paragraph-20",
  "CORE_TYPE_SEMIBOLD_20_FONT_FAMILY": "Square Sans Text",
  "CORE_TYPE_SEMIBOLD_30_SIZE": 16,
  "CORE_TYPE_SEMIBOLD_30_LEADING": 24,
  "CORE_TYPE_SEMIBOLD_30_TRACKING": 0,
  "CORE_TYPE_SEMIBOLD_30_WEIGHT": 600,
  "CORE_TYPE_SEMIBOLD_30_CASE": "regular",
  "CORE_TYPE_SEMIBOLD_30_NUMBER_SPACING": "default",
  "CORE_TYPE_SEMIBOLD_30_SCALE": "paragraph-30",
  "CORE_TYPE_SEMIBOLD_30_FONT_FAMILY": "Square Sans Text",
  "CORE_TYPE_SEMIBOLD_WEIGHT": 600,
  "CORE_TYPE_REGULAR_WEIGHT": 400,
  "CORE_TYPE_BOLD_WEIGHT": 700,
  "CORE_TYPE_FONT_FAMILY": "Square Sans Text"
};

export { tokens_module as t };
